
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bbYj5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $29vMs = parcelRequire("29vMs");





var $7Xbdy = parcelRequire("7Xbdy");


var $6mKj3 = parcelRequire("6mKj3");


var $jECFp = parcelRequire("jECFp");

const $4f3a8dba1da971e8$export$c608cc623d373c2b = ({ contentId: contentId, title: title, isTitleGenerating: isTitleGenerating, locale: locale, pageAlreadyHasEmoji: pageAlreadyHasEmoji, onSuggestTitleClickedRef: onSuggestTitleClickedRef })=>{
    const { suggestEmoji: suggestEmojiFromPasteTitle, reset: resetEmojiSuggestionHook } = (0, $7Xbdy.useAIPageEmojiSuggestion)({
        contentId: contentId
    });
    const { setAISuggestedEmojiId: setAISuggestedEmojiId, setAifcSuggestionInFlight: setAifcSuggestionInFlight, resetForNewSession: resetForNewSession } = (0, $jECFp.useAIEmojiSuggestionActions)();
    const isPasteEmojiSuggestionEnabled = (0, $6mKj3.isExperimentEnabled)('confluence_ai_title_generation_on_paste_standard') && (0, $6mKj3.isExperimentEnabled)('confluence_suggested_emojis_for_title_generation');
    const lastTriggerSourceRef = (0, $cozmU.useRef)('pasteAutoTitle');
    const onSuggestTitleClicked = (0, $cozmU.useCallback)(()=>{
        lastTriggerSourceRef.current = 'suggestTitle';
    }, []);
    onSuggestTitleClickedRef.current = isPasteEmojiSuggestionEnabled ? onSuggestTitleClicked : undefined;
    const wasTitleGeneratingRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!isPasteEmojiSuggestionEnabled) {
            wasTitleGeneratingRef.current = isTitleGenerating ?? false;
            return;
        }
        const generating = isTitleGenerating ?? false;
        const justStarted = !wasTitleGeneratingRef.current && generating;
        const justFinished = wasTitleGeneratingRef.current && !generating;
        wasTitleGeneratingRef.current = generating;
        if (justStarted) {
            resetForNewSession(lastTriggerSourceRef.current);
            lastTriggerSourceRef.current = 'pasteAutoTitle';
            resetEmojiSuggestionHook?.();
            return;
        }
        if (!justFinished) return;
        const finalTitle = (title ?? '').trim();
        if (!finalTitle) return;
        if (pageAlreadyHasEmoji) return;
        setAifcSuggestionInFlight(true);
        suggestEmojiFromPasteTitle({
            title: finalTitle,
            locale: locale
        }).then((emojiId)=>{
            if (!emojiId) return;
            setAISuggestedEmojiId(emojiId);
        }).catch(()=>{
        // Swallow — the upstream useAIPageEmojiSuggestion hook owns its
        // own error telemetry. The .finally below still clears the
        // in-flight flag so the UI does not stay stuck.
        }).finally(()=>{
            // Always clear in-flight state, even on rejection, so
            // aifcSuggestionInFlight does not stay true for the session.
            setAifcSuggestionInFlight(false);
        });
    }, [
        isTitleGenerating,
        isPasteEmojiSuggestionEnabled,
        title,
        locale,
        suggestEmojiFromPasteTitle,
        resetEmojiSuggestionHook,
        pageAlreadyHasEmoji,
        setAISuggestedEmojiId,
        setAifcSuggestionInFlight,
        resetForNewSession
    ]);
    return null;
};



var $ktUCG = parcelRequire("ktUCG");


var $fTmNK = parcelRequire("fTmNK");


var $gqqjz = parcelRequire("gqqjz");


var $7QM6o = parcelRequire("7QM6o");


var $jVylI = parcelRequire("jVylI");


var $aV3a0 = parcelRequire("aV3a0");


var $i5zxs = parcelRequire("i5zxs");


var $bSMD1 = parcelRequire("bSMD1");








var $9DHhW = parcelRequire("9DHhW");


var $b9k8w = parcelRequire("b9k8w");


var $8Iwqw = parcelRequire("8Iwqw");


var $8lt1a = parcelRequire("8lt1a");


var $kXsBa = parcelRequire("kXsBa");


var $LSims = parcelRequire("LSims");


var $l1uFv = parcelRequire("l1uFv");





var $aJUpe = parcelRequire("aJUpe");


var $4Pmcr = parcelRequire("4Pmcr");

const $b3ec081dc8208a8f$export$872bd9efb95d9be5 = (contentId)=>{
    if (!contentId || !(0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true)) return false;
    try {
        const cached = (0, $l1uFv.readQueryInterop)({
            query: (0, $aJUpe.default),
            variables: {
                contentId: contentId,
                isMarkdownModeEnabled: true
            },
            __callerPackage__: "content-markdown-mode"
        });
        return (0, $4Pmcr.getIsMarkdownModeFromData)(cached);
    } catch  {
        // Cache miss (query never ran for this contentId) — treat as not in markdown mode.
        return false;
    }
};



var $bJrpn = parcelRequire("bJrpn");


var $1B6Lx = parcelRequire("1B6Lx");





var $aK0Eq = parcelRequire("aK0Eq");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $dPJCf = parcelRequire("dPJCf");


var $cb6fO = parcelRequire("cb6fO");


var $9wGTI = parcelRequire("9wGTI");





var $1NBp8 = parcelRequire("1NBp8");


var $bQm3c = parcelRequire("bQm3c");


var $kSPGK = parcelRequire("kSPGK");


var $jhwJP = parcelRequire("jhwJP");


var $4tOXV = parcelRequire("4tOXV");


var $kycWk = parcelRequire("kycWk");

var $iuuqT = parcelRequire("iuuqT");

var $2MwVI = parcelRequire("2MwVI");


var $iOaib = parcelRequire("iOaib");








var $kz1Yj = parcelRequire("kz1Yj");





var $dTHYM = parcelRequire("dTHYM");


var $dUI0h = parcelRequire("dUI0h");


var $24dy7 = parcelRequire("24dy7");


var $3oEyF = parcelRequire("3oEyF");











var $8m9SI = parcelRequire("8m9SI");


var $i0AJ7 = parcelRequire("i0AJ7");

const $82b9586b69ae689f$var$titleStyles = (0, $buxP3.xcss)({
    width: '100%'
});
const $82b9586b69ae689f$var$errorIconStyles = (0, $buxP3.xcss)({
    flexShrink: 0,
    margin: 'space.050',
    marginBottom: 'space.0'
});
const $82b9586b69ae689f$var$fieldStyles = (0, $buxP3.xcss)({
    // This removes the default top margin that comes with the atlas Field component.
    marginTop: 'space.negative.100'
});
const $82b9586b69ae689f$export$46314a318e0df6ce = ({ title: title, isDisabled: isDisabled, viewMode: viewMode, isTitleCenterAligned: isTitleCenterAligned, isUserEditing: isUserEditing, isTitleAIGenerated: isTitleAIGenerated, updateError: updateError, updateLoading: updateLoading, handleBlur: handleBlur, handleFocus: handleFocus, handleChange: handleChange, handleKeyDown: handleKeyDown, getIsInvalidTitle: getIsInvalidTitle, buildErrorMessage: buildErrorMessage, textAreaRef: textAreaRef, formatMessage: formatMessage, i18n: i18n, AI_SUGGEST_TITLE_PROPS: AI_SUGGEST_TITLE_PROPS, maxLength: maxLength, isCssAutoSizingSupported: isCssAutoSizingSupported, isDisabledTextBlack: isDisabledTextBlack, customPlaceholder: customPlaceholder, isMarkdownMode: isMarkdownMode, displayValueOverride: displayValueOverride })=>{
    // Render an immutable `.md` suffix when in markdown mode and the user is not editing the title.
    // The suffix is purely visual: `fieldProps.value` is left untouched, so saved title state never includes it.
    // Skip the append when the raw value already ends with `.md` (trim-tolerant); literal `.md` titles should not become `.md.md`.
    const [isTextAreaFocused, setIsTextAreaFocused] = (0, $cozmU.useState)(false);
    const getDisplayValue = (rawValue)=>{
        const valueToDisplay = displayValueOverride ?? rawValue;
        return isMarkdownMode && !isTextAreaFocused && valueToDisplay.length > 0 && !(0, $iOaib.endsWithMarkdownSuffix)(valueToDisplay) ? `${valueToDisplay}${0, $iOaib.MARKDOWN_SUFFIX}` : valueToDisplay;
    };
    // If the browser supports it, we use a textarea that auto resizes using CSS so we don't need to adjust the height in JS.
    // This is better for performance as it avoids reflows and layout shifts.
    const TextAreaComponent = isCssAutoSizingSupported ? (0, $8m9SI.EditorTitleTextAreaNext) : (0, $8m9SI.EditorTitleTextArea);
    const TextAreaComponentToUse = isTitleAIGenerated ? (0, $8m9SI.AIGeneratedEditorTitleTextArea) : TextAreaComponent;
    const placeholder = customPlaceholder ?? formatMessage(i18n.placeholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $82b9586b69ae689f$var$titleStyles
    }, (0, $9wGTI.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: ()=>{}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $82b9586b69ae689f$var$fieldStyles,
        id: "content-title-id"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "livepages-title",
        defaultValue: title
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3oEyF.default), {
            isOpen: !isDisabled && !!(fieldProps.isInvalid || !updateLoading && updateError && !isUserEditing || getIsInvalidTitle(fieldProps?.value)),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
                space: "space.025",
                alignBlock: "start"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $82b9586b69ae689f$var$errorIconStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                label: "error",
                spacing: "none",
                color: "var(--ds-icon-danger, #C9372C)"
            })), buildErrorMessage(fieldProps, error)),
            placement: isTitleCenterAligned ? 'bottom' : 'bottom-start',
            strategy: "absolute"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i0AJ7.EditorTitleContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(TextAreaComponentToUse, {
            ...fieldProps,
            ...AI_SUGGEST_TITLE_PROPS,
            value: getDisplayValue(fieldProps.value),
            "data-testid": `editor-title-text-area${isCssAutoSizingSupported ? '-css-auto-sizing' : ''}`,
            minimumRows: 1,
            rows: 1,
            ...(0, $6mKj3.expValEquals)('a11y-fixes-week2-may-2026', 'isEnabled', true) ? {
                role: 'heading',
                'aria-level': 1
            } : {},
            isTitleCenterAligned: isTitleCenterAligned,
            isTitleAIGenerated: isTitleAIGenerated,
            isInvalid: error,
            disabled: isDisabled,
            readOnly: viewMode,
            "aria-readonly": viewMode,
            "aria-disabled": isDisabled,
            ref: textAreaRef,
            maxLength: maxLength,
            "aria-label": placeholder,
            placeholder: placeholder,
            shouldAnimate: false,
            autoComplete: "off",
            resize: "vertical",
            onChange: (e)=>handleChange(e, fieldProps),
            onFocus: ()=>{
                setIsTextAreaFocused(true);
                handleFocus();
            },
            onBlur: (e)=>{
                setIsTextAreaFocused(false);
                handleBlur(e, fieldProps);
            },
            onKeyDown: handleKeyDown,
            isDisabledTextBlack: isDisabledTextBlack
        }))))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: ()=>{}
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $82b9586b69ae689f$var$fieldStyles,
            id: "content-title-id"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "livepages-title",
            defaultValue: title
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3oEyF.default), {
                isOpen: !isDisabled && !!(fieldProps.isInvalid || !updateLoading && updateError && !isUserEditing || getIsInvalidTitle(fieldProps?.value)),
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
                    space: "space.025",
                    alignBlock: "start"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                    xcss: $82b9586b69ae689f$var$errorIconStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                    label: "error",
                    spacing: "none",
                    color: "var(--ds-icon-danger, #C9372C)"
                })), buildErrorMessage(fieldProps, error)),
                placement: isTitleCenterAligned ? 'bottom' : 'bottom-start',
                strategy: "absolute"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i0AJ7.EditorTitleContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(TextAreaComponentToUse, {
                ...fieldProps,
                ...AI_SUGGEST_TITLE_PROPS,
                value: getDisplayValue(fieldProps.value),
                "data-testid": `editor-title-text-area${isCssAutoSizingSupported ? '-css-auto-sizing' : ''}`,
                minimumRows: 1,
                rows: 1,
                ...(0, $6mKj3.expValEquals)('a11y-fixes-week2-may-2026', 'isEnabled', true) ? {
                    role: 'heading',
                    'aria-level': 1
                } : {},
                isTitleCenterAligned: isTitleCenterAligned,
                isTitleAIGenerated: isTitleAIGenerated,
                isInvalid: error,
                disabled: isDisabled,
                readOnly: viewMode,
                "aria-readonly": viewMode,
                "aria-disabled": isDisabled,
                ref: textAreaRef,
                maxLength: maxLength,
                "aria-label": placeholder,
                placeholder: placeholder,
                shouldAnimate: false,
                autoComplete: "off",
                resize: "vertical",
                onChange: (e)=>handleChange(e, fieldProps),
                onFocus: ()=>{
                    setIsTextAreaFocused(true);
                    handleFocus();
                },
                onBlur: (e)=>{
                    setIsTextAreaFocused(false);
                    handleBlur(e, fieldProps);
                },
                onKeyDown: handleKeyDown,
                isDisabledTextBlack: isDisabledTextBlack
            })))))))));
};



var $fazoG = parcelRequire("fazoG");





var $idaAv = parcelRequire("idaAv");


var $2SWmG = parcelRequire("2SWmG");

const $c2dc750c82b079e2$var$i18nBase = (0, $kSwu1.defineMessages)({
    placeholder: {
        id: "editor-title.live-pages-title.placeholder",
        defaultMessage: "Give this page a title"
    },
    duplicateTitleError: {
        id: "editor-title.live-pages-title.duplicate-title-error",
        defaultMessage: "There\u2019s already content named \u201C{pageTitle}\u201D in this space. Give this page a unique title."
    },
    invalidTitleError: {
        id: "editor-title.live-pages-title.empty-title-error",
        defaultMessage: "Give your page a unique title so you can find it easily later"
    },
    generalError: {
        id: "editor-title.live-pages-title.general-error",
        defaultMessage: "An error occurred on our end. Refresh and try again."
    },
    aiGeneratedTitleDismissButton: {
        id: "editor-title.ai.title.error.dismiss",
        defaultMessage: "Dismiss"
    },
    aiGeneratedTitleFromPaste: {
        id: "editor-title.flags.generate.ai.from.paste.title",
        defaultMessage: "AI generated a title for this page"
    },
    aiGeneratedTitleFromPasteDescription: {
        id: "editor-title.flags.generate.ai.from.paste.description",
        defaultMessage: "Rovo generated a title for this page using the content pasted into the editor. <Link>Content quality may vary.</Link>"
    }
});
const $c2dc750c82b079e2$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    placeholder: {
        id: "editor-title.live-pages-title.placeholder.livedocs",
        defaultMessage: "Give this live doc a title "
    },
    duplicateTitleError: {
        id: "editor-title.live-pages-title.duplicate-title-error.livedocs",
        defaultMessage: "There\u2019s already content named \u201C{pageTitle}\u201D in this space. Give this doc a unique title. "
    },
    invalidTitleError: {
        id: "editor-title.live-pages-title.empty-title-error.livedocs",
        defaultMessage: "Give your live doc a unique title so you can find it easily later "
    }
});
const $c2dc750c82b079e2$var$i18n = (0, $jhwJP.mergeLiveDocI18n)($c2dc750c82b079e2$var$i18nBase, $c2dc750c82b079e2$var$i18nLiveDocs);
const $c2dc750c82b079e2$export$919d652062589a50 = ({ title: title, contentId: contentId, userOffline: userOffline, isDisabled: isDisabled, isEditorEmpty: isEditorEmpty, focusEditor: focusEditor, onFocusChanged: onFocusChanged, onTitleBlur: onTitleBlur, viewMode: viewMode, isTitleCenterAligned: isTitleCenterAligned, version: version = 1, editorApi: editorApi, editorSessionId: editorSessionId, isSeamlessTransitionInProgress: isSeamlessTransitionInProgress = false, customPlaceholder: customPlaceholder, flags: flags, editorActions: editorActions, onTitleGeneratingChange: onTitleGeneratingChange })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { formatMessage: formatMessage } = intl;
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const textAreaRef = (0, $cozmU.useRef)(null);
    const hasEditEventFiredRef = (0, $cozmU.useRef)(false);
    const { updateError: updateError, updateTitle: updateTitle, updateTitleAndWait: updateTitleAndWait, updateLoading: updateLoading } = (0, $kXsBa.useContentTypesTitleUpdate)(contentId, title);
    // Component only renders for live pages by design, so no per-content-type guard needed.
    const isMarkdownMode = (0, $LSims.useIsMarkdownMode)(contentId);
    // Wire the title → markdown-mode-convert gesture: when the user appends
    // `.md` to a non-markdown-mode title and blurs, we treat that as a
    // shortcut for “Convert to markdown”. Dialog state is shared via the
    // sweet-state store inside `useMarkdownModeActions`, so the dialog
    // rendered by `MoreActions` opens for this gesture too. When
    // `editorActions` isn’t available we still call the hook (it tolerates
    // the empty placeholder) but the gesture itself is gated by it being
    // the real instance — see the blur handler.
    const { convertToMarkdown: convertToMarkdown, convertDialogState: convertDialogState } = (0, $bJrpn.useMarkdownModeActions)({
        contentId: contentId,
        isLivePage: true,
        editorActions: editorActions ?? {
            isDocumentEmpty: ()=>false
        },
        flags: flags ?? {
            showErrorFlag: ()=>{}
        }
    });
    const isConvertDialogOpenForMarkdown = convertDialogState.isOpen && convertDialogState.direction === 'toMarkdown';
    const updateTimestampCache = (0, $1B6Lx.useUpdateLastEditedTimestampVersionCache)();
    const { setOptimisticTitle: setOptimisticTitle } = (0, $kSPGK.useOptimisticTitleChange)(contentId, title);
    const [isUserEditing, setUserIsEditing] = (0, $cozmU.useState)(false);
    const [pendingMdDisplayValue, setPendingMdDisplayValue] = (0, $cozmU.useState)(null);
    const hasActivatedBoeFocusRef = (0, $cozmU.useRef)(false);
    // Check if title has changed from the current prop value, gated by experiment
    // The title prop only updates after submission, so it represents the last saved value
    const hasTitleChanged = (0, $cozmU.useCallback)((value)=>{
        if ((0, $6mKj3.expValEquals)('confluence_live_pages_title_update_diffing', 'isEnabled', true)) return value !== title;
        return true;
    }, [
        title
    ]);
    const isCSSAutoSizingSupported = (0, $idaAv.isFieldSizingSupported)();
    const undoRedoManagerRef = (0, $cozmU.useRef)(null);
    const isUndoRedoActionRef = (0, $cozmU.useRef)(false);
    const pendingMdRawValueRef = (0, $cozmU.useRef)(null);
    const pendingMdFieldOnChangeRef = (0, $cozmU.useRef)(null);
    const pendingMdTextAreaRef = (0, $cozmU.useRef)(null);
    const prevConvertDialogOpenRef = (0, $cozmU.useRef)(false);
    if ((0, $9wGTI.fg)('platform_editor_ai_aifc_patch_ga_blockers')) {
        if (undoRedoManagerRef.current === null) undoRedoManagerRef.current = new (0, $2SWmG.UndoRedoManager)();
    }
    const undoRedoManager = undoRedoManagerRef.current;
    const { replace: replace } = (0, $dPJCf.useRouteActions)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { isHideTitleInUrl: isHideTitleInUrl } = (0, $bQm3c.useSessionData)();
    const redirectToHideTitleSlug = isHideTitleInUrl && (0, $6mKj3.expValEquals)('confluence_hide_content_title_in_url', 'isEnabled', true);
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(window.__SSR_RENDERED__);
    (0, $2MwVI.useTrackTitleRedactionRendered)({
        contentId: contentId,
        title: title
    });
    const { activeSpotlight: activeSpotlight } = (0, $iuuqT.useRedactionsTour)({
        contentId: contentId,
        step: (0, $kycWk.RedactionsTourSteps).FIRST,
        firstStepSource: (0, $iuuqT.RedactionTourStepSource).titleRedaction
    });
    const onTitleUpdate = (0, $cozmU.useCallback)(async (value)=>{
        setOptimisticTitle(value);
        // We don't want to update the title if the field is blank, otherwise it will update to a default title
        // Also skip if title hasn't actually changed from the last saved value (gated by experiment)
        if (getIsTitleEmpty(value) || !hasTitleChanged(value)) return;
        await updateTitle(value);
        if (undoRedoManager && (0, $9wGTI.fg)('platform_editor_ai_aifc_patch_ga_blockers')) undoRedoManager.addToUndoStack(value);
        // Update timestamp cache so that Last Edited in object header responsively updates
        updateTimestampCache({
            contentId: contentId
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'updated',
                actionSubject: 'title',
                source: 'editorTitle',
                attributes: {
                    isLivePage: true
                },
                objectId: contentId,
                objectType: 'page',
                containerType: 'space',
                containerId: spaceId
            }
        }).fire();
        // We want to fire this event only once to indicate the editor has been edited; the first event measures all title updates.
        if (!hasEditEventFiredRef.current) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: 'editorTitle',
                    action: 'edited',
                    actionSubject: 'editor',
                    objectId: contentId,
                    objectType: 'page',
                    attributes: {
                        isLivePage: true,
                        editorSessionId: editorSessionId
                    },
                    containerType: 'space',
                    containerId: spaceId
                }
            }).fire();
            // Mark the event as fired
            hasEditEventFiredRef.current = true;
        }
    }, [
        contentId,
        createAnalyticsEvent,
        hasTitleChanged,
        spaceId,
        updateTitle,
        setOptimisticTitle,
        updateTimestampCache,
        editorSessionId,
        undoRedoManager
    ]);
    const saveTitleForMarkdownConvert = (0, $cozmU.useCallback)(async (value)=>{
        setOptimisticTitle(value);
        if (getIsTitleEmpty(value)) return false;
        if (!hasTitleChanged(value)) return true;
        const success = await updateTitleAndWait(value);
        if (!success) return false;
        if (undoRedoManager && (0, $9wGTI.fg)('platform_editor_ai_aifc_patch_ga_blockers')) undoRedoManager.addToUndoStack(value);
        // Update timestamp cache so that Last Edited in object header responsively updates
        updateTimestampCache({
            contentId: contentId
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'updated',
                actionSubject: 'title',
                source: 'editorTitle',
                attributes: {
                    isLivePage: true
                },
                objectId: contentId,
                objectType: 'page',
                containerType: 'space',
                containerId: spaceId
            }
        }).fire();
        // We want to fire this event only once to indicate the editor has been edited; the first event measures all title updates.
        if (!hasEditEventFiredRef.current) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: 'editorTitle',
                    action: 'edited',
                    actionSubject: 'editor',
                    objectId: contentId,
                    objectType: 'page',
                    attributes: {
                        isLivePage: true,
                        editorSessionId: editorSessionId
                    },
                    containerType: 'space',
                    containerId: spaceId
                }
            }).fire();
            // Mark the event as fired
            hasEditEventFiredRef.current = true;
        }
        return true;
    }, [
        contentId,
        createAnalyticsEvent,
        hasTitleChanged,
        spaceId,
        updateTitleAndWait,
        setOptimisticTitle,
        updateTimestampCache,
        editorSessionId,
        undoRedoManager
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (prevConvertDialogOpenRef.current && !isConvertDialogOpenForMarkdown) {
            // Dialog closed: read markdown mode from cache instead of the reactive
            // hook state so confirm vs cancel is decided from the mutation result,
            // not from a later render. While the dialog is open we keep the raw
            // `….md` visible via `pendingMdDisplayValue`; only cancel strips it from
            // the actual field value.
            const modeFromCache = (0, $b3ec081dc8208a8f$export$872bd9efb95d9be5)(contentId);
            if (!modeFromCache && pendingMdRawValueRef.current !== null && pendingMdTextAreaRef.current === textAreaRef.current) pendingMdFieldOnChangeRef.current?.((0, $iOaib.stripMarkdownSuffix)(pendingMdRawValueRef.current));
            setPendingMdDisplayValue(null);
            pendingMdRawValueRef.current = null;
            pendingMdFieldOnChangeRef.current = null;
            pendingMdTextAreaRef.current = null;
        }
        prevConvertDialogOpenRef.current = isConvertDialogOpenForMarkdown;
    }, [
        isConvertDialogOpenForMarkdown,
        contentId,
        textAreaRef
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!routeDataRef.current || routeDataRef.current.routeName !== (0, $1NBp8.VIEW_PAGE).name) return;
        const currentSlug = routeDataRef.current.routeParams?.contentSlug;
        const targetSlug = redirectToHideTitleSlug ? undefined : (0, $cb6fO.generateSlug)(title);
        const urlSlugNeedsUpdate = redirectToHideTitleSlug // if the title slug needs to be hidden in the URL
         ? Boolean(currentSlug) // we need to update if there currently is any title slug in the URL
         : Boolean(targetSlug) && targetSlug !== currentSlug; // else, we need to update only if page title is different from current title slug in the URL
        if (!urlSlugNeedsUpdate) return;
        // Construct the new URL with the updated slug and existing query params and any hash that was present
        const newUrl = (0, $1NBp8.VIEW_PAGE).toUrl({
            ...routeDataRef.current.routeParams,
            contentSlug: targetSlug
        }, {
            query: {
                ...routeDataRef.current.queryParams || {}
            },
            // When hiding title from the address bar URL, also strip heading anchor hashes to avoid exposing UGC in the address bar.
            hash: redirectToHideTitleSlug ? undefined : routeDataRef.current.hash
        });
        replace(`${newUrl}`, false);
    }, [
        title,
        replace,
        routeDataRef,
        redirectToHideTitleSlug
    ]);
    const adjustTextAreaHeight = (0, $cozmU.useCallback)((textAreaRef)=>{
        // Skip height adjustment if browser supports field sizing.
        // We only need to adjust the height manually in javascript if it can't be done in the native CSS way.
        if (isCSSAutoSizingSupported) return;
        const textArea = textAreaRef.current;
        if (textArea) {
            // Reset the height in case the new content is smaller than the old content
            textArea.style.height = 'auto';
            // Set the height to match the scroll height, which is the total height of the content
            textArea.style.height = `${textArea.scrollHeight}px`;
        }
    }, [
        isCSSAutoSizingSupported
    ]);
    const undoAIGeneratedTitle = (0, $cozmU.useCallback)(()=>{
        const currentTitle = title || '';
        if (!undoRedoManager) return;
        const previousState = undoRedoManager.undo(currentTitle);
        if (currentTitle === previousState) return;
        isUndoRedoActionRef.current = true;
        onTitleUpdate(previousState);
    }, [
        title,
        onTitleUpdate,
        undoRedoManager
    ]);
    const redoAIGeneratedTitle = (0, $cozmU.useCallback)(()=>{
        const currentTitle = title || '';
        if (!undoRedoManager) return;
        const nextState = undoRedoManager.redo(currentTitle);
        if (currentTitle === nextState) return;
        isUndoRedoActionRef.current = true;
        onTitleUpdate(nextState);
    }, [
        title,
        onTitleUpdate,
        undoRedoManager
    ]);
    const getMarkdownConvertValue = (0, $cozmU.useCallback)((rawValue)=>{
        const hasRealEditorActions = !!editorActions && 'getValue' in editorActions;
        const strippedValue = (0, $iOaib.stripMarkdownSuffix)(rawValue);
        if ((0, $iOaib.endsWithMarkdownSuffix)(rawValue) && !(0, $iOaib.endsWithMarkdownSuffix)(title) && strippedValue.trim().length > 0 && !isMarkdownMode && hasRealEditorActions && (0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true)) return strippedValue;
        return null;
    }, [
        editorActions,
        isMarkdownMode,
        title
    ]);
    const handleKeyDown = (event)=>{
        // If the user is composing characters using, e.g., the Hiragana - Kana keyboard,
        // short circuit the code to prevent the bug in Chrome where the selected text
        // gets copied into the editor body.
        if (event.nativeEvent.isComposing) return;
        if (undoRedoManager && (0, $9wGTI.fg)('platform_editor_ai_aifc_patch_ga_blockers')) {
            const isUndoShortcut = event.key === 'z' && ((0, $4tOXV.isMac)() ? event.metaKey : event.ctrlKey) && !event.shiftKey;
            const isRedoShortcut = event.key === 'z' && event.metaKey && event.shiftKey;
            if (isUndoShortcut && undoRedoManager.canUndo()) {
                event.preventDefault();
                event.stopPropagation();
                undoAIGeneratedTitle();
                return;
            }
            if (isRedoShortcut && undoRedoManager.canRedo()) {
                event.preventDefault();
                event.stopPropagation();
                redoAIGeneratedTitle();
                return;
            }
        }
        const isTabPressed = event.key === (0, $aK0Eq.KeyboardEventKeys).TAB.key && !event.shiftKey;
        // If enter is pressed without publish keyboard shortcut prompt key, prevent default and insert newline in editor body
        const promptKeyForPublishShortcut = (0, $4tOXV.isMac)() ? event.metaKey : event.ctrlKey;
        const isEnterPressed = event.key === (0, $aK0Eq.KeyboardEventKeys).ENTER.key;
        const isPublishShortcut = isEnterPressed && promptKeyForPublishShortcut;
        const shouldTriggerMarkdownConvertOnEnter = isEnterPressed && !isPublishShortcut && getMarkdownConvertValue(event.currentTarget.value) !== null;
        if (shouldTriggerMarkdownConvertOnEnter) {
            event.preventDefault();
            event.stopPropagation();
            event.currentTarget.blur();
            return;
        }
        const isDownArrowPressed = event.key === (0, $aK0Eq.KeyboardEventKeys).DOWN.key;
        if (isTabPressed || isEnterPressed || isDownArrowPressed) {
            event.preventDefault();
            // If the publish keyboard shortcut is pressed, still process it
            if (!isPublishShortcut) event.stopPropagation();
            if (isPublishShortcut || !focusEditor) {
                // if we don't have focusEditor prop or if we're using the publish shortcut, we should call onTitleUpdate
                onTitleUpdate(event.currentTarget.value);
                setUserIsEditing(false);
            } else if (focusEditor) {
                if (isEnterPressed) editorApi?.core?.actions.execute(editorApi?.pageTitleUtils?.commands?.insertNewLineAtDocStart());
                if (isTabPressed || isDownArrowPressed) editorApi?.core?.actions.execute(editorApi?.pageTitleUtils?.commands?.selectDocStart());
                // if we trigger focusEditor, it will blur the title field.
                // The title is saved on blur, calling onTitleUpdate is avoided here to prevent double trigger.
                focusEditor();
            }
        }
    };
    const handleFocus = ()=>onFocusChanged?.(true);
    const handleBlur = async (e, fieldProps)=>{
        const rawValue = e.target.value;
        // `.md` suffix gesture: user typed `.md` at the end of the title to
        // shortcut into markdown mode. Strip the suffix from what we save
        // (markdown-mode re-renders it as a visual suffix) then trigger the
        // same convert flow as the menu item — which opens the lossy
        // confirmation dialog when needed.
        //
        // Guards:
        //  - case-sensitive `.md` only,
        //  - previous saved title must NOT already end with `.md` (so we
        //    only fire when the suffix was *appended* this edit),
        //  - skip when already in markdown mode (no-op),
        //  - skip when stripped title is empty / whitespace-only,
        //  - skip without a real editorActions — lossy detection needs the
        //    doc and a no-op placeholder would silently misclassify as
        //    non-lossy and flip the flag without confirmation,
        //  - gated behind the `cc-markdown-mode` experiment.
        // Trim-tolerant: `Hello.md ` (trailing whitespace) also triggers the gesture.
        const strippedValue = getMarkdownConvertValue(rawValue);
        const shouldTriggerMarkdownConvert = strippedValue !== null;
        const valueToSave = strippedValue ?? rawValue;
        if (shouldTriggerMarkdownConvert) {
            pendingMdRawValueRef.current = rawValue;
            pendingMdFieldOnChangeRef.current = fieldProps.onChange;
            pendingMdTextAreaRef.current = e.currentTarget;
            setPendingMdDisplayValue(rawValue);
        }
        onTitleBlur?.(valueToSave);
        onFocusChanged?.(false);
        setUserIsEditing(false);
        if (shouldTriggerMarkdownConvert) {
            const didUpdateTitle = await saveTitleForMarkdownConvert(valueToSave);
            if (didUpdateTitle) convertToMarkdown();
            else {
                setPendingMdDisplayValue(null);
                pendingMdRawValueRef.current = null;
                pendingMdFieldOnChangeRef.current = null;
                pendingMdTextAreaRef.current = null;
            }
            return;
        }
        onTitleUpdate(valueToSave);
    };
    const handleChange = (e, fieldProps)=>{
        fieldProps.onChange(e);
        adjustTextAreaHeight(textAreaRef);
        setUserIsEditing(true);
    };
    (0, $cozmU.useEffect)(()=>{
        // To address a timing issue where the height adjustment was occurring before the new title was rendered,
        // a delay  was implemented. Ensures the new title is fully rendered before the text area height is adjusted
        const timeoutId = setTimeout(()=>{
            adjustTextAreaHeight(textAreaRef);
        }, 0);
        return ()=>clearTimeout(timeoutId);
    }, [
        title,
        adjustTextAreaHeight,
        textAreaRef
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        adjustTextAreaHeight(textAreaRef);
    }, [
        adjustTextAreaHeight,
        textAreaRef
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isDisabled || viewMode || version !== 1 || !getIsTitleEmpty(title) || !textAreaRef.current) return;
        if (hasActivatedBoeFocusRef.current) return;
        if (isEditorEmpty && ((0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant1') || (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant2'))) {
            hasActivatedBoeFocusRef.current = true;
            focusEditor?.();
            return;
        }
        textAreaRef.current.focus();
    }, [
        isDisabled,
        isEditorEmpty,
        title,
        version,
        viewMode,
        textAreaRef,
        focusEditor
    ]);
    const mountedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $9wGTI.fg)('platform_editor_ai_aifc_patch_ga_blockers')) {
            if (textAreaRef.current && mountedRef.current && isUndoRedoActionRef.current) {
                textAreaRef.current.focus();
                isUndoRedoActionRef.current = false;
            }
            mountedRef.current = true;
        }
    }, [
        title
    ]);
    // Used in onTitleUpdate for checking whether title update should be send to backend
    const getIsTitleEmpty = (title)=>!title || title.trim().length === 0;
    // Title is invalid when:
    // 1. Verion is not 1 and it's empty (title was updated to be empty) OR
    // 2. It only contains empty space or tabs
    const getIsInvalidTitle = (title)=>{
        return !!(version !== 1 && !title || title && title.trim().length === 0);
    };
    const buildErrorMessage = (fieldProps, error)=>{
        const updateErrorMessage = updateError?.message.toLowerCase();
        if (fieldProps.isInvalid) return error;
        else if (getIsInvalidTitle(fieldProps?.value)) return formatMessage($c2dc750c82b079e2$var$i18n.invalidTitleError);
        else if (updateErrorMessage?.includes('exists with the same title in this space')) return formatMessage($c2dc750c82b079e2$var$i18n.duplicateTitleError, {
            pageTitle: fieldProps?.value
        });
        else return formatMessage($c2dc750c82b079e2$var$i18n.generalError);
    };
    // Temporary bugfix: <LivePagesTitlePresentation> has a `key={title}` to force remounting when the title changes.
    // This prevents the title from being outdated when transitioning between live docs when we're not unmounting editor component.
    // The real fix should likely be made on the design system team's <Field> component that's erroronously displaying an outdated title. Their team is looking into this.
    // TODO Remove the `key` when the design system team's <Field> component is fixed.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PAGE_MODES
    }, updateError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: updateError
    }), !isSSR && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fazoG.TitleGenerationOnPaste), {
        contentId: contentId,
        contentType: "page",
        textAreaRef: textAreaRef,
        title: title,
        isLivePage: true,
        isEditorEmpty: isEditorEmpty,
        userOffline: userOffline ?? false,
        flags: flags,
        i18n: $c2dc750c82b079e2$var$i18n,
        formatMessage: formatMessage,
        onTitleGeneratingChange: onTitleGeneratingChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b9k8w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Iwqw.default), {
        name: (0, $kycWk.REDACTIONS_TOUR_TARGETS).TITLE_REDACTION
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $82b9586b69ae689f$export$46314a318e0df6ce), {
        ...(0, $9wGTI.fg)('confluence_frontend_transition_preloading_system') ? {
            key: title
        } : {},
        title: title,
        isDisabled: isDisabled,
        viewMode: viewMode,
        isTitleCenterAligned: isTitleCenterAligned,
        isUserEditing: isUserEditing,
        updateLoading: updateLoading,
        updateError: updateError,
        handleBlur: handleBlur,
        handleFocus: handleFocus,
        handleChange: handleChange,
        handleKeyDown: handleKeyDown,
        displayValueOverride: pendingMdDisplayValue,
        getIsInvalidTitle: getIsInvalidTitle,
        buildErrorMessage: buildErrorMessage,
        textAreaRef: textAreaRef,
        formatMessage: formatMessage,
        i18n: $c2dc750c82b079e2$var$i18n,
        AI_SUGGEST_TITLE_PROPS: (0, $fTmNK.AI_SUGGEST_TITLE_PROPS),
        maxLength: (0, $fTmNK.MAX_LENGTH_OF_TITLE),
        isCssAutoSizingSupported: isCSSAutoSizingSupported,
        isDisabledTextBlack: isSeamlessTransitionInProgress,
        customPlaceholder: customPlaceholder,
        isMarkdownMode: isMarkdownMode
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lt1a.default), null, activeSpotlight)));
};



var $3jwuS = parcelRequire("3jwuS");


var $bFMG7 = parcelRequire("bFMG7");


var $ep3mz = parcelRequire("ep3mz");


var $kdpMy = parcelRequire("kdpMy");


var $hy9oS = parcelRequire("hy9oS");








var $dBcar = parcelRequire("dBcar");


var $ivb8S = parcelRequire("ivb8S");

/**
 * Checks if the specified locale and the browser's language setting are English.
 * Optionally skips the browser's language check.
 *
 * @param {string} locale - The locale to check. It will be transformed to lowercase for comparison.
 * @param {boolean} [skipBrowserCheck=false] - Whether to skip checking the browser's language setting. Defaults to false.
 * @returns {boolean} - Returns true if:
 *  - The passed locale starts with 'en' and navigator language setting starts with 'en'.
 *  - The passed locale starts with 'en' and either skipBrowserCheck is true or the navigator object is not available.
 * Returns false otherwise.
 */ const $ea6df990daadbbff$export$68fe00948fce4bd0 = (locale, skipBrowserCheck = false)=>{
    const englishPrefix = 'en';
    const isLocaleEnglish = locale.toLowerCase().startsWith(englishPrefix);
    // When skipBrowserCheck is true or we are not in a browser environment, only check locale
    if (skipBrowserCheck || !Boolean(window?.navigator)) return isLocaleEnglish;
    // Otherwise, check both locale and navigator language
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    return isLocaleEnglish && navigator.language?.toLowerCase().startsWith(englishPrefix);
};






var $jmWd4 = parcelRequire("jmWd4");


var $5epXp = parcelRequire("5epXp");


var $gektR = parcelRequire("gektR");

const $dc469ce4f301a98f$var$i18n = (0, $kSwu1.defineMessages)({
    aiBlankPagePlaceholder: {
        id: "title-area-content-components.ai-blank-page-placeholder",
        defaultMessage: "New page"
    },
    aiBlankLiveDocPlaceholder: {
        id: "title-area-content-components.ai-blank-live-doc-placeholder",
        defaultMessage: "New live doc"
    },
    autoPageEmojiPlaceholderTitle: {
        id: "title-area-content-components.title-section.auto-page-emoji-placeholder-title",
        defaultMessage: "Start with a title and emoji"
    }
});
const $dc469ce4f301a98f$var$topLineBoxStylesMarginTopSpaceNegative300 = (0, $buxP3.xcss)({
    marginTop: 'space.negative.300'
});
const $dc469ce4f301a98f$var$breadcrumbAndTitleGapStyles = (0, $buxP3.xcss)({
    marginBottom: 'space.300'
});
const $dc469ce4f301a98f$var$aiAnalyticsConfig = {
    product: 'confluence',
    subproduct: 'confluence',
    source: 'confluencePage',
    aiFeatureName: 'aiTitleGenOnPublish',
    proactiveGeneratedAI: 1,
    userGeneratedAI: 0
};
const $dc469ce4f301a98f$var$TitleAreaComponentWithState = ({ title: title, breadcrumbsComponent: breadcrumbsComponent, contentId: contentId, cloudId: cloudId, isDisabled: isDisabled, linkCreation: linkCreation, onChange: onChange, focusEditor: focusEditor, onFocusChanged: onFocusChanged, debounceOnChange: debounceOnChange, contentType: contentType, userOffline: userOffline, isInPreview: isInPreview, isUnpublishedDraft: isUnpublishedDraft, isPublishingContent: isPublishingContent, templateSuggestionsRef: templateSuggestionsRef, templateButtonRef: templateButtonRef, isTemplateEditor: isTemplateEditor = false, contentTopperComponent: headerActionsComponent, viewMode: viewMode, contentClassificationMetadata: contentClassificationMetadata, version: version, isEditorEmpty: isEditorEmpty, collabEditInitialized: collabEditInitialized, alignmentButtonContainer: alignmentButtonContainer, coverPictureStateContainer: coverPictureStateContainer, flags: flags, contentComponentsDisabled: contentComponentsDisabled, isDraftLockedForEditing: isDraftLockedForEditing, isStatusDisconnected: isStatusDisconnected, editorApi: editorApi, editorActions: editorActions, editorSessionId: editorSessionId, isSeamlessTransitionInProgress: isSeamlessTransitionInProgress = false, isTitleGenerating: isTitleGenerating, onTitleGeneratingChange: onTitleGeneratingChange, isEmbeddedConfluence: isEmbeddedConfluence, customPlaceholderOverride: customPlaceholderOverride, isDisabledTextBlack: isDisabledTextBlack, pageAlreadyHasEmoji: pageAlreadyHasEmoji })=>{
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { cloudId: sessionCloudId, isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled, userId: userId } = (0, $bQm3c.useSessionData)();
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const hasTitleChangedRef = (0, $cozmU.useRef)(false);
    const detectMeetingSignal = (0, $jmWd4.useMeetingSignalDetection)();
    const hasTitleSuggestionTriggeredRef = (0, $cozmU.useRef)(false);
    const updateAlignmentState = alignmentButtonContainer?.toggleAlignmentButton;
    const updateCoverPictureWidthState = coverPictureStateContainer?.toggleCoverPictureWidthButton;
    const updateIsLoadingComplete = alignmentButtonContainer?.setIsLoadingComplete;
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const hideWhileLoading = !(window.__SSR_RENDERED__ || undefined);
    const { isTitleAlignmentLoading: isTitleAlignmentLoading, isTitleCenteredInitial: isTitleCenteredInitial, coverImageWidthCached: coverImageWidthCached } = (0, $aV3a0.useTitleContentPropertiesForEditor)({
        contentId: contentId,
        updateAlignmentState: updateAlignmentState,
        updateCoverPictureWidthState: updateCoverPictureWidthState,
        loadTitleContentProperties: true,
        contentType: contentType,
        flags: flags,
        updateIsLoadingComplete: updateIsLoadingComplete
    });
    const [localUserOffline, setLocalUserOffline] = (0, $cozmU.useState)(false);
    const [suppressTitleFocus, setSuppressTitleFocus] = (0, $cozmU.useState)(false);
    const hasActivatedBoeFocusRef = (0, $cozmU.useRef)(false);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [spaceKey = ''] = (0, $ep3mz.usePageSpaceKey)();
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [, action] = (0, $kdpMy.useGeneratedTitle)();
    const [titleAfterBlur, setTitleAfterBlur] = (0, $cozmU.useState)(null);
    const onTitleBlur = (currentTitle)=>{
        hasTitleSuggestionTriggeredRef.current = true;
        if (isLivePage && (0, $9wGTI.fg)('cc_fd_suggest_whiteboards_on_page_title_gate')) hasTitleChangedRef.current = true;
        const resolvedTitle = currentTitle ?? title;
        setTitleAfterBlur(resolvedTitle);
        // Meeting-signal instrumentation (STARB-3763)
        detectMeetingSignal({
            source: 'editPageScreen',
            trigger: 'titleEdit',
            titleText: resolvedTitle
        });
    };
    const isEnglishLocale = (0, $ea6df990daadbbff$export$68fe00948fce4bd0)(locale);
    const isEligibleForAutoPageEmojiAudienceCheck = isAdminHubAIEnabled && isEnglishLocale && (contentType === 'page' || contentType === 'blogpost');
    const { data: onboardingStateData } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.ONBOARDING_EXPERIENCES).NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP,
        (0, $dBcar.NTH_USER_EMOJI_TITLE_DISCOVERED).EMOJI_TITLE_DISCOVERED
    ], !isEligibleForAutoPageEmojiAudienceCheck);
    const { nthUserOnboardingCompletedTimestamp: nthUserOnboardingCompletedTimestamp, emojiTitleDiscovered: emojiTitleDiscovered } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const completedTimestamp = parseInt(nthUserOnboardingCompletedTimestamp, 10) ?? 0;
    const isEligibleForAutoPageEmojiExp = isEligibleForAutoPageEmojiAudienceCheck && completedTimestamp >= Date.parse('2025-12-04');
    const cohort = isEligibleForAutoPageEmojiExp ? (0, $6mKj3.expVal)('auto_page_emoji_for_new_users_exp', 'cohort', 'not-enrolled') : undefined;
    const autoPageEmojiCohort = cohort === 'control' || cohort === 'random' || cohort === 'not-enrolled' ? cohort : undefined;
    const customPlaceholder = (0, $cozmU.useMemo)(()=>{
        if (customPlaceholderOverride) return customPlaceholderOverride;
        if (!isEmbeddedConfluence && isRovoLLMEnabled && (0, $6mKj3.isExperimentEnabled)('cwr_blank_object_experiment') && contentType !== 'blogpost') return formatMessage(isLivePage ? $dc469ce4f301a98f$var$i18n.aiBlankLiveDocPlaceholder : $dc469ce4f301a98f$var$i18n.aiBlankPagePlaceholder);
        if (autoPageEmojiCohort === 'random') return formatMessage($dc469ce4f301a98f$var$i18n.autoPageEmojiPlaceholderTitle);
        return undefined;
    }, [
        isEmbeddedConfluence,
        isLivePage,
        contentType,
        autoPageEmojiCohort,
        formatMessage,
        customPlaceholderOverride,
        isRovoLLMEnabled
    ]);
    const contentClassificationFromHook = (0, $bFMG7.useContentClassification)({
        contentId: contentId,
        spaceKeyOverride: spaceKey,
        contentStatusContext: isLivePage ? 'current-and-draft' : 'draft-only'
    });
    const contentClassification = !contentClassificationMetadata ? contentClassificationFromHook : contentClassificationMetadata;
    const { shouldDisplayClassification: shouldDisplayClassification } = contentClassification;
    // Experience tracking callbacks for AI image generation
    const imageGenerationCallbacks = (0, $hy9oS.useImageGenerationCallbacks)();
    const { generateImage: generateImage, aiHeaderImageStatus: aiHeaderImageStatus, aiHeaderImageFileId: aiHeaderImageFileId, setAIHeaderImageStatus: setAIHeaderImageStatus, error: aiHeaderImageError } = (0, $bSMD1.useHeaderImageGeneration)({
        cloudId: cloudId ?? sessionCloudId,
        contentId: contentId,
        eventCallbacks: imageGenerationCallbacks,
        userId: userId
    });
    const onSuggestTitleClickedRef = (0, $cozmU.useRef)(undefined);
    // Connection banner height has a delay to appear, adjust the draft banner height to reflect this delay
    (0, $cozmU.useEffect)(()=>{
        const DELAY_TIMEOUT = 3000;
        const delayTimeout = setTimeout(()=>setLocalUserOffline(userOffline), DELAY_TIMEOUT);
        return ()=>{
            clearTimeout(delayTimeout);
        };
    }, [
        userOffline
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (hasActivatedBoeFocusRef.current || isLivePage) return;
        if (collabEditInitialized && isEditorEmpty && !title && ((0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant1') || (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant2'))) {
            hasActivatedBoeFocusRef.current = true;
            setSuppressTitleFocus(true);
            focusEditor?.();
        }
    }, [
        collabEditInitialized,
        focusEditor,
        isEditorEmpty,
        isLivePage,
        title
    ]);
    const handleOnChangeWrapperForSuggestWhiteboardExperiment = (value)=>{
        hasTitleChangedRef.current = true;
        onChange(value);
    };
    const renderTitleComponent = ()=>{
        if (isTitleAlignmentLoading && hideWhileLoading) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: [
                (0, $gqqjz.FlagsStateContainer),
                (0, $gektR.AlignmentButtonContainer)
            ]
        }, (flags, alignmentButtonContainer)=>{
            const isTitleCenterAligned = !alignmentButtonContainer.state.isLoadingComplete ? isTitleCenteredInitial : alignmentButtonContainer.state.alignmentButtonState === (0, $jVylI.TitleAlignmentType).CENTER;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $29vMs.AIEventsInstrumentationProvider), {
                config: $dc469ce4f301a98f$var$aiAnalyticsConfig
            }, isLivePage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c2dc750c82b079e2$export$919d652062589a50), {
                title: title ?? '',
                contentId: contentId,
                cloudId: cloudId,
                userOffline: userOffline,
                isDisabled: isDisabled,
                isEditorEmpty: isEditorEmpty,
                focusEditor: focusEditor,
                onFocusChanged: onFocusChanged,
                onTitleBlur: onTitleBlur,
                viewMode: viewMode,
                isTitleCenterAligned: isTitleCenterAligned,
                version: version,
                editorApi: editorApi,
                editorActions: editorActions,
                editorSessionId: editorSessionId,
                isSeamlessTransitionInProgress: isSeamlessTransitionInProgress,
                customPlaceholder: customPlaceholder,
                flags: flags,
                onTitleGeneratingChange: onTitleGeneratingChange
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fTmNK.EditorTitle), {
                title: title,
                contentId: contentId,
                cloudId: cloudId,
                isDisabled: isDisabled,
                suppressTitleFocus: suppressTitleFocus,
                onChange: (0, $9wGTI.fg)('cc_fd_suggest_whiteboards_on_page_title_gate') ? handleOnChangeWrapperForSuggestWhiteboardExperiment : onChange,
                focusEditor: focusEditor,
                onFocusChanged: onFocusChanged,
                setGeneratedTitle: action.setGeneratedTitle,
                setTrackAIResultViewStored: action.setTrackAIResultViewStored,
                onTitleBlur: onTitleBlur,
                debounceOnChange: debounceOnChange,
                contentType: contentType,
                userOffline: userOffline,
                isInPreview: isInPreview,
                isTemplateEditor: isTemplateEditor,
                templateSuggestionsRef: templateSuggestionsRef,
                templateButtonRef: templateButtonRef,
                flagArray: flags?.state?.flags ?? [],
                isTitleCenterAligned: isTitleCenterAligned,
                isUnpublishedDraft: isUnpublishedDraft,
                contentClassificationMetadata: contentClassification,
                hasClassification: shouldDisplayClassification,
                isEditMode: true,
                isEditorEmpty: isEditorEmpty,
                spaceKey: spaceKey,
                spaceId: spaceId,
                editorApi: editorApi,
                editorSessionId: editorSessionId,
                isSeamlessTransitionInProgress: isSeamlessTransitionInProgress,
                isTitleGeneratingFromPaste: isTitleGenerating,
                onTitleGeneratingChange: onTitleGeneratingChange,
                customPlaceholder: customPlaceholder,
                isDisabledTextBlack: isDisabledTextBlack
            }));
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, isTemplateEditor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            localUserOffline && $dc469ce4f301a98f$var$topLineBoxStylesMarginTopSpaceNegative300,
            $dc469ce4f301a98f$var$breadcrumbAndTitleGapStyles
        ],
        testId: "breadcrumbs-wrapper"
    }, breadcrumbsComponent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5epXp.EditorTitleWithTitleAreaComponents), {
        contentId: contentId,
        isPublishingContent: isPublishingContent,
        contentType: contentType,
        userOffline: userOffline,
        isTemplateEditor: isTemplateEditor,
        isTitleDisabled: isDisabled,
        isUnpublishedDraft: isUnpublishedDraft,
        isTitleCenterAligned: !alignmentButtonContainer.state.isLoadingComplete ? isTitleCenteredInitial : alignmentButtonContainer.state.alignmentButtonState === (0, $jVylI.TitleAlignmentType).CENTER,
        linkCreation: linkCreation,
        viewMode: viewMode,
        contentTopperComponent: !isTemplateEditor && headerActionsComponent,
        contentClassificationMetadata: contentClassification,
        hasClassification: shouldDisplayClassification,
        spaceKey: spaceKey,
        isEditorEmpty: isEditorEmpty,
        isTitleAlignmentLoading: isTitleAlignmentLoading && hideWhileLoading,
        contentComponentsDisabled: contentComponentsDisabled,
        isDraftLockedForEditing: isDraftLockedForEditing,
        isStatusDisconnected: isStatusDisconnected,
        coverPictureState: coverPictureStateContainer,
        title: title,
        titleAfterBlur: titleAfterBlur,
        isLivePage: isLivePage,
        coverImageWidthCached: coverImageWidthCached,
        pageTitleContent: titleAfterBlur || undefined,
        aiHeaderImageStatus: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_ai_header_image_generation') ? aiHeaderImageStatus : undefined,
        aiHeaderImageFileId: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_ai_header_image_generation') ? aiHeaderImageFileId : undefined,
        generateAIHeaderImage: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_ai_header_image_generation') ? generateImage : undefined,
        setAIHeaderImageStatus: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_ai_header_image_generation') ? setAIHeaderImageStatus : undefined,
        aiHeaderImageError: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_ai_header_image_generation') ? aiHeaderImageError : undefined,
        autoPageEmojiCohort: autoPageEmojiCohort,
        emojiTitleDiscovered: emojiTitleDiscovered,
        onSuggestTitleClickedRef: onSuggestTitleClickedRef,
        version: version,
        hasTitleChangedRef: hasTitleChangedRef,
        hasTitleSuggestionTriggeredRef: hasTitleSuggestionTriggeredRef,
        isDisabledTextBlack: isDisabledTextBlack
    }, renderTitleComponent(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4f3a8dba1da971e8$export$c608cc623d373c2b), {
        contentId: contentId,
        title: title,
        isTitleGenerating: isTitleGenerating,
        locale: locale,
        pageAlreadyHasEmoji: pageAlreadyHasEmoji,
        onSuggestTitleClickedRef: onSuggestTitleClickedRef
    })));
};
$dc469ce4f301a98f$var$TitleAreaComponentWithState.displayName = 'TitleAreaComponentWithState';
const $dc469ce4f301a98f$export$24c87f0cb1dfb811 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $gektR.AlignmentButtonContainer),
            (0, $i5zxs.CoverPictureStateContainer),
            (0, $gqqjz.FlagsStateContainer),
            (0, $ktUCG.EmojiTitleStateContainer)
        ]
    }, (alignmentButtonContainer, coverPictureStateContainer, flags, emojiTitleState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dc469ce4f301a98f$var$TitleAreaComponentWithState, {
            ...props,
            alignmentButtonContainer: alignmentButtonContainer,
            coverPictureStateContainer: coverPictureStateContainer,
            flags: flags,
            pageAlreadyHasEmoji: !!emojiTitleState.state.selectedEmoji
        }));
};
$dc469ce4f301a98f$export$24c87f0cb1dfb811.displayName = 'TitleAreaContentComponents';
module.exports["TitleAreaContentComponents"] = $dc469ce4f301a98f$export$24c87f0cb1dfb811;

});

parcelRegister("29vMs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1np6T = parcelRequire("1np6T");


var $hBkQ2 = parcelRequire("hBkQ2");


var $aZXY4 = parcelRequire("aZXY4");

const $61be62ccfa3ec333$var$validateAIEventsConfig = (config)=>{
    if (!config.aiFeatureName.match(/^[a-z][A-Za-z]*$/)) // eslint-disable-next-line no-console
    console.error('[@atlassian/ai-analytics]: please set aiFeatureName in camelCase');
};
const $61be62ccfa3ec333$export$b5d4bc85dfbaa4f8 = ({ children: children, config: config })=>{
    const { refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = (0, $aZXY4.useAIInstrumentationSetup)(config.singleInstrumentationID);
    const contextValue = (0, $cozmU.useMemo)(()=>{
        $61be62ccfa3ec333$var$validateAIEventsConfig(config);
        return {
            config: {
                ...(0, $hBkQ2.defaultAIEventsInstrumentationConfigValues),
                ...config,
                product: config.product.toLowerCase()
            },
            refreshSingleInstrumentationID: refreshSingleInstrumentationID,
            getSingleInstrumentationID: getSingleInstrumentationID,
            setAISessionState: setAISessionState,
            getAISessionState: getAISessionState
        };
    }, [
        config,
        refreshSingleInstrumentationID,
        getSingleInstrumentationID,
        setAISessionState,
        getAISessionState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1np6T.AIEventsInstrumentationContext).Provider, {
        value: contextValue
    }, children);
};
module.exports["AIEventsInstrumentationProvider"] = $61be62ccfa3ec333$export$b5d4bc85dfbaa4f8;

});

parcelRegister("7Xbdy", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $8e42127f11926abc$var$CONVO_AI_PAGE_EMOJI_URL = '/gateway/api/assist/api/ai/v2/ai-feature/confluence-page-emoji-suggestion';
// ConfluencePageEmojiSuggestionError (from generated @atlassian/convo-ai-api) requires
// both error_reason and error_message. FE never surfaces this string to users.
const $8e42127f11926abc$var$GENERIC_API_ERROR_MESSAGE = 'Failed to suggest page emoji';
class $8e42127f11926abc$var$SuggestEmojiError extends Error {
    constructor(apiError){
        super(apiError.error_message), this.apiError = apiError;
        this.name = 'SuggestEmojiError';
    }
}
const $8e42127f11926abc$export$c6b5b42bcefa9f9a = ({ contentId: contentId, eventCallbacks: eventCallbacks })=>{
    const [loading, setLoading] = (0, $cozmU.useState)(false);
    const [data, setData] = (0, $cozmU.useState)(null);
    const [error, setError] = (0, $cozmU.useState)(null);
    const [aiEmojiStatus, setAiEmojiStatus] = (0, $cozmU.useState)('NOT_LOADING');
    const abortControllerRef = (0, $cozmU.useRef)(null);
    // Held in a ref so suggestEmoji's identity stays stable across renders.
    const callbacksRef = (0, $cozmU.useRef)(eventCallbacks);
    (0, $cozmU.useEffect)(()=>{
        callbacksRef.current = eventCallbacks;
    }, [
        eventCallbacks
    ]);
    const reset = (0, $cozmU.useCallback)(()=>{
        setLoading(false);
        setData(null);
        setError(null);
        setAiEmojiStatus('NOT_LOADING');
    }, []);
    const suggestEmoji = (0, $cozmU.useCallback)(async ({ title: title, locale: locale })=>{
        const trimmedTitle = (title ?? '').trim();
        const baseParams = {
            contentId: contentId,
            titleLength: trimmedTitle.length,
            ...locale !== undefined && {
                locale: locale
            }
        };
        if (!trimmedTitle) {
            const invalidError = {
                error_reason: 'invalid_input',
                error_message: $8e42127f11926abc$var$GENERIC_API_ERROR_MESSAGE
            };
            setError(invalidError);
            setData(null);
            setAiEmojiStatus('INVALID_INPUT');
            callbacksRef.current?.onSuggestError?.({
                ...baseParams,
                error: new Error(invalidError.error_message),
                errorReason: 'invalid_input'
            });
            return undefined;
        }
        callbacksRef.current?.onSuggestStart?.(baseParams);
        abortControllerRef.current?.abort();
        abortControllerRef.current = new AbortController();
        setError(null);
        setData(null);
        setLoading(true);
        setAiEmojiStatus('LOADING');
        try {
            const request = {
                ai_feature_input: {
                    title: trimmedTitle,
                    ...locale !== undefined && {
                        locale: locale
                    }
                }
            };
            const response = await fetch($8e42127f11926abc$var$CONVO_AI_PAGE_EMOJI_URL, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json;charset=UTF-8',
                    'X-Experience-Id': 'confluence-ai-first-creation',
                    'X-Product': 'confluence'
                },
                body: JSON.stringify(request),
                signal: abortControllerRef.current.signal
            });
            if (!response.ok) throw new $8e42127f11926abc$var$SuggestEmojiError({
                error_reason: 'api_error',
                error_message: $8e42127f11926abc$var$GENERIC_API_ERROR_MESSAGE
            });
            const parsed = await response.json();
            const output = parsed?.ai_feature_output;
            if (!output || typeof output.status !== 'string') throw new $8e42127f11926abc$var$SuggestEmojiError({
                error_reason: 'api_error',
                error_message: $8e42127f11926abc$var$GENERIC_API_ERROR_MESSAGE
            });
            setData(output);
            switch(output.status){
                case 'suggested':
                case 'default':
                    if (!output.emojiId) throw new $8e42127f11926abc$var$SuggestEmojiError({
                        error_reason: 'api_error',
                        error_message: $8e42127f11926abc$var$GENERIC_API_ERROR_MESSAGE
                    });
                    setError(null);
                    setAiEmojiStatus('SUCCESSFULLY_SET');
                    callbacksRef.current?.onSuggestSuccess?.({
                        ...baseParams,
                        status: output.status,
                        emojiId: output.emojiId
                    });
                    return output.emojiId;
                case 'no_suggestion':
                    setError(null);
                    setAiEmojiStatus('NO_SUGGESTION');
                    callbacksRef.current?.onSuggestNoSuggestion?.({
                        ...baseParams,
                        status: 'no_suggestion'
                    });
                    return undefined;
                case 'error':
                    // BE always returns 200 for AIFeature envelopes; throw so the single catch handles it.
                    throw new $8e42127f11926abc$var$SuggestEmojiError(output.error ?? {
                        error_reason: 'api_error',
                        error_message: $8e42127f11926abc$var$GENERIC_API_ERROR_MESSAGE
                    });
                case 'loading':
                default:
                    setError(null);
                    setAiEmojiStatus('NOT_LOADING');
                    return undefined;
            }
        } catch (err) {
            const isErrorType = err instanceof Error;
            if (isErrorType && err.name === 'AbortError') {
                callbacksRef.current?.onSuggestAbort?.(baseParams);
                return undefined;
            }
            const apiError = err instanceof $8e42127f11926abc$var$SuggestEmojiError ? err.apiError : {
                error_reason: 'api_error',
                error_message: $8e42127f11926abc$var$GENERIC_API_ERROR_MESSAGE
            };
            const errorReason = apiError.error_reason;
            setError(apiError);
            setData({
                status: 'error',
                error: apiError
            });
            setAiEmojiStatus('ERROR');
            callbacksRef.current?.onSuggestError?.({
                ...baseParams,
                error: isErrorType ? err : new Error(apiError.error_message),
                errorReason: errorReason
            });
            return undefined;
        } finally{
            setLoading(false);
        }
    }, // eventCallbacks is intentionally excluded — read through callbacksRef for stable identity.
    [
        contentId
    ]);
    const isRetryable = (0, $cozmU.useMemo)(()=>aiEmojiStatus === 'ERROR' && error?.error_reason === 'api_error', [
        aiEmojiStatus,
        error
    ]);
    const aiEmojiId = (0, $cozmU.useMemo)(()=>data && (data.status === 'suggested' || data.status === 'default') ? data.emojiId : undefined, [
        data
    ]);
    return {
        suggestEmoji: suggestEmoji,
        aiEmojiId: aiEmojiId,
        aiEmojiReasoning: data?.reasoning,
        aiEmojiStatus: aiEmojiStatus,
        data: data,
        error: error,
        isRetryable: isRetryable,
        loading: loading,
        reset: reset
    };
};
module.exports["useAIPageEmojiSuggestion"] = $8e42127f11926abc$export$c6b5b42bcefa9f9a;

});

parcelRegister("jECFp", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $a0bb26fc274d4fce$var$initialState = {
    aiSuggestedEmojiId: undefined,
    aifcSuggestionInFlight: false,
    aiEmojiSuggestionSource: undefined,
    aiEmojiSuggestionSessionId: 0,
    hasPasteAutoTitleEmojiAppliedThisSession: false
};
const $a0bb26fc274d4fce$var$actions = {
    setAISuggestedEmojiId: (aiSuggestedEmojiId)=>({ setState: setState })=>{
            setState({
                aiSuggestedEmojiId: aiSuggestedEmojiId
            });
        },
    setAifcSuggestionInFlight: (aifcSuggestionInFlight)=>({ setState: setState })=>{
            setState({
                aifcSuggestionInFlight: aifcSuggestionInFlight
            });
        },
    setAIEmojiSuggestionSource: (aiEmojiSuggestionSource)=>({ setState: setState })=>{
            setState({
                aiEmojiSuggestionSource: aiEmojiSuggestionSource
            });
        },
    setHasPasteAutoTitleEmojiAppliedThisSession: (hasPasteAutoTitleEmojiAppliedThisSession)=>({ setState: setState })=>{
            setState({
                hasPasteAutoTitleEmojiAppliedThisSession: hasPasteAutoTitleEmojiAppliedThisSession
            });
        },
    /**
   * Atomically bumps the session id and clears the companion fields. Called on
   * each new title-generating rising edge so each session starts clean. Always
   * prefer this over bumping `aiEmojiSuggestionSessionId` directly so the
   * session-reset contract cannot be broken.
   */ resetForNewSession: (nextSource)=>({ getState: getState, setState: setState })=>{
            setState({
                aiEmojiSuggestionSessionId: getState().aiEmojiSuggestionSessionId + 1,
                aiSuggestedEmojiId: undefined,
                aifcSuggestionInFlight: false,
                hasPasteAutoTitleEmojiAppliedThisSession: false,
                aiEmojiSuggestionSource: nextSource
            });
        }
};
const $a0bb26fc274d4fce$export$28f0982fc242dfc = (0, $8s9DV.createStore)({
    name: 'AIEmojiSuggestionStore',
    initialState: $a0bb26fc274d4fce$var$initialState,
    actions: $a0bb26fc274d4fce$var$actions
});
const $a0bb26fc274d4fce$export$ceaf53c089700a19 = (0, $kBr4q.createHook)($a0bb26fc274d4fce$export$28f0982fc242dfc);
const $a0bb26fc274d4fce$export$9ebb873254abc907 = (0, $kBr4q.createActionsHook)($a0bb26fc274d4fce$export$28f0982fc242dfc);
module.exports["useAIEmojiSuggestion"] = $a0bb26fc274d4fce$export$ceaf53c089700a19;
module.exports["useAIEmojiSuggestionActions"] = $a0bb26fc274d4fce$export$9ebb873254abc907;

});

parcelRegister("ktUCG", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");


var $6mKj3 = parcelRequire("6mKj3");


var $8rneB = parcelRequire("8rneB");


var $bKZz0 = parcelRequire("bKZz0");

class $122734ff4c4db131$export$c7d05d5ff2632978 extends (0, $kNIYN.Container) {
    populateState(ssrEmojiTitleData) {
        const { emojiStatusFieldName: emojiStatusFieldName, queryData: queryData, isLivePage: isLivePage } = ssrEmojiTitleData;
        const emojiId = (0, $8rneB.getEmojiId)(queryData, emojiStatusFieldName);
        const hasDefaultLiveTitleEmoji = (0, $8rneB.getHasLiveDocsDefaultEmoji)(queryData);
        this.setSelectedEmoji(emojiId || null);
        this.setHasLiveDocsDefaultEmoji(hasDefaultLiveTitleEmoji && isLivePage);
    }
    constructor(ssrEmojiTitleData){
        super();
        // Analytics-only flag: intentionally bypasses Container state so mutations
        // never trigger subscriber re-renders.
        this.justRestoredEmoji = false;
        this.state = {
            emojiPickerLoaded: false,
            isLoading: true,
            isMouseEnterTitle: false,
            isUpdatingEmoji: false,
            openFirstEmojiPicker: false,
            openSecondEmojiPicker: false,
            selectedEmoji: null,
            isEmojiButtonFocused: false,
            isRemovingEmoji: false,
            hasLiveDocsDefaultEmoji: false,
            previousEmojiIdByContentId: {}
        };
        this.onUpdateStart = ()=>this.setState({
                isUpdatingEmoji: true
            });
        this.onUpdateEnd = ()=>{
            this.setState({
                isUpdatingEmoji: false
            });
            this.setState({
                isRemovingEmoji: false
            });
        };
        this.setIsEmojiButtonFocused = (isEmojiButtonFocused)=>this.setState({
                isEmojiButtonFocused: isEmojiButtonFocused
            });
        this.setIsRemovingEmoji = (isRemovingEmoji)=>this.setState({
                isRemovingEmoji: isRemovingEmoji
            });
        this.setIsUpdatingEmoji = (isUpdatingEmoji)=>this.setState({
                isUpdatingEmoji: isUpdatingEmoji
            });
        // first emoji picker is open when user already selected an emoji
        // click on the emoji and want to change it to different emoji
        this.setOpenFirstEmojiPicker = (isOpen)=>{
            if (this.state.openFirstEmojiPicker !== isOpen) this.setState({
                openFirstEmojiPicker: isOpen
            });
        };
        // second emoji picker is open when not yet selected an emoji
        // and want to add emoji via Add emoji button
        this.setOpenSecondEmojiPicker = (isOpen)=>{
            if (this.state.openSecondEmojiPicker !== isOpen) this.setState({
                openSecondEmojiPicker: isOpen
            });
        };
        this.setSelectedEmoji = (emoji)=>this.setState({
                selectedEmoji: emoji
            });
        this.onEmojiPickerLoaded = ()=>{
            if (!this.state.emojiPickerLoaded) this.setState({
                emojiPickerLoaded: true
            });
        };
        // for testing
        this.setContainerState = (newState)=>this.setState((state)=>({
                    ...state,
                    ...newState
                }));
        this.setLoadingEmoji = (isLoading)=>this.setState({
                isLoading: isLoading
            });
        this.setHasLiveDocsDefaultEmoji = (hasDefaultEmoji)=>this.setState({
                hasLiveDocsDefaultEmoji: hasDefaultEmoji
            });
        this.getPreviousEmojiId = (contentId)=>this.state.previousEmojiIdByContentId[contentId] ?? null;
        // Pass `null` to clear just that entry.
        this.setPreviousEmojiId = (contentId, previousEmojiId)=>{
            const next = {
                ...this.state.previousEmojiIdByContentId
            };
            if (previousEmojiId === null) delete next[contentId];
            else next[contentId] = previousEmojiId;
            if ((0, $6mKj3.isExperimentEnabled)('cc_page_experiences_livedocs_restore_latest_emoji')) (0, $bKZz0.writeSessionStoragePreviousEmojiCache)(next);
            return this.setState({
                previousEmojiIdByContentId: next
            });
        };
        if ((0, $6mKj3.isExperimentEnabled)('cc_page_experiences_livedocs_restore_latest_emoji')) {
            const hydrated = (0, $bKZz0.readSessionStoragePreviousEmojiCache)();
            if (Object.keys(hydrated).length > 0) this.state = {
                ...this.state,
                previousEmojiIdByContentId: hydrated
            };
        }
        if (ssrEmojiTitleData) this.populateState(ssrEmojiTitleData);
    }
}
module.exports["EmojiTitleStateContainer"] = $122734ff4c4db131$export$c7d05d5ff2632978;

});

parcelRegister("8rneB", function(module, exports) {

var $kwzZh = parcelRequire("kwzZh");


var $32x2E = parcelRequire("32x2E");


var $5amrO = parcelRequire("5amrO");

const $61659933fe71a4ee$export$d2d37cdca5b73056 = (data, emojiFieldName)=>data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.version?.number || 0;
const $61659933fe71a4ee$export$4f65bc4b6ab2638 = (data, emojiFieldName)=>(data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$7f77dde40cb9b60a = (emojiValue)=>(emojiValue || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$var$transformProperty = (property)=>{
    if (property) return {
        propertyId: property?.id ?? '',
        value: (property?.value || '').replace(/['"]+/g, '').replace(/null/, ''),
        versionNumber: 'version' in property && property.version?.number || 0
    };
};
const $61659933fe71a4ee$var$findPropertyByKey = (object, key)=>$61659933fe71a4ee$var$transformProperty(object?.properties?.nodes?.find((node)=>node?.key === key));
const $61659933fe71a4ee$export$1b37039eb4b94aa5 = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-published');
const $61659933fe71a4ee$export$4d2921b7085d93bb = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-draft');
const $61659933fe71a4ee$export$f6641c501f8a1aee = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$e1cb12562674727b = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$db0acf1152e62ad6 = (data)=>((data?.content?.nodes?.[0] || data?.singleContent)?.emojiTitlePublished?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$a5b3ff94c918547 = (content)=>(content?.emoji?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$c4fe69c947489b89 = (content)=>(content?.emojiDraft?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$bb520a2176fa2873 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$fbf43d9e87015d93 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$b8852397200defa1 = (data, emojiFieldName)=>{
    let nodes;
    if (data && 'content' in data) nodes = data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0];
    else nodes = data?.emojiTitlePublished?.nodes?.[0];
    return !!nodes?.value && nodes?.value !== '""' && nodes?.value !== '"null"';
};
const $61659933fe71a4ee$export$496af73e8e85fd08 = (data)=>{
    return $61659933fe71a4ee$export$b8852397200defa1(data, 'emojiTitlePublished');
};
const $61659933fe71a4ee$export$53519180ca077ff2 = (data)=>$61659933fe71a4ee$export$b8852397200defa1(data, (0, $5amrO.EMOJI_TITLE_PUBLISHED_FIELD));
const $61659933fe71a4ee$export$8210f5f78c0bcf27 = async (cloudId, userId)=>{
    return await (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
        cloudId: cloudId,
        userId: userId
    });
};
var $61659933fe71a4ee$export$66d7571a7d7aad65 = /*#__PURE__*/ function(DefaultTitleEmojiValues) {
    DefaultTitleEmojiValues["LIVE_PAGE_DEFAULT"] = "live-page-default";
    DefaultTitleEmojiValues["NONE"] = "none";
    return DefaultTitleEmojiValues;
}({});
const $61659933fe71a4ee$export$efb819bf9c3235c7 = (data)=>{
    if (!data) return false;
    const defaultTitleEmoji = data?.content?.nodes?.[0]?.contentProperties?.latest?.defaultTitleEmoji;
    // This property denotes whether or not we show a default emoji icon, and is initially set to null to avoid backfilling on the BE;
    // therefore, a null value OR a specifically set value implies that we need to show a default icon, while a "none" value implies
    // that we should not show an icon. The default icon should also be overriden by a user-set emoji.
    return defaultTitleEmoji === null || defaultTitleEmoji === "live-page-default";
};
module.exports["getVersionNumber"] = $61659933fe71a4ee$export$d2d37cdca5b73056;
module.exports["getEmojiId"] = $61659933fe71a4ee$export$4f65bc4b6ab2638;
module.exports["sanitizeEmojiValue"] = $61659933fe71a4ee$export$7f77dde40cb9b60a;
module.exports["getEmojiPublishedProperty"] = $61659933fe71a4ee$export$1b37039eb4b94aa5;
module.exports["getEmojiDraftProperty"] = $61659933fe71a4ee$export$4d2921b7085d93bb;
module.exports["getEmojiFromPublishedPageProperties"] = $61659933fe71a4ee$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $61659933fe71a4ee$export$e1cb12562674727b;
module.exports["getPublishedEmojiId"] = $61659933fe71a4ee$export$db0acf1152e62ad6;
module.exports["getEmojiValueFromContent"] = $61659933fe71a4ee$export$a5b3ff94c918547;
module.exports["getEmojiDraftFromProperties"] = $61659933fe71a4ee$export$bb520a2176fa2873;
module.exports["getEmojiPublishedFromProperties"] = $61659933fe71a4ee$export$fbf43d9e87015d93;
module.exports["getHasEmoji"] = $61659933fe71a4ee$export$b8852397200defa1;
module.exports["doesContentHaveEmojiPublished"] = $61659933fe71a4ee$export$496af73e8e85fd08;
module.exports["getEmojiProvider"] = $61659933fe71a4ee$export$8210f5f78c0bcf27;
module.exports["DefaultTitleEmojiValues"] = $61659933fe71a4ee$export$66d7571a7d7aad65;
module.exports["getHasLiveDocsDefaultEmoji"] = $61659933fe71a4ee$export$efb819bf9c3235c7;

});

parcelRegister("32x2E", function(module, exports) {

var $1UWNP = parcelRequire("1UWNP");


var $bwAnG = parcelRequire("bwAnG");


var $7W8i8 = parcelRequire("7W8i8");

const $dc26b22176754e2e$var$logger = (0, $7W8i8.getLogger)('emoji-provider');
const $dc26b22176754e2e$export$ca6dda5263526f75 = '/gateway/api/emoji';
const $dc26b22176754e2e$export$240be4f98742fdda = (cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const config = {
        providers: [
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/standard`
            },
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/atlassian`
            }
        ],
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks
    };
    if (cloudId && (userId || allowAnonymousAccess)) config.providers.push({
        url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/site`
    });
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $dc26b22176754e2e$export$1504d130127dbc5f = (_EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? false;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    return `${cloudId}_${userId}_${allowAnonymousAccess}_${emojiSSRConfig ? 'withSSR' : 'noSSR'}`;
};
const $dc26b22176754e2e$export$9e6d4bd03aadcea5 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? undefined;
    const emojiConfig = $dc26b22176754e2e$export$240be4f98742fdda(cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess);
    return new EmojiResource(emojiConfig);
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return emojiResource.getEmojiProvider();
    } catch (err) {
        return Promise.resolve(undefined);
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$b263a0680b18512c = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return new (0, $bwAnG.EmojiNodeDataProvider)(emojiResource);
    } catch (err) {
        return undefined;
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
module.exports["getEmojiConfig"] = $dc26b22176754e2e$export$240be4f98742fdda;
module.exports["getEmojiProvider"] = $dc26b22176754e2e$export$8210f5f78c0bcf27;
module.exports["getEmojiNodeDataProvider"] = $dc26b22176754e2e$export$b263a0680b18512c;

});

parcelRegister("bwAnG", function(module, exports) {

var $4iudd = parcelRequire("4iudd");


var $l4yrE = parcelRequire("l4yrE");


var $4xiow = parcelRequire("4xiow");


var $drRzc = parcelRequire("drRzc");


var $anBbz = parcelRequire("anBbz");

class $dfb1108de4ce4e19$export$67106c51beb59865 extends (0, $drRzc.NodeDataProvider) {
    isNodeSupported(node) {
        return node.type === 'emoji';
    }
    nodeDataKey(node) {
        return node.attrs.id || node.attrs.shortName;
    }
    /**
   * Implementing different re-fetching strategy for emoji.
   *
   * Default strategy for NodeDataProvider is to:
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   * 4. Re-render node with fresh data.
   *
   * This is similar, but doesn't update the node.
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   */ getData(node, callback) {
        const cached = this.getNodeDataFromCache(node);
        if (cached?.data) {
            callback(cached);
            if (!(0, $4iudd.isSSR)() && typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(()=>void this.getDataAsync(node, ()=>{}));
        } else this.getDataAsync(node, callback);
    }
    async fetchNodesData(nodes) {
        // If we have an `optimisticImageApi`, use it to generate a URL immediately.
        // This is how emojis are server-side rendered in Confluence.
        // Without this, the emoji server response will hit timeout on SSR and the emoji will not be rendered.
        //
        // We are using this optimization only in SSR because on client side we need to know a valid emoji size
        // which is not possible to get from optimisticImageApi.
        //
        // Check platform/packages/editor/renderer/src/react/nodes/emoji.tsx
        // and platform/packages/elements/emoji/src/components/common/ResourcedEmojiComponent.tsx
        const getOptimisticImageUrl = this.emojiResource.emojiProviderConfig.optimisticImageApi?.getUrl;
        if ((0, $4iudd.isSSR)() && getOptimisticImageUrl) return nodes.map((node)=>{
            if ((0, $anBbz.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true)) {
                // Skip SSR for nodes without an Id
                if (!node.attrs.id) return undefined;
                const unicodeEmoji = (0, $4xiow.emojiIdToEmoji)(node.attrs.id);
                if (unicodeEmoji) return {
                    id: node.attrs.id,
                    shortName: node.attrs.shortName,
                    fallback: node.attrs.text,
                    representation: {
                        unicodeEmoji: unicodeEmoji
                    },
                    searchable: true,
                    type: '',
                    category: ''
                };
            }
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            const optimisticImageURL = getOptimisticImageUrl(emojiId);
            return {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text,
                representation: {
                    height: (0, $l4yrE.defaultEmojiHeight),
                    width: (0, $l4yrE.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true,
                // Type and category are unknown at this point.
                // It's not a big deal, because EmojiNodeView doesn't use them.
                type: '',
                category: ''
            };
        });
        // This is slower path because during access to emojiProvider emojiResource
        // makes a request to fetch all emojis.
        const emojiProvider = await this.emojiProvider;
        const fetches = nodes.map(async (node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            // This usually fast because the emojiProvider already has all emojis fetched.
            const result = await emojiProvider.fetchByEmojiId(emojiId, true);
            // For STANDARD emojis, return a UnicodeRepresentation so they are rendered
            // as native text characters rather than images (twemoji removal).
            if (node.attrs.id && result && (0, $anBbz.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true)) {
                const unicodeEmoji = (0, $4xiow.emojiIdToEmoji)(node.attrs.id);
                if (unicodeEmoji) return {
                    ...result,
                    representation: {
                        unicodeEmoji: unicodeEmoji
                    }
                };
            }
            // If we have optimisticImageApi, we need to path response and set URL from it to match the URL used in SSR.
            if (getOptimisticImageUrl && result) {
                const optimisticImageURL = getOptimisticImageUrl(emojiId);
                if (result.representation && 'imagePath' in result.representation) return {
                    ...result,
                    representation: {
                        ...result.representation,
                        imagePath: optimisticImageURL
                    }
                };
            }
            return result;
        });
        return Promise.all(fetches);
    }
    constructor(resource){
        super();
        this.name = 'emojiNodeDataProvider';
        this.emojiResource = void 0;
        this.emojiProvider = void 0;
        this.emojiResource = resource;
        this.emojiProvider = resource.getEmojiProvider();
    }
}
module.exports["EmojiNodeDataProvider"] = $dfb1108de4ce4e19$export$67106c51beb59865;

});

parcelRegister("drRzc", function(module, exports) {

var $4iudd = parcelRequire("4iudd");


var $fqVYq = parcelRequire("fqVYq");

class $27efd3461a9c6d27$export$1185db7a00c13eed {
    /**
   * Sets the SSR data for the provider.
   * This pre-populates the cache with data rendered on the server, preventing redundant network requests on the client.
   * Calling this method will invalidate the existing cache.
   *
   * @example
   * ```
   * const ssrData = window.__SSR_NODE_DATA__ || {};
   * nodeDataProvider.setSSRData(ssrData);
   * ```
   *
   * @param ssrData A map of node data keys to their corresponding data.
   */ setSSRData(ssrData = {}) {
        if ((0, $fqVYq.editorExperiment)('platform_synced_block', true)) {
            this.updateCache(ssrData, {
                strategy: 'replace',
                source: 'ssr'
            });
            return;
        }
        this.cacheVersion++;
        this.cache = Object.fromEntries(Object.entries(ssrData).map(([key, data])=>[
                key,
                {
                    data: data,
                    source: 'ssr'
                }
            ]));
    }
    /**
   * Clears all cached data.
   * This increments the internal cache version, invalidating any pending network requests.
   *
   * @example
   * ```
   * function useMyNodeDataProvider(contentId: string) {
   *  const nodeDataProvider = new MyNodeDataProvider();
   *
   *  // Reset the cache when the contentId changes (e.g., when the user navigates to a different page).
   *  useEffect(() => {
   *    nodeDataProvider.resetCache();
   *  }, [contentId]);
   *
   *  return nodeDataProvider;
   * }
   * ```
   */ resetCache() {
        this.cacheVersion++;
        this.cache = {};
    }
    /**
   * Fetches data for a given node using a cache-first-then-network strategy.
   *
   * The provided callback may be called multiple times:
   * 1. Immediately with data from the SSR cache, if available.
   * 2. Asynchronously with data fetched from the network.
   *
   * @example
   * ```
   * const nodeDataProvider = new MyNodeDataProvider();
   *
   * nodeDataProvider.getData(node, (data) => {
   * 	console.log('Node data:', data);
   * });
   * ```
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @param callback The callback function to call with the fetched data or an error.
   */ getData(node, callback) {
        // Move implementation to a separate async method
        // to keep this method synchronous and avoid async/await in the public API.
        this.getDataAsync(node, callback);
    }
    async getDataAsync(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        const dataFromCache = this.cache[dataKey];
        if (dataFromCache !== undefined) // If we have the data in the SSR data, we can use it directly
        callback({
            data: dataFromCache.data
        });
        if ((0, $4iudd.isSSR)()) // During SSR, we only use the cache and never fetch from the network.
        // Use loading state instead.
        return;
        // If no data is available in the cache, or the data is from the network,
        // we need to fetch it from the network.
        if (dataFromCache?.source !== 'network') {
            // Store the current cache version before making the request,
            // so we can check if the cache has changed while we are waiting for the network response.
            const cacheVersionBeforeRequest = this.cacheVersion;
            // Create a unique key for the in-flight network request
            // based on the cache version and the data key.
            const networkRequestInFlightKey = `${cacheVersionBeforeRequest}-${dataKey}`;
            // Check if there is already a network request in flight for this data
            // to avoid duplicate requests.
            const networkRequestInFlight = this.networkRequestsInFlight[networkRequestInFlightKey];
            if (networkRequestInFlight) {
                try {
                    const data = await networkRequestInFlight;
                    callback({
                        data: data
                    });
                } catch (error) {
                    callback({
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }
                return;
            }
            try {
                const dataPromise = this.fetchNodesData([
                    jsonNode
                ]).then(([value])=>value);
                // Store the promise in the in-flight requests map
                this.networkRequestsInFlight[networkRequestInFlightKey] = dataPromise;
                const data = await dataPromise;
                // We need to call the callback with the data with result even if the cache version has changed,
                // so all promises that are waiting for the data can resolve.
                callback({
                    data: data
                });
                // If the cache version has changed, we don't want to use the data from the network
                // because it could be stale data.
                if (cacheVersionBeforeRequest === this.cacheVersion) {
                    // Replace promise with the resolved data in the cache
                    if ((0, $fqVYq.editorExperiment)('platform_synced_block', true)) this.updateCache({
                        [dataKey]: data
                    }, {
                        strategy: 'merge',
                        source: 'network'
                    });
                    else this.cache[dataKey] = {
                        data: data,
                        source: 'network'
                    };
                }
            } catch (error) {
                // If an error occurs, we call the callback with the error
                callback({
                    error: error instanceof Error ? error : new Error(String(error))
                });
            } finally{
                // Ensure we clean up the in-flight request entry
                delete this.networkRequestsInFlight[networkRequestInFlightKey];
            }
        }
    }
    /**
   * Fetches data for a given node and returns it as a Promise.
   * This is a convenience wrapper around the `data` method for use with async/await.
   *
   * Note: This promise resolves with the *first* available data, which could be from the SSR cache or the network.
   * It may not provide the most up-to-date data if a network fetch is in progress.
   *
   * Note: This method is only for migration purposes. Use {@link getData} in new code instead.
   *
   * @private
   * @deprecated Don't use this method, use {@link getData} method instead.
   *             This method is only for migration purposes.
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @returns A promise that resolves with the node's data.
   */ getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS(node) {
        return new Promise((resolve, reject)=>{
            try {
                this.getData(node, (payload)=>{
                    if (payload.error) reject(payload.error);
                    else resolve(payload.data);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Checks the cache for the given node and returns its status.
   *
   * Possible return values:
   * - `false`: No cached data found for the node.
   * - `'ssr'`: Data is cached from server-side rendering (SSR).
   * - `'network'`: Data is cached from a network request.
   *
   * @param node The node (or its ProseMirror representation) to check in the cache.
   * @returns The cache status: `false`, `'ssr'`, or `'network'`.
   */ getCacheStatusForNode(node) {
        const dataFromCache = this.getNodeDataFromCache(node);
        return dataFromCache ? dataFromCache.source : false;
    }
    /**
   * Retrieves the cached data for a given node, if available.
   *
   * @param node The node (or its ProseMirror representation) for which to retrieve cached data.
   * @returns The cached data object containing `data` and `source`, or `undefined` if no cache entry exists.
   */ getNodeDataFromCache(node) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return undefined;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        return this.cache[dataKey];
    }
    /**
   * Returns the keys of the cache.
   *
   * @returns An array of the keys of the cache.
   */ getNodeDataCacheKeys() {
        return Object.keys(this.cache);
    }
    /**
   * Updates the cache with new records using merge or replace strategies.
   * This method should be the only way to modify the cache directly.
   * This allow subclasses to use it when needed. e.g. abstract fetchNodesData implementation.
   *
   * @example
   * ```
   * const newRecords = {
   *   'node-id-1': { value: 'updated data' },
   *   'node-id-3': { value: 'new data' }
   * };
   * nodeDataProvider.updateCache(newRecords, { strategy: 'merge', source: 'network' });
   * ```
   *
   * Supports two strategies:
   * - 'merge' (default): Merges new records into the existing cache.
   * - 'replace': Replaces the entire cache with the new records, invalidating any in-flight requests.
   *
   * @param records A map of node data keys to their corresponding data.
   * @param options Optional settings for the update operation.
   * @param options.strategy The strategy to use for updating the cache ('merge' or 'replace'). Defaults to 'merge'.
   * @param options.source The source of the data being added ('ssr' or 'network'). Defaults to 'network'.
   */ updateCache(records = {}, options) {
        const strategy = options?.strategy ?? 'merge';
        const source = options?.source ?? 'network';
        if (strategy === 'merge') {
            for (const [key, data] of Object.entries(records))this.cache[key] = {
                data: data,
                source: source
            };
            return;
        } else if (strategy === 'replace') {
            // Replace the entire cache with the new records
            // This will increase the cache version to invalidate any in-flight requests
            this.resetCache();
            this.cache = Object.fromEntries(Object.entries(records).map(([key, data])=>[
                    key,
                    {
                        data: data,
                        source: source
                    }
                ]));
        }
    }
    /**
   * Removes one or more entries from the cache.
   *
   * @param keys A single data key or array of data keys to remove from the cache.
   */ removeFromCache(keys) {
        keys.forEach((key)=>{
            delete this.cache[key];
        });
    }
    constructor(){
        this.cacheVersion = void 0;
        this.cache = void 0;
        this.networkRequestsInFlight = void 0;
        /**
     * A unique name for the provider. Used for identification in SSR.
     */ this.name = void 0;
        this.cacheVersion = 0;
        this.cache = {};
        this.networkRequestsInFlight = {};
    }
}
module.exports["NodeDataProvider"] = $27efd3461a9c6d27$export$1185db7a00c13eed;

});

parcelRegister("5amrO", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $99t4P = parcelRequire("99t4P");

const $bb7cbab4663812b3$export$342dc808a4f4a7ab = 'emoji-title-draft';
const $bb7cbab4663812b3$export$97ffb0b9059d248e = 'emoji-title-published';
const $bb7cbab4663812b3$export$5a027b13986198b7 = 'emojiTitleDraft';
const $bb7cbab4663812b3$export$b78a8db8f4546258 = 'emojiTitlePublished';
const $bb7cbab4663812b3$export$61509c1d76ea5fb2 = (contentType)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isWhiteboardEmoji = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    if (isWhiteboardEmoji || isLivePage) return $bb7cbab4663812b3$export$b78a8db8f4546258;
    else return $bb7cbab4663812b3$export$5a027b13986198b7;
};
const $bb7cbab4663812b3$export$28c62f1b367f9166 = (fieldName)=>{
    return fieldName === $bb7cbab4663812b3$export$b78a8db8f4546258 ? $bb7cbab4663812b3$export$97ffb0b9059d248e : $bb7cbab4663812b3$export$342dc808a4f4a7ab;
};
module.exports["EMOJI_TITLE_DRAFT_FIELD"] = $bb7cbab4663812b3$export$5a027b13986198b7;
module.exports["EMOJI_TITLE_PUBLISHED_FIELD"] = $bb7cbab4663812b3$export$b78a8db8f4546258;
module.exports["useEmojiStatusFieldName"] = $bb7cbab4663812b3$export$61509c1d76ea5fb2;
module.exports["convertEmojiFieldNameToPropertyKey"] = $bb7cbab4663812b3$export$28c62f1b367f9166;

});

parcelRegister("99t4P", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $6b4026d31beb25d0$export$f0410e068eb2ef9e = (contentType)=>{
    return contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles');
};
module.exports["isEmojiTitleEnabled"] = $6b4026d31beb25d0$export$f0410e068eb2ef9e;

});

parcelRegister("bKZz0", function(module, exports) {
/**
 * sessionStorage mirror for the per-contentId `previousEmojiId` cache used by
 * the Live Docs "Restore emoji" affordance. Survives same-tab refresh; not a
 * source of truth — the in-memory unstated state is. Failures degrade silently.
 */ 
var $17wUi = parcelRequire("17wUi");


var $ivEX1 = parcelRequire("ivEX1");

const $dabf2e5c28263f4b$var$STORAGE_KEY = (0, $ivEX1.sessionKeys).EMOJI_TITLE_PREVIOUS_EMOJI;
const $dabf2e5c28263f4b$export$6adb2744b497be8f = ()=>{
    try {
        const raw = (0, $17wUi.confluenceSessionStorageInstance)?.getItem($dabf2e5c28263f4b$var$STORAGE_KEY);
        if (!raw || typeof raw !== 'string') return {};
        const parsed = JSON.parse(raw);
        if (!parsed || parsed.v !== 1 || typeof parsed.entries !== 'object' || !parsed.entries) return {};
        // Defensive: filter to non-empty string values in case the slot was
        // mutated by something else on the same origin.
        const out = {};
        for (const [contentId, emojiId] of Object.entries(parsed.entries))if (typeof emojiId === 'string' && emojiId.length > 0) out[contentId] = emojiId;
        return out;
    } catch  {
        return {};
    }
};
const $dabf2e5c28263f4b$export$3ef572a2467e08f4 = (map)=>{
    try {
        const entries = {};
        for (const [contentId, emojiId] of Object.entries(map))if (typeof emojiId === 'string' && emojiId.length > 0) entries[contentId] = emojiId;
        // Drop the key entirely when empty to keep storage clean.
        if (Object.keys(entries).length === 0) {
            (0, $17wUi.confluenceSessionStorageInstance)?.removeItem($dabf2e5c28263f4b$var$STORAGE_KEY);
            return;
        }
        (0, $17wUi.confluenceSessionStorageInstance)?.setItem($dabf2e5c28263f4b$var$STORAGE_KEY, JSON.stringify({
            v: 1,
            entries: entries
        }));
    } catch  {
    // Quota / consent / disabled storage — swallow; in-memory cache is unaffected.
    }
};
const $dabf2e5c28263f4b$export$fc4e54f3757eb471 = $dabf2e5c28263f4b$var$STORAGE_KEY;
module.exports["readSessionStoragePreviousEmojiCache"] = $dabf2e5c28263f4b$export$6adb2744b497be8f;
module.exports["writeSessionStoragePreviousEmojiCache"] = $dabf2e5c28263f4b$export$3ef572a2467e08f4;

});

parcelRegister("ivEX1", function(module, exports) {
/**
 * Registry of keys used with `confluenceSessionStorageInstance` (session storage).
 *
 * Keys here are intentionally NOT persisted across browser sessions.
 * Do NOT add keys here that should survive a tab close — use `LocalStorageKeys.ts` instead.
 */ const $ebcfca89ee3399cd$export$43572ca00746d574 = {
    /**
	 * The layout ('grid' | 'list') selected by the user for the folder contents view.
	 * Persisted for the duration of the browser session only.
	 */ FOLDER_VIEW_LAYOUT: 'folder.view.layout',
    /**
	 * Overrides the release track to 'dev'. Useful for running end-to-end tests
	 * from a dev machine against a production instance.
	 * Used by @confluence/build-info.
	 */ TELEMETRY_DEV_TRACK_OVERRIDE: 'confluence.telemetry-dev-track-override',
    /**
	 * Enables Confluence frontend logging when set to 'true'.
	 * Used by @confluence/logger.
	 */ ENABLE_LOGGING: 'confluence.enable-logging',
    /**
	 * Controls the minimum log level (1–5) for Confluence frontend logging.
	 * Used by @confluence/logger.
	 */ LOG_LEVEL: 'confluence.log-level',
    /**
	 * Tracks when the page-watch nudge was last shown to the user.
	 * Used by @confluence/third-party-nudge.
	 */ PAGE_VIEW_NUDGE_DATE: 'page-view-nudge-date',
    /**
	 * Tracks the state of the notification section nudge.
	 * Used by @confluence/third-party-nudge.
	 */ NOTIFICATION_NUDGE_STATE: 'notification-nudge-state',
    /**
	 * Per-contentId cache of the most recent custom emoji observed on a Live
	 * Doc, used to drive the "Restore emoji" affordance.
	 * Used by @confluence/emoji-title.
	 */ EMOJI_TITLE_PREVIOUS_EMOJI: 'confluence.emoji-title.previousEmojiId.v1',
    /**
	 * Set to `true` once the Planner title-based agent suggestion banner has been
	 * dismissed (via the close button or by clicking the CTA) during the current
	 * browser session, so it is not re-shown again until the next session.
	 * Used by @confluence/experiment-ootb-title-based-agent-suggestion-nudge.
	 */ TITLE_AGENT_NUDGE_PLANNER_DISMISSED_SESSION: 'confluence.title-agent-nudge.planner-dismissed-session',
    /**
	 * Set to `true` once the Discovery & Feedback title-based agent suggestion
	 * banner has been dismissed (via the close button or by clicking the CTA)
	 * during the current browser session, so it is not re-shown again until the
	 * next session.
	 * Used by @confluence/experiment-ootb-title-based-agent-suggestion-nudge.
	 */ TITLE_AGENT_NUDGE_DISCOVERY_AND_FEEDBACK_DISMISSED_SESSION: 'confluence.title-agent-nudge.discovery-and-feedback-dismissed-session',
    /**
	 * Identifies the title-based agent suggestion already shown in this editing
	 * session. The value is the owning agent/content pair so the currently visible
	 * suggestion can remain mounted while all other title suggestions are suppressed.
	 * Used by @confluence/experiment-ootb-title-based-agent-suggestion-nudge.
	 */ TITLE_AGENT_NUDGE_SHOWN_SESSION: 'confluence.title-agent-nudge.shown-session'
};
module.exports["sessionKeys"] = $ebcfca89ee3399cd$export$43572ca00746d574;

});

parcelRegister("jVylI", function(module, exports) {
var $341ba7bb7f83b82d$export$18feebdc268a3ef1 = /*#__PURE__*/ function(TitleAlignmentType) {
    TitleAlignmentType["LEFT"] = "LEFT";
    TitleAlignmentType["CENTER"] = "CENTER";
    return TitleAlignmentType;
}({});
const $341ba7bb7f83b82d$export$f5c76f9de4274e9b = {
    titleLayoutAlignment: "LEFT",
    titlePropertySubtitle: '',
    titlePropertySubtitleEnabled: false,
    titlePropertyBylineEnabled: false,
    titlePropertyEmojiEnabled: true,
    headerImageStylingEnabled: false
};
var $341ba7bb7f83b82d$export$f84f565b1b747c24 = /*#__PURE__*/ function(COVERPICTUREWIDTH) {
    COVERPICTUREWIDTH["FULL"] = "full";
    COVERPICTUREWIDTH["FIXED"] = "fixed";
    return COVERPICTUREWIDTH;
}({});
module.exports["TitleAlignmentType"] = $341ba7bb7f83b82d$export$18feebdc268a3ef1;
module.exports["defaultPropertyValue"] = $341ba7bb7f83b82d$export$f5c76f9de4274e9b;
module.exports["COVERPICTUREWIDTH"] = $341ba7bb7f83b82d$export$f84f565b1b747c24;

});

parcelRegister("aV3a0", function(module, exports) {

var $kae7O = parcelRequire("kae7O");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $5T18X = parcelRequire("5T18X");


var $jMyy4 = parcelRequire("jMyy4");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $i9VoI = parcelRequire("i9VoI");


var $7Sm4c = parcelRequire("7Sm4c");


var $5kqgA = parcelRequire("5kqgA");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $gzIc1 = parcelRequire("gzIc1");


var $jVylI = parcelRequire("jVylI");

const $c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery = (0, $kae7O.default);
const $c042cea05c5afe3c$export$56ad806c83a5bd5e = (queryData)=>queryData?.content?.nodes?.[0]?.pageTitleDraft?.nodes?.find((node)=>node?.key === 'page-title-property-draft');
const $c042cea05c5afe3c$var$i18n = (0, $kSwu1.defineMessages)({
    errorFlagTitle: {
        id: "content-topper.page-title.alignment.error.title",
        defaultMessage: "We couldn\u2019t update the title alignment"
    },
    errorFlagDescription: {
        id: "content-topper.page-title.alignment.error.description",
        defaultMessage: "Try again, or refresh the page."
    }
});
const $c042cea05c5afe3c$export$e3e4716593714d84 = ({ contentId: contentId, propertyKey: propertyKey = 'page-title-property-draft', isDelete: isDelete = false, loadTitleContentProperties: loadTitleContentProperties = false, updateAlignmentState: updateAlignmentState, updateCoverPictureWidthState: updateCoverPictureWidthState, contentType: contentType, flags: flags, updateIsLoadingComplete: updateIsLoadingComplete })=>{
    const isInitialLoadComplete = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false);
    const isTitleCenteredInitial = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false);
    const handleError = (0, $cozmU.useCallback)((error, suppressErrors)=>{
        const isUnauthOrNotFoundError = (0, $1uFM6.isUnauthorizedError)(error) || (0, $f9jv7.isNotFoundError)(error);
        if (!isUnauthOrNotFoundError) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        if (!suppressErrors) flags?.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c042cea05c5afe3c$var$i18n.errorFlagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c042cea05c5afe3c$var$i18n.errorFlagDescription)
        });
    }, [
        flags
    ]);
    const getAlignmentFromContentProperty = (response)=>{
        const titlePropertyContent = $c042cea05c5afe3c$export$56ad806c83a5bd5e(response);
        if (titlePropertyContent?.value) try {
            return (0, $gzIc1.contentPropertyHelper)(titlePropertyContent)?.titleLayoutAlignment || (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
        } catch (e) {
            handleError(e, false);
            return (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
        }
        else return (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
    };
    const onCompleted = (response_0)=>{
        const coverPictureWidth = response_0.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
        updateAlignmentState?.(getAlignmentFromContentProperty(response_0));
        updateCoverPictureWidthState?.(coverPictureWidth);
    };
    const { data: data, networkStatus: networkStatus, refetch: refetchProperties } = (0, $jMyy4.useQueryInterop)($c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery, {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft',
                'archived'
            ]
        },
        fetchPolicy: window.__SSR_RENDERED__ ? 'cache-first' : 'cache-and-network',
        // cache-and-network is required for: edit cover width, transition out of edit, transition back to edit for same page (for Live Docs and Classic pages)
        onError: (error_0)=>{
            handleError(error_0, true);
        },
        skip: !(loadTitleContentProperties || Boolean(window.__SSR_RENDERED__)),
        notifyOnNetworkStatusChange: true,
        __callerPackage__: "content-topper"
    });
    const isTitleAlignmentLoading = networkStatus === (0, $5T18X.NetworkStatus).loading && !data;
    const refetchLoading = networkStatus === (0, $5T18X.NetworkStatus).refetch;
    const coverImageWidthCached = data?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth;
    isTitleCenteredInitial.current = (Boolean(window.__SSR_RENDERED__) || !isTitleAlignmentLoading) && getAlignmentFromContentProperty(data) === (0, $jVylI.TitleAlignmentType).CENTER;
    if (!isInitialLoadComplete.current && loadTitleContentProperties && data) {
        isInitialLoadComplete.current = true;
        onCompleted(data);
        updateIsLoadingComplete?.(true);
    }
    const { updateContentProperty: updateContentProperty, updateContentPropertyResult: { loading: isUpdatingAlignment } = {} } = (0, $5kqgA.useUpdateContentProperty)({
        contentId: contentId,
        contentType: contentType || 'page'
    });
    const onPageTitlePropertyUpdatedSubscriptionData = (0, $cozmU.useCallback)((_eventName, response_1)=>{
        const { pageTitlePropertyUpdated: pageTitlePropertyUpdated } = response_1 || {};
        try {
            const value = JSON.parse(pageTitlePropertyUpdated?.value);
            updateAlignmentState?.(value?.titleLayoutAlignment);
        } catch (error_1) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error_1, {
                attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
            });
            (0, $7Sm4c.markErrorAsHandled)(error_1);
        }
    }, [
        updateAlignmentState
    ]);
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType || 'page',
        delta: 'pageTitlePropertyUpdated',
        onDataReceived: onPageTitlePropertyUpdatedSubscriptionData,
        subscriberId: 'useTitleContentPropertiesForEditor'
    });
    const updatePageTitleProperty = (0, $cozmU.useCallback)(async (propertyValue)=>{
        try {
            const getVersionNumber = (data_0)=>data_0?.content?.nodes?.[0]?.pageTitleDraft?.nodes?.[0]?.version?.number || 0;
            const versionData = await refetchProperties();
            const versionNumber = getVersionNumber(versionData.data);
            const newVersionNumber = versionNumber ? versionNumber + 1 : 1;
            await updateContentProperty({
                propertyKey: propertyKey,
                propertyValue: propertyValue,
                isDelete: isDelete,
                hasExistingProperty: versionNumber > 0,
                shouldOptimisticResponse: true,
                options: {
                    update: ()=>{
                        try {
                            const cacheData = (0, $l1uFv.readQueryInterop)({
                                query: $c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery,
                                variables: {
                                    contentId: contentId,
                                    status: [
                                        'current',
                                        'draft',
                                        'archived'
                                    ]
                                },
                                __callerPackage__: "content-topper"
                            });
                            cacheData.content.nodes[0].pageTitleDraft.nodes[0] = {
                                ...cacheData.content.nodes[0].pageTitleDraft.nodes[0],
                                id: contentId,
                                key: propertyKey,
                                value: JSON.stringify(propertyValue),
                                version: {
                                    number: newVersionNumber,
                                    __typename: 'Version'
                                }
                            };
                            (0, $fEmGS.writeQueryInterop)({
                                query: $c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery,
                                variables: {
                                    contentId: contentId,
                                    status: [
                                        'current',
                                        'draft',
                                        'archived'
                                    ]
                                },
                                data: cacheData,
                                __callerPackage__: "content-topper"
                            });
                        } catch (error_2) {
                            throw new Error(` failed to write to cache while updating ${propertyKey} content property after user updated page title${error_2.message}`);
                        }
                    }
                }
            });
        } catch (err) {
            handleError(err, false);
        }
    }, [
        propertyKey,
        contentId,
        isDelete,
        updateContentProperty,
        refetchProperties,
        handleError
    ]);
    return {
        isUpdatingAlignment: isUpdatingAlignment || refetchLoading,
        updatePageTitleProperty: updatePageTitleProperty,
        onCompleted: // exported for testing purposes
        onCompleted,
        isTitleAlignmentLoading: isTitleAlignmentLoading,
        isTitleCenteredInitial: isTitleCenteredInitial.current,
        coverImageWidthCached: coverImageWidthCached
    };
};
module.exports["useTitleContentPropertiesForEditor"] = $c042cea05c5afe3c$export$e3e4716593714d84;

});

parcelRegister("kae7O", function(module, exports) {
/**
 * @generated SignedSource<<235e2f4f1cae802c5b7683463fdf34f9>>
 * @relayHash 177df4e8b836b390b9636d650c93a7b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 73afdec0b7224f93dd9771ff4d32ef23242471659162b27d31de856f0e22f612
const $99e3ac9ccccf9f94$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "alias": "pageTitlePublished",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-published\")"
                        },
                        {
                            "alias": "pageTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-draft\")"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "coverPictureWidth"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForEditorQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForEditorQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "177df4e8b836b390b9636d650c93a7b2",
            "id": "73afdec0b7224f93dd9771ff4d32ef23242471659162b27d31de856f0e22f612",
            "metadata": {},
            "name": "useTitleContentPropertiesForEditorQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForEditorQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}}}"
        }
    };
}();
$99e3ac9ccccf9f94$var$node.hash = "cdd7743e3348e4dc97a35c6808323ae0";
var $99e3ac9ccccf9f94$export$2e2bcd8739ae039 = $99e3ac9ccccf9f94$var$node;
module.exports["default"] = $99e3ac9ccccf9f94$export$2e2bcd8739ae039;

});

parcelRegister("f9jv7", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $b29e4bf652226e80$export$6ccdb59d3479f4f1 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '404');
module.exports["isNotFoundError"] = $b29e4bf652226e80$export$6ccdb59d3479f4f1;

});

parcelRegister("i9VoI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6UYek = parcelRequire("6UYek");

const $357775eda04c1a81$export$63ba9f3f1b368ae8 = ({ onDataReceived: onDataReceived, skip: skip = false, contentId: contentId, contentType: contentType, delta: delta, subscriberId: subscriberId })=>{
    const dispatch = (0, $6UYek.useSubscriptionsDispatchContext)();
    const { setContentId: setContentId, setContentType: setContentType, removeSubscriber: removeSubscriber, addSubscriber: addSubscriber } = dispatch || {};
    (0, $cozmU.useEffect)(()=>{
        if (skip || !addSubscriber || !contentId || !contentType || !removeSubscriber) return;
        setContentId?.(contentId);
        setContentType?.(contentType);
        const uniqueSubscriberId = addSubscriber({
            delta: delta,
            subscriberId: subscriberId,
            onSubscriptionData: onDataReceived
        });
        return ()=>{
            removeSubscriber({
                delta: delta,
                subscriberId: uniqueSubscriberId
            });
        };
    }, [
        skip,
        dispatch,
        contentId,
        contentType,
        setContentId,
        setContentType,
        addSubscriber,
        removeSubscriber,
        subscriberId,
        delta,
        onDataReceived
    ]);
    return null;
};
module.exports["useSubscriptionEvent"] = $357775eda04c1a81$export$63ba9f3f1b368ae8;

});

parcelRegister("gzIc1", function(module, exports) {

var $jVylI = parcelRequire("jVylI");

const $bda1e030ddde07df$export$e2d610ec02a291e1 = (jsonProperty)=>{
    let value;
    try {
        value = JSON.parse(jsonProperty.value);
        // objects returned from the content property can be double stringified
        const quoteMatches = value.match(/"/g);
        const quoteCount = quoteMatches ? quoteMatches.length : 0;
        // if quoteCount != null this means that the object is double wrapped as a string and needs to be parsed again
        if (quoteCount) try {
            value = JSON.parse(value);
        } catch (error) {
            value = (0, $jVylI.defaultPropertyValue);
            throw new Error(`unable to parse value: ${error.message}`);
        }
    } catch (error) {
        value = (0, $jVylI.defaultPropertyValue);
        throw error;
    }
    return value;
};
module.exports["contentPropertyHelper"] = $bda1e030ddde07df$export$e2d610ec02a291e1;

});

parcelRegister("bSMD1", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $6SMAs = parcelRequire("6SMAs");


var $1tQnx = parcelRequire("1tQnx");


var $4IoVL = parcelRequire("4IoVL");


var $9wGTI = parcelRequire("9wGTI");

const $91a551f868bb6c9f$export$788ceca2e301e15f = (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { cloudId: cloudId, contentId: contentId, eventCallbacks: eventCallbacks, userId: userId } = t0;
    let t1;
    if ($[0] !== contentId || $[1] !== eventCallbacks) {
        t1 = {
            contentId: contentId,
            eventCallbacks: eventCallbacks
        };
        $[0] = contentId;
        $[1] = eventCallbacks;
        $[2] = t1;
    } else t1 = $[2];
    const legacyImageGeneration = (0, $6SMAs.useAIGeneratedCoverImage)(t1);
    let t2;
    if ($[3] !== cloudId || $[4] !== contentId || $[5] !== eventCallbacks || $[6] !== userId) {
        t2 = {
            cloudId: cloudId,
            contentId: contentId,
            createEditorMediaProvider: $4IoVL.createEditorMediaProvider,
            eventCallbacks: eventCallbacks,
            successfulGenerationStatus: "NOT_LOADING",
            touchpointSource: "confluence-header-image-generation",
            userId: userId
        };
        $[3] = cloudId;
        $[4] = contentId;
        $[5] = eventCallbacks;
        $[6] = userId;
        $[7] = t2;
    } else t2 = $[7];
    const remixImageGeneration = (0, $1tQnx.useRemixImageGeneration)(t2);
    if ((0, $9wGTI.fg)("header_images_migrate_image_gen_to_remix")) {
        let t3;
        if ($[8] !== remixImageGeneration) {
            t3 = {
                ...remixImageGeneration,
                data: null
            };
            $[8] = remixImageGeneration;
            $[9] = t3;
        } else t3 = $[9];
        return t3;
    }
    return legacyImageGeneration;
};
module.exports["useHeaderImageGeneration"] = $91a551f868bb6c9f$export$788ceca2e301e15f;

});

parcelRegister("6SMAs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ieeJu = parcelRequire("ieeJu");

const $2b831d8e6e40a769$var$CONVO_AI_URL = '/gateway/api/assist/api/ai/v2/ai-feature/confluence-header-image-generation';
const $2b831d8e6e40a769$export$7624fc593a548cde = ({ contentId: contentId, eventCallbacks: eventCallbacks })=>{
    const [loading, setLoading] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(null);
    const [data, setData] = (0, $cozmU.useState)(null);
    const [aiHeaderImageStatus, setAIHeaderImageStatus] = (0, $cozmU.useState)('NOT_LOADING');
    const showAcceptanceFlowRef = (0, $cozmU.useRef)(false);
    const abortControllerRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (error) {
            setAIHeaderImageStatus('ERROR');
            return;
        }
        if (loading) {
            if (showAcceptanceFlowRef.current) setAIHeaderImageStatus('LOADING_WITH_ACCEPTANCE_FLOW');
            else setAIHeaderImageStatus('LOADING');
        } else setAIHeaderImageStatus('NOT_LOADING');
    }, [
        loading,
        error
    ]);
    const generateImage = (0, $cozmU.useCallback)(async ({ adfContent: adfContent, aspectRatio: aspectRatio, imageGenerationModel: imageGenerationModel, showAcceptanceFlow: showAcceptanceFlow = false, useRawPrompt: useRawPrompt = false, theme: theme })=>{
        const eventParams = {
            contentId: contentId,
            useRawPrompt: useRawPrompt || false,
            ...theme && {
                theme: theme
            },
            ...aspectRatio && {
                aspectRatio: aspectRatio
            },
            ...imageGenerationModel && {
                imageGenerationModel: imageGenerationModel
            }
        };
        // Notify start
        eventCallbacks?.onGenerateStart?.(eventParams);
        // Abort potential ongoing request
        abortControllerRef.current?.abort();
        abortControllerRef.current = new AbortController();
        showAcceptanceFlowRef.current = showAcceptanceFlow;
        setError(null);
        setData(null);
        if (!loading) setLoading(true);
        try {
            const shouldUseAdvancedHeaderImageGeneration = (0, $ieeJu.expValEquals)('confluence_advanced_header_image_generation_exp', 'isEnabled', true);
            const request = {
                ai_feature_input: {
                    adfContent: adfContent,
                    contentId: contentId,
                    useRawPrompt: useRawPrompt,
                    ...shouldUseAdvancedHeaderImageGeneration && imageGenerationModel && {
                        imageGenerationModel: imageGenerationModel
                    },
                    ...theme !== undefined && {
                        theme: theme
                    },
                    ...aspectRatio !== undefined && {
                        aspectRatio: aspectRatio
                    }
                }
            };
            const response = await fetch($2b831d8e6e40a769$var$CONVO_AI_URL, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json;charset=UTF-8',
                    'X-Experience-Id': 'confluence-ai-first-creation',
                    'X-Product': 'confluence'
                },
                body: JSON.stringify(request),
                signal: abortControllerRef.current.signal
            });
            if (!response.ok) throw new Error(`Error fetching AI-generated cover image, status code: ${response.status}`);
            const responseData = await response.json();
            const content = responseData?.ai_feature_output;
            if (!content) {
                const noContentError = new Error('No content received from API');
                setError(noContentError.message);
                eventCallbacks?.onGenerateError?.({
                    ...eventParams,
                    error: noContentError
                });
                return;
            }
            // Check if the response contains an error in the body (API can return 200 OK with error in body)
            if (content.error) {
                const errorMessage = content.error.error_message || content.error.error_reason || 'AI image generation failed';
                const apiError = new Error(errorMessage);
                setError(errorMessage);
                eventCallbacks?.onGenerateError?.({
                    ...eventParams,
                    error: apiError
                });
                return;
            }
            const responseContent = content;
            setData(responseContent);
            // Notify success
            eventCallbacks?.onGenerateSuccess?.(eventParams);
            return responseContent.mediaFileId;
        } catch (err) {
            const isErrorType = err instanceof Error;
            // Don't set error for aborted requests
            if (isErrorType && err.name === 'AbortError') {
                eventCallbacks?.onGenerateAbort?.(eventParams);
                return;
            }
            const errorMessage = isErrorType ? err.message : 'Unknown error occurred';
            const error = isErrorType ? err : new Error(errorMessage);
            setError(errorMessage);
            eventCallbacks?.onGenerateError?.({
                ...eventParams,
                error: error
            });
        } finally{
            setLoading(false);
        }
    }, [
        contentId,
        loading,
        eventCallbacks
    ]);
    // Begin loading experience but don't generate yet
    const fakeGenerateImage = (0, $cozmU.useCallback)(()=>{
        showAcceptanceFlowRef.current = false;
        setError(null);
        setData(null);
        setLoading(true);
    }, []);
    return {
        generateImage: generateImage,
        fakeGenerateImage: fakeGenerateImage,
        loading: loading,
        error: error,
        data: data,
        aiHeaderImageStatus: aiHeaderImageStatus,
        aiHeaderImageFileId: data?.mediaFileId,
        setAIHeaderImageStatus: setAIHeaderImageStatus
    };
};
module.exports["useAIGeneratedCoverImage"] = $2b831d8e6e40a769$export$7624fc593a548cde;

});

parcelRegister("1tQnx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $g9ZnD = parcelRequire("g9ZnD");


var $ieeJu = parcelRequire("ieeJu");


var $aYC8J = parcelRequire("aYC8J");


var $iF7Yl = parcelRequire("iF7Yl");


var $lJ6db = parcelRequire("lJ6db");


var $lSM29 = parcelRequire("lSM29");

const $d4322024ea497cb0$var$PRODUCT = 'confluence';
const $d4322024ea497cb0$var$unwrapStreamMessage = (value)=>{
    if (typeof value === 'object' && value !== null && '__isSSEWrapper' in value && value.__isSSEWrapper === true && 'data' in value) return value.data;
    return value;
};
const $d4322024ea497cb0$var$getGeneratedMediaFileId = async (generator)=>{
    for await (const value of generator){
        const streamMessage = $d4322024ea497cb0$var$unwrapStreamMessage(value);
        if (streamMessage.type === 'ERROR') throw new Error(streamMessage.message?.content ?? 'Remix image generation failed');
        if (streamMessage.type === 'FINAL_RESPONSE') {
            const imageAction = streamMessage.message?.message?.actions?.find((action)=>action.key === (0, $aYC8J.IMAGE_CREATE_KEY));
            if (!(0, $aYC8J.isImageCreateData)(imageAction?.data)) throw new Error('Remix did not return a generated image');
            return imageAction.data.mediaFileId;
        }
    }
    throw new Error('Remix image generation ended without a response');
};
const $d4322024ea497cb0$var$useRemixImageGenerationWithAssistanceService = ({ contentId: contentId, createEditorMediaProvider: createEditorMediaProvider, eventCallbacks: eventCallbacks, successfulGenerationStatus: successfulGenerationStatus = 'SUCCESSFULLY_SET', userId: userId, assistanceServiceInjectedParams: { assistanceService: assistanceService } })=>{
    const [aiHeaderImageStatus, setAIHeaderImageStatus] = (0, $cozmU.useState)('NOT_LOADING');
    const [aiHeaderImageFileId, setAIHeaderImageFileId] = (0, $cozmU.useState)();
    const [error, setError] = (0, $cozmU.useState)(null);
    const activeGenerationRef = (0, $cozmU.useRef)();
    const generationSequenceRef = (0, $cozmU.useRef)(0);
    (0, $cozmU.useEffect)(()=>()=>{
            generationSequenceRef.current += 1;
            const activeGeneration = activeGenerationRef.current;
            activeGenerationRef.current = undefined;
            activeGeneration?.controller.abort();
            activeGeneration?.notifyAbort();
        }, []);
    const uploadGeneratedImage = (0, $cozmU.useCallback)(async (mediaFileId)=>{
        if (!userId) throw new Error('Cannot upload a Remix image without a user ID');
        if (!createEditorMediaProvider) throw new Error('Cannot upload a Remix image without an editor media provider');
        const mediaProvider = await createEditorMediaProvider({
            contentId: contentId,
            contentType: 'page',
            isExternalShare: false
        });
        const targetCollection = mediaProvider.uploadParams?.collection;
        if (!mediaProvider.uploadMediaClientConfig || !targetCollection) throw new Error('Editor media provider is missing upload configuration');
        const { token: token, collection: collection } = await (0, $iF7Yl.fetchMauiPersonalReadToken)($d4322024ea497cb0$var$PRODUCT);
        const sourceUrl = (0, $aYC8J.buildImageUrl)({
            fileId: mediaFileId,
            token: token.split('Bearer ')[1],
            collection: collection,
            clientId: userId,
            isStaging: (0, $lSM29.isStaging)()
        });
        const mediaClient = (0, $g9ZnD.getMediaClient)(mediaProvider.uploadMediaClientConfig);
        const result = await mediaClient.file.uploadExternal(sourceUrl, targetCollection, undefined, true);
        return result.uploadableFileUpfrontIds.id;
    }, [
        contentId,
        createEditorMediaProvider,
        userId
    ]);
    const generateImage = (0, $cozmU.useCallback)(async ({ adfContent: adfContent, aspectRatio: aspectRatio, imageGenerationModel: imageGenerationModel, showAcceptanceFlow: showAcceptanceFlow = false, theme: theme, useRawPrompt: useRawPrompt = false })=>{
        const generationSequence = ++generationSequenceRef.current;
        const previousGeneration = activeGenerationRef.current;
        previousGeneration?.controller.abort();
        previousGeneration?.notifyAbort();
        const conversationId = crypto.randomUUID();
        const abortController = new AbortController();
        const eventParams = {
            contentId: contentId,
            useRawPrompt: useRawPrompt,
            ...theme && {
                theme: theme
            },
            ...aspectRatio && {
                aspectRatio: aspectRatio
            },
            ...imageGenerationModel && {
                imageGenerationModel: imageGenerationModel
            }
        };
        let abortNotified = false;
        const notifyAbort = ()=>{
            if (!abortNotified) {
                abortNotified = true;
                eventCallbacks?.onGenerateAbort?.(eventParams);
            }
        };
        activeGenerationRef.current = {
            controller: abortController,
            notifyAbort: notifyAbort
        };
        setAIHeaderImageFileId(undefined);
        setError(null);
        setAIHeaderImageStatus(showAcceptanceFlow ? 'LOADING_WITH_ACCEPTANCE_FLOW' : 'LOADING');
        eventCallbacks?.onGenerateStart?.(eventParams);
        const prompt = {
            type: 'doc',
            version: 1,
            content: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: adfContent
                        }
                    ]
                }
            ]
        };
        const dynamicUiSource = {
            contentType: 'page',
            startLocalId: '',
            endLocalId: '',
            startIndex: 0,
            endIndex: -1,
            fragmentAdf: prompt.content,
            fullAdf: prompt
        };
        try {
            const creationContext = {
                dynamicUiType: 'image',
                dynamicUiSubtype: theme ?? 'image',
                dynamicUiSource: dynamicUiSource,
                source: 'remix',
                isStagingArea: true,
                productKey: $d4322024ea497cb0$var$PRODUCT,
                isViewMode: false,
                ...(0, $ieeJu.expValEquals)('rovo_remix_experience_context', 'isEnabled', true) ? {
                    experience: 'remix',
                    blocks: [
                        'image'
                    ]
                } : {},
                ...aspectRatio ? {
                    additionalContext: {
                        aspectRatio: aspectRatio
                    }
                } : {}
            };
            const { generator: generator } = await assistanceService.sendMessageStream({
                message: prompt,
                conversationId: conversationId,
                controller: abortController,
                storeMessage: false,
                citationsEnabled: true,
                optInSSEStream: true,
                additionalContext: {
                    creationContext: creationContext,
                    userTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone
                }
            });
            const temporaryMediaFileId = await $d4322024ea497cb0$var$getGeneratedMediaFileId(generator);
            const generatedImageId = await uploadGeneratedImage(temporaryMediaFileId);
            if (abortController.signal.aborted || generationSequence !== generationSequenceRef.current) {
                notifyAbort();
                return successfulGenerationStatus === 'NOT_LOADING' ? undefined : generatedImageId;
            }
            setAIHeaderImageFileId(generatedImageId);
            setAIHeaderImageStatus(successfulGenerationStatus);
            eventCallbacks?.onGenerateSuccess?.(eventParams);
            return generatedImageId;
        } catch (generationError) {
            const normalizedError = generationError instanceof Error ? generationError : new Error('Unknown error occurred');
            const isCurrentGeneration = generationSequence === generationSequenceRef.current;
            if (abortController.signal.aborted || normalizedError.name === 'AbortError' || !isCurrentGeneration) {
                notifyAbort();
                if (isCurrentGeneration) {
                    if (successfulGenerationStatus === 'NOT_LOADING') setAIHeaderImageStatus('NOT_LOADING');
                    else {
                        // Preserve the existing default Remix behaviour for non-header consumers.
                        setError(normalizedError.message);
                        setAIHeaderImageStatus('ERROR');
                    }
                }
                return undefined;
            }
            setError(normalizedError.message);
            setAIHeaderImageStatus('ERROR');
            eventCallbacks?.onGenerateError?.({
                ...eventParams,
                error: normalizedError
            });
            return undefined;
        } finally{
            if (activeGenerationRef.current?.controller === abortController) activeGenerationRef.current = undefined;
        }
    }, [
        assistanceService,
        contentId,
        eventCallbacks,
        successfulGenerationStatus,
        uploadGeneratedImage
    ]);
    // Begin the loading experience before an AIFC title is available to generate from.
    const fakeGenerateImage = (0, $cozmU.useCallback)(()=>{
        setAIHeaderImageFileId(undefined);
        setError(null);
        setAIHeaderImageStatus('LOADING');
    }, []);
    return {
        generateImage: generateImage,
        fakeGenerateImage: fakeGenerateImage,
        loading: aiHeaderImageStatus === 'LOADING' || aiHeaderImageStatus === 'LOADING_WITH_ACCEPTANCE_FLOW',
        error: error,
        aiHeaderImageStatus: aiHeaderImageStatus,
        aiHeaderImageFileId: aiHeaderImageFileId,
        setAIHeaderImageStatus: setAIHeaderImageStatus
    };
};
const $d4322024ea497cb0$var$useRemixImageGenerationWithService = (0, $lJ6db.createHookWithAssistanceService)($d4322024ea497cb0$var$useRemixImageGenerationWithAssistanceService);
const $d4322024ea497cb0$export$1b9537157fec4b30 = (props)=>$d4322024ea497cb0$var$useRemixImageGenerationWithService({
        ...props,
        assistanceServiceParams: {
            product: $d4322024ea497cb0$var$PRODUCT,
            experienceId: 'ai-mate',
            siteId: props.cloudId,
            touchpointSource: props.touchpointSource ?? 'company-hub-image-generation'
        }
    });
module.exports["useRemixImageGeneration"] = $d4322024ea497cb0$export$1b9537157fec4b30;

});

parcelRegister("iF7Yl", function(module, exports) {
const $006c5a8383b762f1$var$MAUI_PERSONAL_READ_TOKEN_PATH = '/gateway/api/assist/rovo/v1/maui/media/personal-read-token';
async function $006c5a8383b762f1$export$c64afe9f7c18b7d9(productHeader, cloudId) {
    const response = await fetch($006c5a8383b762f1$var$MAUI_PERSONAL_READ_TOKEN_PATH, {
        method: 'GET',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'X-Product': productHeader,
            // Backend requires the site id; without it the request 400s and no image renders.
            ...cloudId ? {
                'X-Cloudid': cloudId
            } : {}
        }
    });
    if (!response.ok) throw new Error(`Failed to fetch MAUI personal read token: ${response.status} ${response.statusText}`);
    const data = await response.json();
    return {
        token: data.token,
        collection: data.collection
    };
}
module.exports["fetchMauiPersonalReadToken"] = $006c5a8383b762f1$export$c64afe9f7c18b7d9;

});

parcelRegister("lSM29", function(module, exports) {
/**
 * Environment detection utilities for the viz package
 */ /**
 * Checks if the current environment is local development
 */ const $06a8047ea97c648d$export$96081e27c2a95b0 = ()=>{
    if (typeof window === 'undefined') // Server-side rendering or Node.js environment
    return false;
    const host = window.location.host;
    return host.includes('localhost') || host.includes('127.0.0.1') || host.includes('0.0.0.0');
};
const $06a8047ea97c648d$export$23da1d24a38b0bde = ()=>{
    if (typeof window === 'undefined') return false;
    const host = window.location.host;
    return host.includes('.stg.atlassian') || host.includes('.stg-east.frontend.public.atl-paas.net') || host.includes('jira-dev.com') || host.includes('trellis.coffee');
};
const $06a8047ea97c648d$export$f15d00aa73aafac4 = ()=>{
    return !$06a8047ea97c648d$export$96081e27c2a95b0() && !$06a8047ea97c648d$export$23da1d24a38b0bde();
};
module.exports["isStaging"] = $06a8047ea97c648d$export$23da1d24a38b0bde;

});

parcelRegister("LSims", function(module, exports) {

var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $aJUpe = parcelRequire("aJUpe");


var $4Pmcr = parcelRequire("4Pmcr");

const $450638ee7a6e2e59$export$ec80b976b56288ba = (contentId)=>{
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $aJUpe.default), {
        variables: {
            contentId: contentId ?? '',
            isMarkdownModeEnabled: (0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true)
        },
        fetchPolicy: 'cache-only',
        skip: !contentId || !(0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true),
        __callerPackage__: "content-markdown-mode"
    });
    return (0, $4Pmcr.getIsMarkdownModeFromData)(data);
};
module.exports["useIsMarkdownMode"] = $450638ee7a6e2e59$export$ec80b976b56288ba;

});

parcelRegister("aJUpe", function(module, exports) {
/**
 * @generated SignedSource<<97f042394447b34381d2572432982113>>
 * @relayHash 8ee1f0cde2475ae17a8f029f978204ad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1279c7f0b2788c28fc2ea16597139729f5d965c3d36268a5b7ab174d923c6971
const $1180c416e2ce3051$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isMarkdownModeEnabled"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PublishedContentProperties",
                                    "kind": "LinkedField",
                                    "name": "latest",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isMarkdownModeEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isMarkdownMode"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "IsMarkdownModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "IsMarkdownModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8ee1f0cde2475ae17a8f029f978204ad",
            "id": "1279c7f0b2788c28fc2ea16597139729f5d965c3d36268a5b7ab174d923c6971",
            "metadata": {},
            "name": "IsMarkdownModeQuery",
            "operationKind": "query",
            "text": "query IsMarkdownModeQuery($contentId:ID!,$isMarkdownModeEnabled:Boolean=false){content(id:$contentId){nodes{id,contentProperties{latest{isMarkdownMode@include(if:$isMarkdownModeEnabled)}}}}}"
        }
    };
}();
$1180c416e2ce3051$var$node.hash = "65f92bc360aa57691987c1aba7d545ca";
var $1180c416e2ce3051$export$2e2bcd8739ae039 = $1180c416e2ce3051$var$node;
module.exports["default"] = $1180c416e2ce3051$export$2e2bcd8739ae039;

});

parcelRegister("4Pmcr", function(module, exports) {
const $70bbf1741b7230f7$export$6bc4ac71fcf3f02a = (data)=>{
    return data?.content?.nodes?.[0]?.contentProperties?.latest?.isMarkdownMode ?? false;
};
module.exports["getIsMarkdownModeFromData"] = $70bbf1741b7230f7$export$6bc4ac71fcf3f02a;

});

parcelRegister("aK0Eq", function(module, exports) {
// Key values can be found in https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values
const $a70f9d70060bc7e5$export$dc9060896f547e2b = {
    ALT: {
        key: 'Alt',
        which: 18
    },
    BACKSPACE: {
        key: 'Backspace',
        which: 8
    },
    CTRL: {
        key: 'Control',
        which: 17
    },
    DELETE: {
        key: 'Delete',
        which: 46
    },
    DOWN: {
        key: 'ArrowDown',
        which: 40
    },
    END: {
        key: 'End',
        which: 35
    },
    ENTER: {
        key: 'Enter',
        which: 13
    },
    ESCAPE: {
        key: 'Escape',
        which: 27
    },
    HOME: {
        key: 'Home',
        which: 36
    },
    INSERT: {
        key: 'Insert',
        which: 45
    },
    LEFT: {
        key: 'ArrowLeft',
        which: 37
    },
    /**
	 * Command key on OSX, WinKey on Windows.
	 * On windows, the "Windows" home button is considered
	 * the "meta" key, but many browsers don't register that event
	 * as it is intercepted by the operating system. If referencing
	 * this key, you should also consider allowing "ctrl" key.
	 */ META: {
        key: 'Meta',
        which: 91
    },
    PAGEDOWN: {
        key: 'PageDown',
        which: 34
    },
    PAGEUP: {
        key: 'PageUp',
        which: 33
    },
    RIGHT: {
        key: 'ArrowRight',
        which: 39
    },
    SPACE: {
        key: ' ',
        which: 32
    },
    SHIFT: {
        key: 'Shift',
        which: 16
    },
    TAB: {
        key: 'Tab',
        which: 9
    },
    UP: {
        key: 'ArrowUp',
        which: 38
    }
};
module.exports["KeyboardEventKeys"] = $a70f9d70060bc7e5$export$dc9060896f547e2b;

});

parcelRegister("kSPGK", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

class $5d6af3820d303892$var$OptimisticTitleChangeEventBus {
    emit(contentId, title) {
        if (this.listeners[contentId]) this.listeners[contentId].forEach((fn)=>{
            fn(title);
        });
    }
    subscribe(contentId, fn) {
        if (!this.listeners[contentId]) this.listeners[contentId] = [];
        this.listeners[contentId].push(fn);
    }
    unsubcribe(contentId, fn) {
        if (this.listeners[contentId]) {
            const index = this.listeners[contentId].findIndex((item)=>item[0] === fn);
            if (index !== -1) this.listeners[contentId].splice(index, 1);
        }
    }
    constructor(){
        this.listeners = void 0;
        this.listeners = {};
    }
}
const $5d6af3820d303892$var$optimisticTitleChangeEventBus = new $5d6af3820d303892$var$OptimisticTitleChangeEventBus();
const $5d6af3820d303892$export$255638cdf0226b65 = (contentId, initialTitle, onOptimisticUpdate)=>{
    const $ = (0, $bDgLe.c)(16);
    const [optimisticTitle, setOptimisticTitle] = (0, $cozmU.useState)(initialTitle);
    let t0;
    if ($[0] !== contentId || $[1] !== optimisticTitle) {
        t0 = (value)=>{
            if (value !== optimisticTitle) $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.emit(contentId, value);
        };
        $[0] = contentId;
        $[1] = optimisticTitle;
        $[2] = t0;
    } else t0 = $[2];
    const publishOptimisticTitle = t0;
    let t1;
    if ($[3] !== contentId || $[4] !== onOptimisticUpdate) {
        t1 = (title)=>{
            setOptimisticTitle(title);
            onOptimisticUpdate && onOptimisticUpdate(contentId, title);
        };
        $[3] = contentId;
        $[4] = onOptimisticUpdate;
        $[5] = t1;
    } else t1 = $[5];
    const handleTitleChanged = t1;
    let t2;
    let t3;
    if ($[6] !== contentId || $[7] !== handleTitleChanged) {
        t2 = ()=>{
            $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.subscribe(contentId, handleTitleChanged);
            return ()=>{
                $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.unsubcribe(contentId, handleTitleChanged);
            };
        };
        t3 = [
            contentId,
            handleTitleChanged
        ];
        $[6] = contentId;
        $[7] = handleTitleChanged;
        $[8] = t2;
        $[9] = t3;
    } else {
        t2 = $[8];
        t3 = $[9];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[10] !== initialTitle) {
        t4 = ()=>{
            setOptimisticTitle(initialTitle);
        };
        t5 = [
            initialTitle
        ];
        $[10] = initialTitle;
        $[11] = t4;
        $[12] = t5;
    } else {
        t4 = $[11];
        t5 = $[12];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[13] !== optimisticTitle || $[14] !== publishOptimisticTitle) {
        t6 = {
            optimisticTitle: optimisticTitle,
            setOptimisticTitle: publishOptimisticTitle
        };
        $[13] = optimisticTitle;
        $[14] = publishOptimisticTitle;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
};
module.exports["useOptimisticTitleChange"] = $5d6af3820d303892$export$255638cdf0226b65;

});

parcelRegister("jhwJP", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $8e78cdefc122a0a9$export$d1326a8d9df930b6 = (i18nBase, i18nLiveDocs)=>{
    const initializeData = (targetObj)=>{
        targetObj._data = (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? {
            ...i18nBase,
            ...i18nLiveDocs
        } : i18nBase;
        targetObj._initialized = true;
    };
    return new Proxy({}, {
        get: (targetObj, prop)=>{
            // Ensures retrieval of properties on i18n object use i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return targetObj._data[prop];
        },
        ownKeys: (targetObj)=>{
            // ensures `.keys` uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return Reflect.ownKeys(targetObj._data);
        },
        has: (targetObj, prop)=>{
            // Ensures for...in uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return prop in targetObj._data;
        },
        getOwnPropertyDescriptor: (targetObj, prop)=>{
            // Ensures i18n props are enumerable, required for ownKeys/etc to work
            if (!targetObj._initialized) initializeData(targetObj);
            const descriptor = Object.getOwnPropertyDescriptor(targetObj._data, prop);
            return descriptor ? {
                ...descriptor,
                enumerable: true
            } : undefined;
        }
    });
};
module.exports["mergeLiveDocI18n"] = $8e78cdefc122a0a9$export$d1326a8d9df930b6;

});

parcelRegister("kycWk", function(module, exports) {
// Extension
const $a7399ed0bcbe7ac9$export$ebe904a0bbf57df1 = 'com.atlassian.guard-premium';
const $a7399ed0bcbe7ac9$export$d20f6356992396b7 = 'false';
var $a7399ed0bcbe7ac9$export$80edbf15fa61a4db = /*#__PURE__*/ function(MessageType) {
    MessageType["Engagement"] = "engagement";
    MessageType["Transactional"] = "transactional";
    return MessageType;
}({});
var $a7399ed0bcbe7ac9$export$ca2bc0ed0fbb9a2a = /*#__PURE__*/ function(RedactionsTourSteps) {
    RedactionsTourSteps[RedactionsTourSteps["FIRST"] = 0] = "FIRST";
    RedactionsTourSteps[RedactionsTourSteps["SECOND"] = 1] = "SECOND";
    return RedactionsTourSteps;
}({});
const $a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX = 'redactions-tour:';
const $a7399ed0bcbe7ac9$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX = 'object-sidebar-tour-target:';
const $a7399ed0bcbe7ac9$export$4ac8baee730e0515 = {
    REDACTION_EXTENSION: `${$a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX}redaction-extension`,
    TITLE_REDACTION: `${$a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX}title-redaction`,
    // Note: SpotlightTarget already exist on this element, so we must target that one
    SIDEBAR_DETAILS_BUTTON: `${$a7399ed0bcbe7ac9$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}sidebar-details-button`
};
const $a7399ed0bcbe7ac9$export$765a9736cc8e2d1f = 'https://support.atlassian.com/confluence-cloud/docs/how-redaction-works/';
module.exports["REDACTION_EXTENSION_TYPE"] = $a7399ed0bcbe7ac9$export$ebe904a0bbf57df1;
module.exports["IS_DISMISSED_FLAG"] = $a7399ed0bcbe7ac9$export$d20f6356992396b7;
module.exports["MessageType"] = $a7399ed0bcbe7ac9$export$80edbf15fa61a4db;
module.exports["RedactionsTourSteps"] = $a7399ed0bcbe7ac9$export$ca2bc0ed0fbb9a2a;
module.exports["REDACTIONS_TOUR_TARGETS"] = $a7399ed0bcbe7ac9$export$4ac8baee730e0515;
module.exports["READ_MORE_URL"] = $a7399ed0bcbe7ac9$export$765a9736cc8e2d1f;

});

parcelRegister("iuuqT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");


var $lsxnT = parcelRequire("lsxnT");


var $aWwYt = parcelRequire("aWwYt");


var $ep3mz = parcelRequire("ep3mz");


var $lfBMY = parcelRequire("lfBMY");


var $2wo33 = parcelRequire("2wo33");


var $8Lx5S = parcelRequire("8Lx5S");


var $kycWk = parcelRequire("kycWk");


var $gsf3i = parcelRequire("gsf3i");

const { IS_REDACTIONS_TOUR_VISIBLE: $cbee4c9267979126$var$IS_REDACTIONS_TOUR_VISIBLE } = (0, $dBcar.ONBOARDING_EXPERIENCES);
const $cbee4c9267979126$var$i18n = (0, $kSwu1.defineMessages)({
    stepOfSteps: {
        id: "redactions.redactions-tour.steps",
        defaultMessage: "{step}/{steps}"
    },
    dismiss: {
        id: "redactions.redactions-tour.dismiss",
        defaultMessage: "Dismiss"
    },
    next: {
        id: "redactions.redactions-tour.next",
        defaultMessage: "Next"
    },
    ok: {
        id: "redactions.redactions-tour.ok",
        defaultMessage: "OK"
    },
    readMore: {
        id: "redactions.redactions-tour.read-more",
        defaultMessage: "Read more"
    },
    solidBarIndicates: {
        id: "redactions.redactions-tour.solid-bar-indicates",
        defaultMessage: "The solid bar indicates that your organization detected and deleted sensitive data."
    },
    goToRedactions: {
        id: "redactions.redactions-tour.go-to-redactions",
        defaultMessage: "Go to Redactions in this menu to view details about the redactions on this page."
    }
});
const $cbee4c9267979126$var$useSpotlights = ({ next: next, end: end, tourStartsInTitle: tourStartsInTitle })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const firstSpotlightKeyTarget = tourStartsInTitle ? (0, $kycWk.REDACTIONS_TOUR_TARGETS).TITLE_REDACTION : (0, $kycWk.REDACTIONS_TOUR_TARGETS).REDACTION_EXTENSION;
    return [
        {
            key: firstSpotlightKeyTarget,
            target: firstSpotlightKeyTarget,
            messageType: (0, $kycWk.MessageType).Engagement,
            actionsBeforeElement: formatMessage($cbee4c9267979126$var$i18n.stepOfSteps, {
                step: 1,
                steps: 2
            }),
            targetRadius: 3,
            actions: [
                {
                    text: formatMessage($cbee4c9267979126$var$i18n.next),
                    onClick: next
                },
                {
                    text: formatMessage($cbee4c9267979126$var$i18n.dismiss),
                    onClick: end
                }
            ],
            children: formatMessage($cbee4c9267979126$var$i18n.solidBarIndicates)
        },
        {
            key: (0, $kycWk.REDACTIONS_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
            target: (0, $kycWk.REDACTIONS_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
            messageType: (0, $kycWk.MessageType).Transactional,
            actionsBeforeElement: formatMessage($cbee4c9267979126$var$i18n.stepOfSteps, {
                step: 2,
                steps: 2
            }),
            targetRadius: 100,
            actions: [
                {
                    text: formatMessage($cbee4c9267979126$var$i18n.ok),
                    onClick: end
                },
                {
                    text: formatMessage($cbee4c9267979126$var$i18n.readMore),
                    href: (0, $kycWk.READ_MORE_URL),
                    target: '_blank'
                }
            ],
            children: formatMessage($cbee4c9267979126$var$i18n.goToRedactions)
        }
    ];
};
var $cbee4c9267979126$export$f5d398bf946a6bf8 = /*#__PURE__*/ function(RedactionTourStepSource) {
    RedactionTourStepSource["bodyRedaction"] = "bodyRedaction";
    RedactionTourStepSource["titleRedaction"] = "titleRedaction";
    return RedactionTourStepSource;
}({});
const $cbee4c9267979126$export$9b351a5d16cec916 = ({ contentId: contentId, step: step, firstStepSource: firstStepSource = "bodyRedaction" })=>{
    const { sidebarControlState: sidebarControlState } = (0, $aWwYt.useObjectSidebarState)();
    const [{ activeSpotlightIndex: activeSpotlightIndex, lastActiveSpotlightIndex: lastActiveSpotlightIndex, firstRedactionIdRendered: firstRedactionIdRendered, titleRedactionRenderedForContentId: titleRedactionRenderedForContentId }, { concludeTour: endTour, proceedToNext: proceedToNext, initiateTour: initiateTour, resetTour: resetTour, setFirstRedactionIdRendered: setFirstRedactionIdRendered, setTitleRedactionRenderedForContentId: setTitleRedactionRenderedForContentId }] = (0, $gsf3i.useRedactionsTourState)();
    const isFirstTourTargetVisible = firstStepSource === "bodyRedaction" ? step === 0 && firstRedactionIdRendered && !titleRedactionRenderedForContentId : step === 0 && titleRedactionRenderedForContentId === contentId; // otherwise, it's a title redaction
    const isSecondTourTargetVisible = sidebarControlState === 'shown';
    const [contentType] = (0, $ep3mz.useContentType)();
    const canUpdateContent = (0, $2wo33.useCanPerformContentOperation)({
        contentId: contentId ?? '',
        contentType: contentType,
        operation: (0, $lfBMY.OperationTypes).UPDATE
    });
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { data: onboardingStateData, error: onboardingStateError, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)($cbee4c9267979126$var$IS_REDACTIONS_TOUR_VISIBLE, false);
    const isTourOnboardingStateCompleted = onboardingStateData?.onboardingState?.some(({ key: key, value: value })=>{
        return key === $cbee4c9267979126$var$IS_REDACTIONS_TOUR_VISIBLE && value === (0, $kycWk.IS_DISMISSED_FLAG);
    });
    const isTourCompleted = !onboardingStateError && !onboardingStateLoading && isTourOnboardingStateCompleted;
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const concludeTour = (0, $cozmU.useCallback)(()=>{
        endTour();
        setOnboardingState({
            key: $cbee4c9267979126$var$IS_REDACTIONS_TOUR_VISIBLE,
            value: (0, $kycWk.IS_DISMISSED_FLAG)
        });
    }, [
        endTour,
        setOnboardingState
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isFirstTourTargetVisible && isSecondTourTargetVisible && !isTourCompleted && !onboardingStateError && !onboardingStateLoading && isLicensed && canUpdateContent) setTimeout(()=>{
            initiateTour();
        }, 0);
    }, [
        initiateTour,
        isFirstTourTargetVisible,
        isSecondTourTargetVisible,
        isTourCompleted,
        onboardingStateError,
        onboardingStateLoading,
        isLicensed,
        canUpdateContent
    ]);
    const spotlights = $cbee4c9267979126$var$useSpotlights({
        next: proceedToNext,
        end: concludeTour,
        tourStartsInTitle: !!titleRedactionRenderedForContentId
    });
    return {
        activeSpotlight: activeSpotlightIndex === step ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Spotlight, {
            dialogPlacement: "bottom right",
            shouldWatchTarget: true // Note: problematic layout shifts for both spotlights
            ,
            targetBgColor: "var(--ds-surface-raised, #FFFFFF)",
            ...spotlights[activeSpotlightIndex]
        }) : null,
        initiateTour: initiateTour,
        proceedToNext: proceedToNext,
        concludeTour: concludeTour,
        resetTour: resetTour,
        activeSpotlightIndex: activeSpotlightIndex,
        lastActiveSpotlightIndex: lastActiveSpotlightIndex,
        isTourCompleted: isTourCompleted,
        setFirstRedactionIdRendered: setFirstRedactionIdRendered,
        setTitleRedactionRenderedForContentId: setTitleRedactionRenderedForContentId // Note: mainly here for testing purposes
    };
};
module.exports["RedactionTourStepSource"] = $cbee4c9267979126$export$f5d398bf946a6bf8;
module.exports["useRedactionsTour"] = $cbee4c9267979126$export$9b351a5d16cec916;

});

parcelRegister("dBcar", function(module, exports) {
const $3c94963df51c0e13$export$4ddca8f5712d2331 = 'onboarding-state:';
const $3c94963df51c0e13$export$f35f2899eb1390e3 = 'peopleNudge';
const $3c94963df51c0e13$export$532485ca1547f1aa = 'legacy';
const $3c94963df51c0e13$export$31c8494ea74d2536 = 'introWorkflow';
const $3c94963df51c0e13$export$1f72e9a162b3795b = 'firstSpaceSelected';
const $3c94963df51c0e13$export$6315bee451a9fcc6 = 'teamSpaceCreated';
const $3c94963df51c0e13$export$c4e14780cf349e73 = 'xflowSpaceCreated';
const $3c94963df51c0e13$export$275d3dda87d2fa7a = 'nthUserOnboardingCompletedTimestamp';
const $3c94963df51c0e13$export$da223e550b96c9d6 = 'help';
const $3c94963df51c0e13$export$ffb6b379ff35f9e = 'onboardingIntents';
const $3c94963df51c0e13$export$d3276a0d758ffd2b = 'isFoundingAdmin';
const $3c94963df51c0e13$export$756b1a5a6b2488c3 = 'isSampleContentV2SpotlightVisible';
const $3c94963df51c0e13$export$8e5a8e09b19b20a8 = 'isMoreActionsTourVisible';
const $3c94963df51c0e13$export$2e10b71f921ae144 = 'isMoreActionsHintVisible';
const $3c94963df51c0e13$export$82fe49566957c443 = 'landOnPath';
const $3c94963df51c0e13$export$f6c79e39ab4496db = 'templateOnboardingViewedTime';
const $3c94963df51c0e13$export$49ac0bbeb4be0a06 = {
    ONBOARDING_INTENT_EXPERIENCES_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceClosed',
    ONBOARDING_EXPERIENCE_ELIGIBLE: 'onboarding-intent-experience:isOnboardingExperienceEligibleUser',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_VIEWED_AT: 'onboarding-intent-experiences:onboardingIntentExperienceLandViewedAt',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceLandClosed'
};
const $3c94963df51c0e13$export$6167e5b70dfd11d9 = {
    MODAL_SEEN: 'onboarding-reverse-trial:isModalSeen'
};
const $3c94963df51c0e13$export$49c044e5e3ccc2af = {
    EXPERIMENT_ELIGIBLE: 'templates-collection:isTaggedForTemplatesCollectionExperiment',
    EXPERIMENT_DISMISSED: 'templates-collection:isTemplatesSectionDismissed'
};
const $3c94963df51c0e13$export$dcbccfe8799c3c7b = {
    IS_DISMISSED: 'space-getting-started-tour:tourIsDismissed'
};
const $3c94963df51c0e13$export$305c55ea55928edf = {
    HAS_INVITE_CAPABILITIES: 'persistent-invite:hasInviteCapabilities'
};
const $3c94963df51c0e13$export$8b7e53c326da02ac = 'improvedGetStartedPath';
const $3c94963df51c0e13$export$cfc1794f56ac0d83 = 'improvedGetStartedWhiteboardPath';
const $3c94963df51c0e13$export$39a89660e80fa1a = 'isRedactionsTourVisible';
const $3c94963df51c0e13$export$b99b309b286adebc = 'nav4:isNav4GlobalSpotlightDismissed';
const $3c94963df51c0e13$export$20b0548cf5859d6 = 'nav4:isNav4SpaceTourDismissed';
const $3c94963df51c0e13$export$4d93dfc1d8538d55 = 'nav4:isNav4CollapseReminderSpotlightDismissed';
const $3c94963df51c0e13$export$94a4264abda026cc = 'creation-focused-nav:shouldShowSpotlight';
const $3c94963df51c0e13$export$f0597adb063e4c38 = 'creation-focused-nav:startTime';
const $3c94963df51c0e13$export$7ed75560092630f6 = {
    IS_SPOTLIGHT_DISMISS: 'whats-new-in-confluence:isWhatsNewInConfluneceSpotlightDismissed',
    PULSE_SEEN_AT: 'whats-new-in-confluence:whatsNewInConfluencePulseSeenAt'
};
const $3c94963df51c0e13$export$6c014427ebb0cbae = {
    HAS_SEEN_SPLASH_MODAL: 'create-with-rovo-announcement-splash:hasSeenSplashModal'
};
const $3c94963df51c0e13$export$ebacd4ef7f5400e2 = {
    CHAT_AUTO_OPENED: 'welcome-from-rovo:chatAutoOpened'
};
const $3c94963df51c0e13$export$d1ec748fb682ca97 = {
    NTH_USER_SELECTED_CONTENT_TYPE: 'nth-user-setup:nthUserSelectedContentType',
    NTH_USER_CONTENT_TYPE_SPOTLIGHT_SEEN: 'nth-user-setup:nthUserContentTypeSpotlightSeen',
    NTH_USER_CONTENT_TYPE_POPULAR_CONTENT_FOUND: 'nth-user-setup:nthUserContentTypePopularContentFound',
    NTH_USER_CONTENT_TYPE_LANDING_CONTENT_ID: 'nth-user-setup:nthUserContentTypeLandingContentId'
};
const $3c94963df51c0e13$export$1a3a43cef0acd011 = {
    PROMPT_DISMISSED: 'prompt-whiteboard-competitor-link:isPromptDismissed'
};
const $3c94963df51c0e13$export$5b471e2344a37be7 = {
    DISMISSED: 'prompt-database-competitor-link:isPromptDatabaseDismissed'
};
const $3c94963df51c0e13$export$c81223a0ce3b63df = {
    HAS_AUTO_FOLLOWED_SPACES: 'nth-user-auto-follow-spaces:hasAutoFollowedSpaces'
};
const $3c94963df51c0e13$export$f1328b04dc902e1f = {
    REVAMPED_BPQA_SHOWN_AT: 'land-users-in-editor-with-revamped-bpqa:revampedBpqaShownAt'
};
const $3c94963df51c0e13$export$e986b94fd54d134 = {
    SELECTED_TEMPLATES: 'use-cases-nth-user-onboarding:selectedTemplates',
    VIEWED_AT: 'use-cases-nth-user-onboarding:viewedAt',
    DISMISSED_HEADER: 'use-cases-nth-user-onboarding:headerDismissed',
    VIEWED_HEADER: 'use-cases-nth-user-onboarding:headerViewedAt'
};
const $3c94963df51c0e13$export$bbdc3607431bd9d3 = {
    EMOJI_TITLE_DISCOVERED: 'auto-page-emoji:emojiTitleDiscovered'
};
const $3c94963df51c0e13$export$31a43870c77aad50 = {
    // Retained only as a guard for cfind_5565_creation_focused_nav_xflow eligibility.
    // Remove this key when cleaning up that xflow experiment.
    NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE: 'simplify-nav-new-user:nthUserD0SimplifiedNavEligible'
};
const $3c94963df51c0e13$export$400b215814bf3fc0 = {
    CHECKED_ELIGIBLE: 'creation-focused-nav-xflow:creationFocusedNavXflowCheckedEligible',
    START_AT: 'creation-focused-nav-xflow:creationFocusedNavXflowStartAt'
};
const $3c94963df51c0e13$export$94df39cf9e5d9804 = {
    TRENDING_PAGES: 'cross-join-nth-user-onboarding:trendingPages',
    DISMISSED: 'cross-join-nth-user-onboarding:dismissed'
};
const $3c94963df51c0e13$export$bfeb2da96277b623 = {
    INTRO_WORKFLOW: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$31c8494ea74d2536}`,
    LEGACY_ONBOARDING_STATE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$532485ca1547f1aa}`,
    IS_FOUNDING_ADMIN: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$d3276a0d758ffd2b}`,
    IS_SAMPLE_CONTENT_V2_SPOTLIGHT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$756b1a5a6b2488c3}`,
    LAND_ON_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$82fe49566957c443}`,
    TEAM_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$6315bee451a9fcc6}`,
    IS_MORE_ACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8e5a8e09b19b20a8}`,
    IS_MORE_ACTIONS_HINT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$2e10b71f921ae144}`,
    IMPROVED_GET_STARTED_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8b7e53c326da02ac}`,
    IMPROVED_GET_STARTED_WHITEBOARD_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$cfc1794f56ac0d83}`,
    IS_REDACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$39a89660e80fa1a}`,
    XFLOW_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$c4e14780cf349e73}`,
    TEMPLATE_ONBOARDING_VIEWED_TIME: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$f6c79e39ab4496db}`,
    NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$275d3dda87d2fa7a}`
};
const $3c94963df51c0e13$export$1660a2d7c2fff354 = '__complete__';
const $3c94963df51c0e13$export$66aa87593037fd4a = $3c94963df51c0e13$export$bfeb2da96277b623.LEGACY_ONBOARDING_STATE;
const $3c94963df51c0e13$export$d4f5dd2b883b8982 = [
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38,
    $3c94963df51c0e13$export$31a43870c77aad50.NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE
];
const $3c94963df51c0e13$export$7a13c575f2c75084 = [
    ...Object.values($3c94963df51c0e13$export$49ac0bbeb4be0a06),
    ...Object.values($3c94963df51c0e13$export$6167e5b70dfd11d9),
    ...Object.values($3c94963df51c0e13$export$49c044e5e3ccc2af),
    ...Object.values($3c94963df51c0e13$export$dcbccfe8799c3c7b),
    ...Object.values($3c94963df51c0e13$export$305c55ea55928edf),
    $3c94963df51c0e13$export$b99b309b286adebc,
    $3c94963df51c0e13$export$20b0548cf5859d6,
    $3c94963df51c0e13$export$4d93dfc1d8538d55,
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38,
    ...Object.values($3c94963df51c0e13$export$7ed75560092630f6),
    ...Object.values($3c94963df51c0e13$export$6c014427ebb0cbae),
    ...Object.values($3c94963df51c0e13$export$ebacd4ef7f5400e2),
    ...Object.values($3c94963df51c0e13$export$d1ec748fb682ca97),
    ...Object.values($3c94963df51c0e13$export$1a3a43cef0acd011),
    ...Object.values($3c94963df51c0e13$export$5b471e2344a37be7),
    ...Object.values($3c94963df51c0e13$export$bfeb2da96277b623),
    ...Object.values($3c94963df51c0e13$export$c81223a0ce3b63df),
    ...Object.values($3c94963df51c0e13$export$f1328b04dc902e1f),
    ...Object.values($3c94963df51c0e13$export$e986b94fd54d134),
    ...Object.values($3c94963df51c0e13$export$bbdc3607431bd9d3),
    ...Object.values($3c94963df51c0e13$export$31a43870c77aad50),
    ...Object.values($3c94963df51c0e13$export$400b215814bf3fc0),
    ...Object.values($3c94963df51c0e13$export$94df39cf9e5d9804)
];
module.exports["ONBOARDING_INTENT_EXPERIENCES"] = $3c94963df51c0e13$export$49ac0bbeb4be0a06;
module.exports["TEMPLATES_COLLECTION"] = $3c94963df51c0e13$export$49c044e5e3ccc2af;
module.exports["PERSISTENT_INVITE"] = $3c94963df51c0e13$export$305c55ea55928edf;
module.exports["IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED"] = $3c94963df51c0e13$export$4d93dfc1d8538d55;
module.exports["CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT"] = $3c94963df51c0e13$export$94a4264abda026cc;
module.exports["CREATION_FOCUSED_NAV_START_TIME"] = $3c94963df51c0e13$export$f0597adb063e4c38;
module.exports["CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH"] = $3c94963df51c0e13$export$6c014427ebb0cbae;
module.exports["WELCOME_FROM_ROVO_CHAT"] = $3c94963df51c0e13$export$ebacd4ef7f5400e2;
module.exports["NTH_USER_SETUP_CONTENT_TYPE"] = $3c94963df51c0e13$export$d1ec748fb682ca97;
module.exports["PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED"] = $3c94963df51c0e13$export$1a3a43cef0acd011;
module.exports["NTH_USER_AUTO_FOLLOW_SPACES"] = $3c94963df51c0e13$export$c81223a0ce3b63df;
module.exports["LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA"] = $3c94963df51c0e13$export$f1328b04dc902e1f;
module.exports["USE_CASES_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$e986b94fd54d134;
module.exports["NTH_USER_EMOJI_TITLE_DISCOVERED"] = $3c94963df51c0e13$export$bbdc3607431bd9d3;
module.exports["SIMPLIFY_NAV_NEW_USER"] = $3c94963df51c0e13$export$31a43870c77aad50;
module.exports["CFIND_5565_CREATION_FOCUSED_NAV_XFLOW"] = $3c94963df51c0e13$export$400b215814bf3fc0;
module.exports["CROSS_JOIN_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$94df39cf9e5d9804;
module.exports["ONBOARDING_EXPERIENCES"] = $3c94963df51c0e13$export$bfeb2da96277b623;
module.exports["COMPLETE"] = $3c94963df51c0e13$export$1660a2d7c2fff354;
module.exports["NAV_EXPERIMENT_ONBOARDING_KEYS"] = $3c94963df51c0e13$export$d4f5dd2b883b8982;
module.exports["OnboardingKeys"] = $3c94963df51c0e13$export$7a13c575f2c75084;

});

parcelRegister("lsxnT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $cozmU.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    const plugin = ctx?.plugin;
    const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);
    (0, $cozmU.useEffect)(()=>{
        window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
    }, [
        isDisplayed
    ]);
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $cozmU.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("i3jcY", function(module, exports) {

const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return (window.location.search ?? '').includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    ChoreographedComponent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightTarget: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("lfBMY", function(module, exports) {
var $93e6e1e47a4562a8$export$64e79c67b77e1326 = /*#__PURE__*/ function(OperationTypes) {
    OperationTypes["USE"] = "use";
    OperationTypes["LIMITED_USE"] = "limited_use";
    OperationTypes["EXTERNAL_COLLABORATOR_USE"] = "external_collaborator_use";
    OperationTypes["CREATE"] = "create";
    OperationTypes["READ"] = "read";
    OperationTypes["UPDATE"] = "update";
    OperationTypes["DELETE"] = "delete";
    OperationTypes["COPY"] = "copy";
    OperationTypes["MOVE"] = "move";
    OperationTypes["EXPORT"] = "export";
    OperationTypes["ARCHIVE"] = "archive";
    OperationTypes["PURGE"] = "purge";
    OperationTypes["PURGE_VERSION"] = "purge_version";
    OperationTypes["ADMINISTER"] = "administer";
    OperationTypes["RESTORE"] = "restore";
    OperationTypes["CREATE_SPACE"] = "create_space";
    OperationTypes["RESTRICT_CONTENT"] = "restrict_content";
    OperationTypes["CLEAR_PERMISSIONS"] = "clear_permissions";
    return OperationTypes;
}({});
module.exports["OperationTypes"] = $93e6e1e47a4562a8$export$64e79c67b77e1326;

});

parcelRegister("2wo33", function(module, exports) {

var $cFXjQ = parcelRequire("cFXjQ");


var $9Z22p = parcelRequire("9Z22p");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");




var $63cta = parcelRequire("63cta");


var $5rZJf = parcelRequire("5rZJf");

const $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    const permittedOperations = operationCheckResult?.content?.nodes?.[0]?.operations ?? [];
    const targetContentType = !!contentType ? contentType : operationCheckResult?.content?.nodes?.[0]?.type;
    if (!targetContentType) return false;
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === targetContentType);
};
const $fec7e6ab8c349d98$export$9df6fd1dd45ee771 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    // prettier-ignore
    const permittedOperations = operationCheckResult?.space?.operations ?? [];
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === contentType);
};
const $fec7e6ab8c349d98$export$e1260b60fe3f2784 = async ({ contentId: contentId, operation: operation, contentType: contentType })=>{
    const contentOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            query: (0, $63cta.ContentOperationsQuery),
            variables: {
                contentId: contentId,
                status: [
                    'current',
                    'archived',
                    'draft'
                ]
            },
            fetchPolicy: 'cache-first'
        } : {
            query: (0, $63cta.ContentOperationsQuery),
            variables: {
                contentId: contentId
            }
        },
        __callerPackage__: "entity-operations"
    });
    return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: contentOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$bcbdef0ac5f1ac47 = async ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const spaceOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $5rZJf.SpaceOperationsQuery),
        variables: {
            spaceKey: spaceKey
        },
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            fetchPolicy: 'cache-first'
        } : {},
        __callerPackage__: "entity-operations"
    });
    return $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: spaceOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$301dbe403ac05dd5 = ({ contentId: contentId, operation: operation, contentType: contentType, status: status })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $9Z22p.default), {
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            variables: {
                contentId: contentId,
                status: status ?? [
                    'current',
                    'archived',
                    'draft'
                ]
            },
            skip: !contentId,
            fetchPolicy: 'cache-first'
        } : {
            variables: {
                contentId: contentId,
                status: status
            },
            skip: !contentId
        },
        __callerPackage__: "entity-operations"
    });
    if (!contentId) return false;
    if (graphQLResult?.data) return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return undefined;
};
const $fec7e6ab8c349d98$export$1fefcc1c89f32022 = ({ spaceKey: spaceKey, operation: operation, contentType: contentType, skip: skip })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $cFXjQ.default), {
        variables: {
            spaceKey: spaceKey
        },
        skip: skip,
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            fetchPolicy: 'cache-first'
        } : {},
        __callerPackage__: "entity-operations"
    });
    // Only show the publish button if the user has permission to update (edit) this content.
    let canPerformOperation = undefined;
    if (graphQLResult?.data) canPerformOperation = $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return [
        canPerformOperation,
        graphQLResult
    ];
};
module.exports["canPerformSpaceOperation"] = $fec7e6ab8c349d98$export$9df6fd1dd45ee771;
module.exports["useCanPerformContentOperation"] = $fec7e6ab8c349d98$export$301dbe403ac05dd5;
module.exports["useCanPerformSpaceOperation"] = $fec7e6ab8c349d98$export$1fefcc1c89f32022;

});

parcelRegister("cFXjQ", function(module, exports) {
/**
 * @generated SignedSource<<1341e8100a34db255d375a90f5c4a762>>
 * @relayHash 66373ccec9c74286b704fa866e6f85ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b
const $718578d961a6d231$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "66373ccec9c74286b704fa866e6f85ed",
            "id": "1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b",
            "metadata": {},
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersSpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$718578d961a6d231$var$node.hash = "e5daa0845f1390f74a58e4fd57f9defb";
var $718578d961a6d231$export$2e2bcd8739ae039 = $718578d961a6d231$var$node;
module.exports["default"] = $718578d961a6d231$export$2e2bcd8739ae039;

});

parcelRegister("9Z22p", function(module, exports) {
/**
 * @generated SignedSource<<48d9ee7fb5d606ab817066b5f7172f92>>
 * @relayHash 74ad4c4ef681c6629c8477bfc21dc6ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58
const $16467728a654d6f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "74ad4c4ef681c6629c8477bfc21dc6ca",
            "id": "e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58",
            "metadata": {},
            "name": "entityOperationsHelpersContentOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$16467728a654d6f6$var$node.hash = "0a581f032f7c1b6232f4634d5c3d1376";
var $16467728a654d6f6$export$2e2bcd8739ae039 = $16467728a654d6f6$var$node;
module.exports["default"] = $16467728a654d6f6$export$2e2bcd8739ae039;

});

parcelRegister("63cta", function(module, exports) {

var $8r0lJ = parcelRequire("8r0lJ");

const $bc89d0f4a052c761$export$a42cd9ccc4f06e9e = (0, $8r0lJ.default);
module.exports["ContentOperationsQuery"] = $bc89d0f4a052c761$export$a42cd9ccc4f06e9e;

});

parcelRegister("8r0lJ", function(module, exports) {
/**
 * @generated SignedSource<<d4c33eb851813f5d8bdf7b8ddf9d7fb7>>
 * @relayHash afd2c148a694798349dbf7c95e9faf5e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a
const $9494deed8cae7257$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "afd2c148a694798349dbf7c95e9faf5e",
            "id": "e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a",
            "metadata": {},
            "name": "ContentOperationsQuery",
            "operationKind": "query",
            "text": "query ContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$9494deed8cae7257$var$node.hash = "4ac4e53f1dd0ba665b3f48217ce7b74b";
var $9494deed8cae7257$export$2e2bcd8739ae039 = $9494deed8cae7257$var$node;
module.exports["default"] = $9494deed8cae7257$export$2e2bcd8739ae039;

});

parcelRegister("5rZJf", function(module, exports) {

var $3QLqz = parcelRequire("3QLqz");

const $8e7057c5d2ae7999$export$636a01496687d185 = (0, $3QLqz.default);
module.exports["SpaceOperationsQuery"] = $8e7057c5d2ae7999$export$636a01496687d185;

});

parcelRegister("3QLqz", function(module, exports) {
/**
 * @generated SignedSource<<eaa114c9e42c98e4d30da80006b4df1f>>
 * @relayHash 5ff0445d5306228126745d8454e82696
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6
const $5b7055a8a77b29df$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5ff0445d5306228126745d8454e82696",
            "id": "b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6",
            "metadata": {},
            "name": "SpaceOperationsQuery",
            "operationKind": "query",
            "text": "query SpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$5b7055a8a77b29df$var$node.hash = "5796c3a83a0773d6d932bd63d2fbf511";
var $5b7055a8a77b29df$export$2e2bcd8739ae039 = $5b7055a8a77b29df$var$node;
module.exports["default"] = $5b7055a8a77b29df$export$2e2bcd8739ae039;

});

parcelRegister("gsf3i", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $4c2208d3e228490f$var$initialState = {
    firstRedactionIdRendered: null,
    titleRedactionRenderedForContentId: null,
    activeSpotlightIndex: null,
    lastActiveSpotlightIndex: null
};
const $4c2208d3e228490f$var$Store = (0, $8s9DV.createStore)({
    initialState: $4c2208d3e228490f$var$initialState,
    actions: {
        setFirstRedactionIdRendered: (redactionId)=>({ getState: getState, setState: setState })=>{
                const { firstRedactionIdRendered: firstRedactionIdRendered } = getState();
                if (firstRedactionIdRendered) return;
                setState({
                    firstRedactionIdRendered: redactionId
                });
            },
        setTitleRedactionRenderedForContentId: (contentId)=>({ setState: setState })=>{
                setState({
                    titleRedactionRenderedForContentId: contentId
                });
            },
        resetTour: ()=>({ setState: setState })=>{
                setState({
                    activeSpotlightIndex: $4c2208d3e228490f$var$initialState.activeSpotlightIndex,
                    lastActiveSpotlightIndex: $4c2208d3e228490f$var$initialState.lastActiveSpotlightIndex
                });
            },
        initiateTour: ()=>({ setState: setState })=>{
                setState({
                    activeSpotlightIndex: 0
                });
            },
        proceedToNext: ()=>({ setState: setState, getState: getState })=>{
                const { activeSpotlightIndex: activeSpotlightIndex } = getState();
                if (activeSpotlightIndex === null) return;
                setState({
                    activeSpotlightIndex: activeSpotlightIndex + 1,
                    lastActiveSpotlightIndex: activeSpotlightIndex
                });
            },
        concludeTour: ()=>({ setState: setState, getState: getState })=>{
                const { activeSpotlightIndex: activeSpotlightIndex } = getState();
                setState({
                    activeSpotlightIndex: null,
                    lastActiveSpotlightIndex: activeSpotlightIndex
                });
            }
    }
});
const $4c2208d3e228490f$export$4e8589b303f4384d = (0, $kBr4q.createHook)($4c2208d3e228490f$var$Store);
const $4c2208d3e228490f$export$b121a589d2d05ff2 = (0, $kBr4q.createActionsHook)($4c2208d3e228490f$var$Store);
const $4c2208d3e228490f$export$f2a6ed6b1eb18db8 = (0, $kBr4q.createStateHook)($4c2208d3e228490f$var$Store, {
    selector: (state)=>state.activeSpotlightIndex !== null
});
module.exports["useRedactionsTourState"] = $4c2208d3e228490f$export$4e8589b303f4384d;
module.exports["useRedactionsTourActions"] = $4c2208d3e228490f$export$b121a589d2d05ff2;

});

parcelRegister("2MwVI", function(module, exports) {

var $635s2 = parcelRequire("635s2");


var $cozmU = parcelRequire("cozmU");


var $aMcHK = parcelRequire("aMcHK");


var $7Sm4c = parcelRequire("7Sm4c");


var $gsf3i = parcelRequire("gsf3i");


var $jMyy4 = parcelRequire("jMyy4");

const $49bfbfa6f9c85bf2$export$ea561d273e8cda71 = "\u2588\u2588\u2588\u2588";
const $49bfbfa6f9c85bf2$export$d7a7fedf1f7b03e1 = (title)=>{
    if (!title) return false;
    return title.includes($49bfbfa6f9c85bf2$export$ea561d273e8cda71);
};
const $49bfbfa6f9c85bf2$export$19187316a5e6c180 = ({ contentId: contentId, title: title })=>{
    const { setTitleRedactionRenderedForContentId: setTitleRedactionRenderedForContentId } = (0, $gsf3i.useRedactionsTourActions)();
    const titleMaybeHasRedaction = (0, $cozmU.useMemo)(()=>$49bfbfa6f9c85bf2$export$d7a7fedf1f7b03e1(title), [
        title
    ]);
    const { data: data, error: redactionsCountError } = (0, $jMyy4.useQueryInterop)((0, $635s2.default), {
        skip: !titleMaybeHasRedaction,
        variables: {
            contentId: contentId
        },
        errorPolicy: 'all',
        __callerPackage__: "redactions"
    });
    // handle 4xx errors
    (0, $cozmU.useEffect)(()=>{
        if (redactionsCountError && (0, $aMcHK.isStatusCodeError)(redactionsCountError, '404')) (0, $7Sm4c.markErrorAsHandled)(redactionsCountError);
    }, [
        redactionsCountError
    ]);
    const redactionsCount = data?.singleContent?.redactionMetadataCount ?? 0;
    (0, $cozmU.useEffect)(()=>{
        if (contentId && titleMaybeHasRedaction && redactionsCount > 0) setTitleRedactionRenderedForContentId(contentId);
        return ()=>{
            // Cleanup function to reset the title redaction state
            setTitleRedactionRenderedForContentId(null);
        };
    }, [
        contentId,
        titleMaybeHasRedaction,
        redactionsCount,
        setTitleRedactionRenderedForContentId
    ]);
};
module.exports["useTrackTitleRedactionRendered"] = $49bfbfa6f9c85bf2$export$19187316a5e6c180;

});

parcelRegister("635s2", function(module, exports) {
/**
 * @generated SignedSource<<a0a12f229cf3db623a511192bab87885>>
 * @relayHash a2231280d1a64c0467ba87a246116380
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5ebec3823398761cbff8ccd89859729728b177003609485a43378ea74e2188e9
const $a51c9ec4f18af0fc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "redactionMetadataCount"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTrackTitleRedactionRenderedRedactionsCountQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTrackTitleRedactionRenderedRedactionsCountQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "a2231280d1a64c0467ba87a246116380",
            "id": "5ebec3823398761cbff8ccd89859729728b177003609485a43378ea74e2188e9",
            "metadata": {},
            "name": "useTrackTitleRedactionRenderedRedactionsCountQuery",
            "operationKind": "query",
            "text": "query useTrackTitleRedactionRenderedRedactionsCountQuery($contentId:ID!){singleContent(id:$contentId){id,redactionMetadataCount}}"
        }
    };
}();
$a51c9ec4f18af0fc$var$node.hash = "f9a742b4e2840cd061fc6915ae9b6b93";
var $a51c9ec4f18af0fc$export$2e2bcd8739ae039 = $a51c9ec4f18af0fc$var$node;
module.exports["default"] = $a51c9ec4f18af0fc$export$2e2bcd8739ae039;

});

parcelRegister("kdpMy", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $9ec3d7afd2a780b8$export$d4c72bab9d6cc13a = {
    generatedTitle: '',
    trackAIResultViewStored: ()=>{},
    generatedTitleFromPaste: '',
    fireResultAnalyticsFromPaste: ()=>{}
};
const $9ec3d7afd2a780b8$var$NAME = 'GENERATED_TITLE_STORE';
const $9ec3d7afd2a780b8$export$e324594224ef24da = {
    setGeneratedTitle: (newTitle)=>({ setState: setState })=>{
            setState({
                generatedTitle: newTitle
            });
        },
    setTrackAIResultViewStored: (trackAIResultViewHook)=>({ setState: setState })=>{
            setState({
                trackAIResultViewStored: trackAIResultViewHook
            });
        },
    setGeneratedTitleFromPaste: (newTitle)=>({ setState: setState })=>{
            setState({
                generatedTitleFromPaste: newTitle
            });
        },
    setFireResultAnalyticsFromPaste: (fireResultAnalytics)=>({ setState: setState })=>{
            setState({
                fireResultAnalyticsFromPaste: fireResultAnalytics
            });
        },
    clearGeneratedTitleFromPaste: ()=>({ setState: setState })=>{
            setState({
                generatedTitleFromPaste: '',
                fireResultAnalyticsFromPaste: ()=>{}
            });
        }
};
const $9ec3d7afd2a780b8$var$GeneratedTitleStore = (0, $8s9DV.createStore)({
    name: $9ec3d7afd2a780b8$var$NAME,
    initialState: $9ec3d7afd2a780b8$export$d4c72bab9d6cc13a,
    actions: $9ec3d7afd2a780b8$export$e324594224ef24da
});
const $9ec3d7afd2a780b8$export$b824f038e1bda391 = (0, $kBr4q.createHook)($9ec3d7afd2a780b8$var$GeneratedTitleStore);
const $9ec3d7afd2a780b8$export$5d1d441e079eaec3 = (0, $kBr4q.createActionsHook)($9ec3d7afd2a780b8$var$GeneratedTitleStore);
module.exports["useGeneratedTitle"] = $9ec3d7afd2a780b8$export$b824f038e1bda391;
module.exports["useGeneratedTitleActions"] = $9ec3d7afd2a780b8$export$5d1d441e079eaec3;

});

parcelRegister("hy9oS", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");

const $a6c6feb29e933984$export$8f26c723630e2919 = ()=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $fGzMp.getExperienceTracker)();
        $[0] = t0;
    } else t0 = $[0];
    const experienceTracker = t0;
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            onGenerateStart: (params)=>{
                experienceTracker.start({
                    name: (0, $irVI7.AI_HEADER_IMAGE_GENERATION),
                    attributes: params
                });
            },
            onGenerateSuccess: (params_0)=>{
                experienceTracker.succeed({
                    name: (0, $irVI7.AI_HEADER_IMAGE_GENERATION),
                    attributes: params_0
                });
            },
            onGenerateError: (params_1)=>{
                experienceTracker.fail({
                    name: (0, $irVI7.AI_HEADER_IMAGE_GENERATION),
                    error: params_1.error,
                    attributes: {
                        contentId: params_1.contentId,
                        useRawPrompt: params_1.useRawPrompt,
                        ...params_1.theme && {
                            theme: params_1.theme
                        }
                    }
                });
            },
            onGenerateAbort: (params_2)=>{
                experienceTracker.abort({
                    name: (0, $irVI7.AI_HEADER_IMAGE_GENERATION),
                    reason: "Request aborted by user",
                    attributes: params_2
                });
            }
        };
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
module.exports["useImageGenerationCallbacks"] = $a6c6feb29e933984$export$8f26c723630e2919;

});

parcelRegister("gektR", function(module, exports) {

var $kNIYN = parcelRequire("kNIYN");


var $jVylI = parcelRequire("jVylI");

class $904056f857fff237$export$e38a13e9484b72c7 extends (0, $kNIYN.Container) {
    constructor(...args){
        super(...args);
        this.state = {
            alignmentButtonState: (0, $jVylI.TitleAlignmentType).LEFT,
            isUpdatingAlignment: false,
            isLoadingComplete: false
        };
        this.toggleAlignmentButton = (newAlignmentState)=>{
            if (this.state.alignmentButtonState !== newAlignmentState) this.setState({
                alignmentButtonState: newAlignmentState || (0, $jVylI.TitleAlignmentType).LEFT
            });
        };
        this.setIsLoadingComplete = (isLoadingComplete)=>{
            this.setState({
                isLoadingComplete: isLoadingComplete
            });
        };
        this.setIsUpdatingAlignment = (isUpdatingAlignment)=>{
            this.setState({
                isUpdatingAlignment: isUpdatingAlignment
            });
        };
        this.resetToDefaults = ()=>{
            this.setState({
                alignmentButtonState: (0, $jVylI.TitleAlignmentType).LEFT,
                isUpdatingAlignment: false,
                isLoadingComplete: false
            });
        };
    }
}
module.exports["AlignmentButtonContainer"] = $904056f857fff237$export$e38a13e9484b72c7;

});

parcelRegister("dkxaU", function(module, exports) {

var $75Ax4 = parcelRequire("75Ax4");

const $17b31ae3aa6020db$export$6a5c726aaec5b09 = (width)=>{
    const imgHeight = Math.floor(width / (0, $75Ax4.COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO));
    if (imgHeight < (0, $75Ax4.MIN_DYNAMIC_COVER_IMAGE_HEIGHT)) return 0, $75Ax4.MIN_DYNAMIC_COVER_IMAGE_HEIGHT;
    else if (imgHeight >= (0, $75Ax4.MAX_DYNAMIC_COVER_IMAGE_HEIGHT)) return 0, $75Ax4.MAX_DYNAMIC_COVER_IMAGE_HEIGHT;
    else return imgHeight;
};
module.exports["calcDynamicCoverImageHeight"] = $17b31ae3aa6020db$export$6a5c726aaec5b09;

});

parcelRegister("75Ax4", function(module, exports) {
const $4cdfc0aeee394c11$export$5a7e63ae23cefcb = 50;
const $4cdfc0aeee394c11$export$535fddacdd1506a3 = '?utm_source=Confluence&utm_medium=referral';
const $4cdfc0aeee394c11$export$41f496cb75ebdbf4 = 140;
const $4cdfc0aeee394c11$export$e1a10bbd512cde25 = 750;
const $4cdfc0aeee394c11$export$e63c70235aab4f60 = 38 / 7;
const $4cdfc0aeee394c11$export$a9612492250fd8ea = 'min(max(calc(calc( 100vw - var(--leftPanelWidth, 0px) - var(--leftSidebarWidth, 0px) - var(--rightPanelWidth, 0px) - var(--rightSidebarWidth, 0px) ) * (7 / 38)), 140px), 750px)';
const $4cdfc0aeee394c11$export$b143b999ce4b353a = `round(down, calc(100cqw / (${$4cdfc0aeee394c11$export$e63c70235aab4f60})), 1px)`;
const $4cdfc0aeee394c11$export$f94fb8385ddeea1f = 800;
const $4cdfc0aeee394c11$export$f60e801aad1e2af5 = 147;
const $4cdfc0aeee394c11$export$a682f4bbb3650e11 = 200;
module.exports["DEFAULT_POSITION_VALUE"] = $4cdfc0aeee394c11$export$5a7e63ae23cefcb;
module.exports["REFERRAL_LINK"] = $4cdfc0aeee394c11$export$535fddacdd1506a3;
module.exports["MIN_DYNAMIC_COVER_IMAGE_HEIGHT"] = $4cdfc0aeee394c11$export$41f496cb75ebdbf4;
module.exports["MAX_DYNAMIC_COVER_IMAGE_HEIGHT"] = $4cdfc0aeee394c11$export$e1a10bbd512cde25;
module.exports["COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO"] = $4cdfc0aeee394c11$export$e63c70235aab4f60;
module.exports["CALCULATE_SCALED_COVER_IMAGE_HEIGHT_FOR_EDIT_PAGE"] = $4cdfc0aeee394c11$export$b143b999ce4b353a;
module.exports["COVER_IMAGE_FIXED_WIDTH"] = $4cdfc0aeee394c11$export$f94fb8385ddeea1f;
module.exports["COVER_IMAGE_FIXED_HEIGHT"] = $4cdfc0aeee394c11$export$f60e801aad1e2af5;
module.exports["SMART_SPACE_OVERVIEW_FIXED_HEIGHT_FULL_WIDTH"] = $4cdfc0aeee394c11$export$a682f4bbb3650e11;

});

parcelRegister("3WPGR", function(module, exports) {

var $1d2ww = parcelRequire("1d2ww");


var $jVylI = parcelRequire("jVylI");


var $zalpJ = parcelRequire("zalpJ");


var $75Ax4 = parcelRequire("75Ax4");


var $dkxaU = parcelRequire("dkxaU");


var $bKd7w = parcelRequire("bKd7w");

function $523f2f8bee18c451$export$da000b5ddbbe9afc(p) {
    let value;
    let version;
    try {
        value = JSON.parse(p.value);
        version = parseInt(JSON.parse(p.version.number));
        // Counting quotes to determine if the value we receive is a string (old cover photos experience without repositioning feature)
        // or object (new cover photos experience with repositioning feature - has a position property in the object).
        // The new designs will have value as an object but stored as a string: "{"id":"http://website.com","position":45}"
        // We need to JSON.parse it again to turn it into an object. The old cover photos will just have value as a string: value: "123-abc",
        // so there is no need to JSON parse it again. We will set its position as the default position value to support this new value format.
        const quoteMatches = value.match(/"/g);
        const quoteCount = quoteMatches ? quoteMatches.length : 0;
        // if quoteCount != null this mean value is part of the new experience so we need to JSON parse the info again since it is a stored as a string and we want the object
        if (quoteCount) try {
            value = JSON.parse(value);
        } catch (e) {
            value = null;
        }
        else // otherwise it was just a regular string (part of old experience without repositioning)
        value = {
            id: value,
            position: (0, $75Ax4.DEFAULT_POSITION_VALUE)
        };
    } catch (e) {
        value = null;
        version = null;
    }
    return p ? {
        value: value,
        version: version
    } : null;
}
function $523f2f8bee18c451$export$64dc6e3789165979(appearanceValue) {
    let appearance;
    if (appearanceValue) try {
        appearance = JSON.parse(appearanceValue);
    } catch (e) {
        appearance = null;
    }
    return appearance ?? (0, $1d2ww.ContentAppearanceType).DEFAULT;
}
function $523f2f8bee18c451$export$df5897f4041f380b(contentQueryData, isLivePage) {
    const pageWidthType = contentQueryData?.content?.nodes?.[0]?.appearancePublished?.nodes?.[0]?.value || `"default"`;
    const properties = contentQueryData?.content?.nodes?.[0]?.properties?.nodes || [];
    const published = isLivePage ? properties[0] : properties.find((p)=>p?.key === (0, $bKd7w.CoverPictureIdPropertyKey).PUBLISHED);
    const coverPictureWidth = contentQueryData?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
    const { titleContentProperties: titleContentProperties } = (0, $zalpJ.getTitleContentProperty)(contentQueryData);
    const isTitleCenterAligned = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER;
    const coverPicture = {
        draft: null,
        published: $523f2f8bee18c451$export$da000b5ddbbe9afc(published)
    };
    let publishedValue;
    try {
        publishedValue = JSON.parse(pageWidthType);
    } catch (e) {
        publishedValue = 'default';
    }
    const contentAppearance = {
        draft: '',
        published: publishedValue
    };
    const hasCoverPicture = !!coverPicture?.published?.value?.id;
    return {
        coverPicture: coverPicture,
        contentAppearance: contentAppearance,
        hasCoverPicture: hasCoverPicture,
        coverPictureWidth: coverPictureWidth,
        isTitleCenterAligned: isTitleCenterAligned
    };
}
const $523f2f8bee18c451$export$abc9309e623c0351 = (width)=>{
    return (0, $dkxaU.calcDynamicCoverImageHeight)(width);
};
function $523f2f8bee18c451$export$8a432f79b719eeda(imageUrl) {
    if (!imageUrl) return false;
    return imageUrl.includes('images.unsplash.com') || imageUrl.includes('dam-cdn.atl.orangelogic.com') || /^https?:\/\/wac-cdn-[^.]+\.atlassian\.com/.test(imageUrl);
}
module.exports["propertyToId"] = $523f2f8bee18c451$export$da000b5ddbbe9afc;
module.exports["getRendererCoverPictureInfo"] = $523f2f8bee18c451$export$df5897f4041f380b;
module.exports["getDynamicCoverImageHeight"] = $523f2f8bee18c451$export$abc9309e623c0351;
module.exports["isAllowedExternalCoverPictureUrl"] = $523f2f8bee18c451$export$8a432f79b719eeda;

});

parcelRegister("zalpJ", function(module, exports) {

var $4lSsc = parcelRequire("4lSsc");


var $1Y111 = parcelRequire("1Y111");


var $jtuBN = parcelRequire("jtuBN");


var $jVylI = parcelRequire("jVylI");


var $gzIc1 = parcelRequire("gzIc1");

'use no memo';
const $20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery = (0, $1Y111.default);
const $20e32f1deb8c1fe0$export$c9b63bbfd869a91 = (0, $4lSsc.default);
const $20e32f1deb8c1fe0$export$cef8b8531fa62d5f = (data)=>{
    const titlePropertyContent = data?.content?.nodes?.[0]?.pageTitlePublished?.nodes?.find((node)=>node?.key == 'page-title-property-published');
    const coverPictureWidth = data?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
    if (titlePropertyContent?.value) try {
        return {
            titleContentProperties: (0, $gzIc1.contentPropertyHelper)(titlePropertyContent),
            coverPictureWidth: coverPictureWidth
        };
    } catch  {
        return {
            titleContentProperties: (0, $jVylI.defaultPropertyValue),
            coverPictureWidth: coverPictureWidth
        };
    }
    else return {
        titleContentProperties: (0, $jVylI.defaultPropertyValue),
        coverPictureWidth: coverPictureWidth
    };
};
const $20e32f1deb8c1fe0$var$QUERY_OPTIONS = (contentId)=>({
        variables: {
            contentId: contentId,
            status: [
                'current',
                'archived',
                'draft'
            ]
        },
        fetchPolicy: 'cache-first'
    });
const $20e32f1deb8c1fe0$export$9e9d248809e028e8 = ({ contentId: contentId })=>{
    const options = $20e32f1deb8c1fe0$var$QUERY_OPTIONS(contentId);
    const { data: data, error: error, loading: loading } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery, {
        variables: options.variables,
        skip: !contentId,
        __callerPackage__: "content-topper"
    });
    if (!loading && data && !error) {
        const { titleContentProperties: titleContentProperties, coverPictureWidth: coverPictureWidth } = $20e32f1deb8c1fe0$export$cef8b8531fa62d5f(data);
        return {
            titleContentProperties: titleContentProperties,
            coverPictureWidth: coverPictureWidth
        };
    }
    return {
        titleContentProperties: (0, $jVylI.defaultPropertyValue),
        coverPictureWidth: (0, $jVylI.COVERPICTUREWIDTH).FULL
    };
};
module.exports["PreloadHomepageIdQuery"] = $20e32f1deb8c1fe0$export$c9b63bbfd869a91;
module.exports["getTitleContentProperty"] = $20e32f1deb8c1fe0$export$cef8b8531fa62d5f;
module.exports["useTitleContentPropertiesForPublishedPage"] = $20e32f1deb8c1fe0$export$9e9d248809e028e8;

});

parcelRegister("4lSsc", function(module, exports) {
/**
 * @generated SignedSource<<27d66eab829e89ba017f17104702246d>>
 * @relayHash 9a31bcd84d31650a9d9bf2ee5045af08
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb
const $f70a6e2cb787614b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "9a31bcd84d31650a9d9bf2ee5045af08",
            "id": "d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb",
            "metadata": {},
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery($spaceKey:String!){space(key:$spaceKey){id,homepage{id}}}"
        }
    };
}();
$f70a6e2cb787614b$var$node.hash = "57678666b7eece7bec595c782b54d686";
var $f70a6e2cb787614b$export$2e2bcd8739ae039 = $f70a6e2cb787614b$var$node;
module.exports["default"] = $f70a6e2cb787614b$export$2e2bcd8739ae039;

});

parcelRegister("1Y111", function(module, exports) {
/**
 * @generated SignedSource<<c93173dea6bc8ed379cb4b9b29fb2a88>>
 * @relayHash 6af15886385d86202fbacd0200dc99eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0
const $66bccefa41a7dece$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "alias": "pageTitlePublished",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-published\")"
                        },
                        {
                            "alias": "pageTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-draft\")"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "coverPictureWidth"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "6af15886385d86202fbacd0200dc99eb",
            "id": "2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0",
            "metadata": {},
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForPublishedPageQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}}}"
        }
    };
}();
$66bccefa41a7dece$var$node.hash = "9a5b243b4d944acf33577dfb16711cea";
var $66bccefa41a7dece$export$2e2bcd8739ae039 = $66bccefa41a7dece$var$node;
module.exports["default"] = $66bccefa41a7dece$export$2e2bcd8739ae039;

});

parcelRegister("bKd7w", function(module, exports) {
var $9558c78c09e4ba60$export$da638b84af7eb6eb = /*#__PURE__*/ function(CoverPictureIdPropertyKey) {
    CoverPictureIdPropertyKey["PUBLISHED"] = "cover-picture-id-published";
    CoverPictureIdPropertyKey["DRAFT"] = "cover-picture-id-draft";
    return CoverPictureIdPropertyKey;
}({});
module.exports["CoverPictureIdPropertyKey"] = $9558c78c09e4ba60$export$da638b84af7eb6eb;

});

parcelRegister("gKr8t", function(module, exports) {

var $9B4fQ = parcelRequire("9B4fQ");


var $10d5H = parcelRequire("10d5H");


var $7G1r9 = parcelRequire("7G1r9");


var $2bfWW = parcelRequire("2bfWW");


var $cC0P5 = parcelRequire("cC0P5");


var $adWn1 = parcelRequire("adWn1");


var $9jPdT = parcelRequire("9jPdT");




var $iMHGI = parcelRequire("iMHGI");


var $8xqRi = parcelRequire("8xqRi");


var $3cnNA = parcelRequire("3cnNA");



var $11MAl = parcelRequire("11MAl");


var $5c4nm = parcelRequire("5c4nm");

let $6d0c6b833ab477dd$var$apolloClient = null;
const $6d0c6b833ab477dd$var$wrappedFetch = (0, $iMHGI.createWrappedFetch)({
    isForAggOnly: true
});
const $6d0c6b833ab477dd$export$ed315e0c0d70f648 = 'agg';
const $6d0c6b833ab477dd$var$fragmentMatcher = new (0, $cC0P5.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: {
        __schema: {
            types: (0, (/*@__PURE__*/$parcel$interopDefault($adWn1)))
        }
    }
});
const $6d0c6b833ab477dd$export$8ddb56c88a6a3feb = new (0, $5c4nm.BroadcastConfigurableInMemoryCache)({
    fragmentMatcher: $6d0c6b833ab477dd$var$fragmentMatcher
});
const $6d0c6b833ab477dd$export$73fc90876f9d2053 = ()=>{
    $6d0c6b833ab477dd$var$apolloClient = null;
};
const $6d0c6b833ab477dd$export$13fdb03e350a572c = ()=>{
    // Use mock gateway Apollo client in tests
    if (window.MOCK_GATEWAY_APOLLO_CLIENT) return window.MOCK_GATEWAY_APOLLO_CLIENT;
    if (!$6d0c6b833ab477dd$var$apolloClient) {
        $6d0c6b833ab477dd$var$apolloClient = $6d0c6b833ab477dd$var$createApolloClient();
        window.GLOBAL_APOLLO_AGG_CLIENT = $6d0c6b833ab477dd$var$apolloClient;
    }
    return $6d0c6b833ab477dd$var$apolloClient;
};
const $6d0c6b833ab477dd$var$createLinks = ()=>{
    const links = [
        (0, $9jPdT.createOnErrorLink)()
    ];
    const subscriptionLinks = [];
    links.push((0, $11MAl.SSRClientLink)($6d0c6b833ab477dd$export$ed315e0c0d70f648, $6d0c6b833ab477dd$export$8ddb56c88a6a3feb));
    subscriptionLinks.push((0, $3cnNA.AttachExtensionsLink));
    subscriptionLinks.push((0, $8xqRi.getAGGWebSocketLinkInstance)());
    links.push(new (0, $2bfWW.HttpLink)({
        credentials: 'include',
        uri: '/gateway/api/graphql',
        fetch: $6d0c6b833ab477dd$var$wrappedFetch
    }));
    return (0, $10d5H.split)(// Condition for handling subscriptions
    // we don't want to use subscriptions in SSR mode
    ({ query: query })=>{
        const definition = (0, $7G1r9.getMainDefinition)(query);
        return definition?.kind === 'OperationDefinition' && definition?.operation === 'subscription' && // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        true;
    }, // WebSocket link for subscriptions
    (0, $10d5H.from)(subscriptionLinks), // HTTP link for non-subscription operations
    (0, $10d5H.from)(links));
};
const $6d0c6b833ab477dd$var$createApolloClient = ()=>{
    if (typeof window['__APOLLO_AGG_STATE__'] === 'object') $6d0c6b833ab477dd$export$8ddb56c88a6a3feb.restore(window['__APOLLO_AGG_STATE__']);
    const client = new (0, $9B4fQ.ApolloClient)({
        // Prevent cache and network query to refresh when they are already preloaded on server-side.
        // Refreshing data will cause component to fallback to loading state.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        ssrMode: Boolean(undefined),
        connectToDevTools: false,
        link: (0, $10d5H.from)([
            $6d0c6b833ab477dd$var$createLinks()
        ]),
        cache: $6d0c6b833ab477dd$export$8ddb56c88a6a3feb
    });
    // This is not actual API from Apollo. This field is read in next/packages/ssr-app/src/module-replacements/apollo-client.js
    client.__isAGGClient = true;
    return client;
};
module.exports["apolloAGGCache"] = $6d0c6b833ab477dd$export$8ddb56c88a6a3feb;
module.exports["getAGGClient"] = $6d0c6b833ab477dd$export$13fdb03e350a572c;

});

parcelRegister("8xqRi", function(module, exports) {

var $4cvLo = parcelRequire("4cvLo");

function $aa9065bb91596100$export$91893b414ff080f2() {
    let WEBSOCKET_URL;
    WEBSOCKET_URL = `wss://${window?.location?.host}/gateway/api/graphql/subscriptions`;
    return WEBSOCKET_URL;
}
let $aa9065bb91596100$var$wsLink;
function $aa9065bb91596100$export$4b71fe053d09625a() {
    const WEBSOCKET_URL = $aa9065bb91596100$export$91893b414ff080f2();
    if (!$aa9065bb91596100$var$wsLink) $aa9065bb91596100$var$wsLink = new (0, $4cvLo.GraphQLWSLink)({
        url: ()=>{
            return WEBSOCKET_URL;
        },
        shouldRetry: ()=>{
            return true;
        },
        keepAlive: (0, $4cvLo.KEEP_ALIVE),
        retryAttempts: 5
    });
    return $aa9065bb91596100$var$wsLink;
}
module.exports["getAGGWebSocketLinkInstance"] = $aa9065bb91596100$export$4b71fe053d09625a;

});

parcelRegister("4cvLo", function(module, exports) {

var $bKqeQ = parcelRequire("bKqeQ");


var $10d5H = parcelRequire("10d5H");


var $bPh6H = parcelRequire("bPh6H");


var $422HI = parcelRequire("422HI");


var $04e9M = parcelRequire("04e9M");


var $dbZMH = parcelRequire("dbZMH");


var $ac4MN = parcelRequire("ac4MN");


var $bBofs = parcelRequire("bBofs");

const $fca9c472df15863c$export$e9ff5bb5c39478ed = 600000;
class $fca9c472df15863c$export$b26b2f8eae2af9a extends (0, $10d5H.ApolloLink) {
    request(operation) {
        // Add null check for operation.getContext to prevent "Cannot read properties of undefined" errors
        const context = operation.getContext?.() || {};
        // context is coming from a previous link since we are using apollo v2
        // subscriptions does not have context or extensions in some cases
        return new (0, $10d5H.Observable)((observer)=>{
            const subscription = this.client.subscribe({
                ...operation,
                query: (0, $bPh6H.print)(operation.query),
                extensions: context?.extensions
            }, {
                next: (result)=>{
                    // Transform null data to empty object
                    const transformedResult = {
                        ...result,
                        data: result.data === null ? {} : result.data
                    };
                    observer.next(transformedResult);
                },
                complete: observer.complete.bind(observer),
                error: (err)=>{
                    if (this.closedInfo && !this.closedInfo?.wasClean && !err?.message) (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                        client.sendOperationalEvent({
                            source: 'confluence-AGGWebSocketLink',
                            actionSubject: 'webSocket',
                            action: 'closed-socket-error',
                            attributes: {
                                reason: this.closedInfo?.reason,
                                code: this.closedInfo?.code,
                                wasClean: this.closedInfo?.wasClean
                            }
                        });
                    });
                    if (err instanceof Error) return observer.error(err);
                    return observer.error(new (0, $422HI.ApolloErrorInterop)({
                        graphQLErrors: Array.isArray(err) ? err : [
                            err
                        ]
                    }));
                }
            });
            // keep track of the subscription so we can unsubscribe later
            this.replayQueries[operation.operationName] = {
                unsubscribe: subscription,
                query: (0, $bPh6H.print)(operation.query)
            };
            return subscription;
        });
    }
    constructor(options){
        super();
        this.client = void 0;
        this.internetConnectionState = 'healthy';
        this.timedOut = null;
        this.closedInfo = null;
        this.replayQueries = {};
        this.currentGetInternetConnectionStatePromise = null;
        this.onConnected = (_socket, _payload, wasRetry)=>{
            (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                client.sendOperationalEvent({
                    source: 'confluence-AGGWebSocketLink',
                    actionSubject: 'webSocket',
                    action: wasRetry ? 'reconnected' : 'connected'
                });
            });
        };
        this.verifyAndUpdateInternetHealth = async ()=>{
            this.currentGetInternetConnectionStatePromise = this.currentGetInternetConnectionStatePromise || (0, $dbZMH.getInternetConnectionState)();
            const internetHealthState = await this.currentGetInternetConnectionStatePromise;
            this.internetConnectionState = internetHealthState;
            this.currentGetInternetConnectionStatePromise = null;
        };
        this.verifyAndUpdateInternetHealthUntilHealthy = async ()=>{
            await this.verifyAndUpdateInternetHealth();
            if (this.internetConnectionState === 'healthy') return;
            else this.client?.terminate();
            await new Promise((resolve)=>{
                setTimeout(resolve, 500);
            });
            return this.verifyAndUpdateInternetHealthUntilHealthy();
        };
        this.retryWait = async (retries)=>{
            const retryDelayRange = await (0, $ac4MN.getDelayRangeFromGraphqlWebsocketState)(retries);
            // This is the logic reused from legacy WebSocket with a check verifyAndUpdateInternetHealthUntilHealthy
            // If the internet connection is healthy then we can retry, otherwise we do not need to retry
            // We subtract the time spent waiting to reconnect from the exponential backoff
            const startedAt = Date.now();
            await this.verifyAndUpdateInternetHealthUntilHealthy();
            // since we took some time to verify internet health, reduce the exponential backoff
            const msCheckingInternetHealth = Date.now() - startedAt;
            const retryDelay = (0, $ac4MN.getBackOffDelay)({
                range: retryDelayRange,
                timeSpent: msCheckingInternetHealth
            });
            // monitor status looks at if a user is idle or hidden to determine the retry delay
            await new Promise((resolve)=>{
                let timeoutId = setTimeout(resolve, retryDelay);
                const newRetryDelayRange = (0, $bBofs.calculateBackOffRange)({
                    status: 'active',
                    attemptsCount: retries
                });
                const msAlreadyWaited = Date.now() - startedAt;
                const newRetryDelay = (0, $ac4MN.getBackOffDelay)({
                    range: newRetryDelayRange,
                    timeSpent: msAlreadyWaited
                });
                const actualReconnectionDelay = Math.max(newRetryDelay - msAlreadyWaited, 0);
                // Clear old timeout and set a new one with the updated delay
                clearTimeout(timeoutId);
                timeoutId = setTimeout(resolve, actualReconnectionDelay);
            });
        };
        this.client = (0, $bKqeQ.createClient)({
            ...options,
            retryWait: this.retryWait,
            on: {
                connected: this.onConnected,
                closed: (info)=>{
                    this.closedInfo = info;
                },
                ping: (received)=>{
                    if (!received /* sent */ ) this.timedOut = setTimeout(()=>{
                        // unsubscribe so that we can reconnect with new arguments
                        for(const key in this.replayQueries)// unsubscribes queries so that we can reconnect with new arguments
                        if (this.replayQueries[key]) {
                            this.replayQueries[key].unsubscribe();
                            delete this.replayQueries[key];
                        }
                        this.client.terminate();
                    }, $fca9c472df15863c$export$e9ff5bb5c39478ed / 2);
                },
                pong: (received)=>{
                    if (received && this.timedOut !== null) clearTimeout(this.timedOut);
                }
            }
        });
    }
}
module.exports["KEEP_ALIVE"] = $fca9c472df15863c$export$e9ff5bb5c39478ed;
module.exports["GraphQLWSLink"] = $fca9c472df15863c$export$b26b2f8eae2af9a;

});

parcelRegister("dbZMH", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getInternetConnectionState.ts when we move to Relay.
 */ // partially copied from Trello modified to use confluences network check
const $3d23f6bbdf409903$export$ddfffe3f5c167fa6 = async ()=>{
    // we can early return unhealthy if offline for navigator, but we cant if onLine.
    // That's because you can be online, but be waiting for VPN connection or something
    // else that blocks actually allowing internet.
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (!navigator.onLine) return 'unhealthy';
    for(let i = 0; i < 3; i++){
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        if (!navigator.onLine) return 'unhealthy';
        // stagger it a little because of flakey VPN's and firewalls
        await new Promise((res)=>setTimeout(res, 1000));
    }
    // we got 3 good attempts, safe to say healthy
    return 'healthy';
};
module.exports["getInternetConnectionState"] = $3d23f6bbdf409903$export$ddfffe3f5c167fa6;

});

parcelRegister("ac4MN", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getBackOffDelay.ts when we move to Relay.
 */ // copied from Trello

var $bBofs = parcelRequire("bBofs");

function $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(start, end) {
    const spread = end - start;
    return Math.floor(start + Math.random() * spread);
}
const $5a87cb4548ea235b$export$73e02b3a26ecb0d7 = ({ range: range, timeSpent: timeSpent = 0 })=>{
    const [lowerBound, upperBound] = range;
    const delay = $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(lowerBound, upperBound);
    return Math.max(delay - timeSpent, 0);
};
const $5a87cb4548ea235b$export$ac8ba6656a385f56 = async (retries)=>{
    /**
	 * We're overriding the status multipliers here to make the reconnection
	 * back-off less aggressive. To reduce client
	 * reconnect load on graphql-subscriptions.
	 * The default status multipliers are: { active: 1, idle: 10 }.
	 */ const activeMultiplier = 1;
    let status = 'idle';
    if (typeof window !== 'undefined') // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    status = document.visibilityState === 'visible' ? 'active' : 'idle';
    else status = 'idle';
    return (0, $bBofs.calculateBackOffRange)({
        status: status,
        attemptsCount: retries,
        statusMultipliersOverride: {
            active: activeMultiplier,
            idle: 10
        }
    });
};
module.exports["getBackOffDelay"] = $5a87cb4548ea235b$export$73e02b3a26ecb0d7;
module.exports["getDelayRangeFromGraphqlWebsocketState"] = $5a87cb4548ea235b$export$ac8ba6656a385f56;

});

parcelRegister("bBofs", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/calculateBackOffRange.ts when we move to Relay.
 */ // copied from Trello

var $11y02 = parcelRequire("11y02");

function $35212ac5bc2e900f$export$de85ae9dfb4a57bc({ status: status, attemptsCount: attemptsCount, statusMultipliersOverride: statusMultipliersOverride, jitterStatusMultipliersOverride: jitterStatusMultipliersOverride, connectionHealth: connectionHealth = 'base', baseLowerBoundOverride: baseLowerBoundOverride, baseUpperBoundOverride: baseUpperBoundOverride, maxDelayOverride: maxDelayOverride }) {
    const [baseLowerBound, baseUpperBound] = (0, $11y02.getReconnectDelayBounds)(connectionHealth);
    const maxDelay = maxDelayOverride ?? (0, $11y02.getMaxDelay)({
        status: status,
        connectionHealth: connectionHealth
    });
    const statusMultipliers = statusMultipliersOverride ?? (0, $11y02.getDefaultStatusMultipliers)();
    const jitterStatusMultipliers = jitterStatusMultipliersOverride ?? (0, $11y02.jitterStatusMultipliers);
    const attemptsMultiplier = Math.pow(2, attemptsCount);
    const totalMultiplier = statusMultipliers[status] * attemptsMultiplier;
    const jitterMultiplier = jitterStatusMultipliers[status];
    const maxFirstActiveDelay = 2000;
    const maxFirstIdleDelay = 60000;
    let tempUpperOverride;
    if (attemptsCount > 0) tempUpperOverride = undefined;
    else if (status === 'active') tempUpperOverride = maxFirstActiveDelay;
    else tempUpperOverride = maxFirstIdleDelay;
    const lowerBound = (baseLowerBoundOverride ?? baseLowerBound) * totalMultiplier;
    const upperBound = tempUpperOverride ?? (baseUpperBoundOverride ?? baseUpperBound) * totalMultiplier * jitterMultiplier;
    return [
        Math.min(lowerBound, maxDelay),
        Math.min(upperBound, maxDelay)
    ];
}
module.exports["calculateBackOffRange"] = $35212ac5bc2e900f$export$de85ae9dfb4a57bc;

});

parcelRegister("11y02", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/backOffConfig.ts when we move to Relay.
 */ // copied from Trello
const $0b8d464841156fc9$var$TEN_MINUTES_IN_MS = 600000;
const $0b8d464841156fc9$export$d89658363be37383 = ({ status: status, connectionHealth: connectionHealth })=>{
    const maxDelays = {
        active: {
            base: 64000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        },
        idle: {
            base: 450000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        }
    };
    return maxDelays[status][connectionHealth];
};
const $0b8d464841156fc9$export$1b131e77a0e75a0a = ()=>({
        active: 1,
        idle: 15
    });
const $0b8d464841156fc9$export$a1d6d3ff41cd93e9 = {
    active: 1,
    idle: 2
};
const $0b8d464841156fc9$export$e5680a2329370bd3 = (connectionHealth)=>{
    const bounds = {
        base: [
            800,
            2000
        ],
        serverIncident: [
            800,
            4000
        ]
    };
    return bounds[connectionHealth];
};
module.exports["getMaxDelay"] = $0b8d464841156fc9$export$d89658363be37383;
module.exports["getDefaultStatusMultipliers"] = $0b8d464841156fc9$export$1b131e77a0e75a0a;
module.exports["jitterStatusMultipliers"] = $0b8d464841156fc9$export$a1d6d3ff41cd93e9;
module.exports["getReconnectDelayBounds"] = $0b8d464841156fc9$export$e5680a2329370bd3;

});

parcelRegister("3cnNA", function(module, exports) {

var $10d5H = parcelRequire("10d5H");

const $eb414ef0fc36a486$export$51a2bb897a605125 = new (0, $10d5H.ApolloLink)((operation, forward)=>{
    if (operation.variables && operation.variables.__extensions) {
        operation.setContext({
            extensions: operation.variables.__extensions
        });
        // remove the property since it's not an actual valid variable
        delete operation.variables.__extensions;
    }
    return forward(operation);
});
module.exports["AttachExtensionsLink"] = $eb414ef0fc36a486$export$51a2bb897a605125;

});

parcelRegister("i1t43", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $w6R6I = parcelRequire("w6R6I");


var $iDrrr = parcelRequire("iDrrr");


var $7vK9E = parcelRequire("7vK9E");

var $iMnC5 = parcelRequire("iMnC5");

const $7e44050607850249$var$styles = {
    base: "_0WKd3G4z3T",
    baseT26Shape: "_0bjKvDcjp5",
    visitedLink: "_2nTuUYWfPD _3ADzdEWfPD _1warJ9WfPD _4scvAwWyeI",
    defaultAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _1UtDYzM7Tp _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5M7Tp _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0clgaMM7Tp _3WzCGi98eZ _0NqVRtYbGa _3BKYwu6wH8 _0CMRbkAwSC",
    defaultAppearanceMotion: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzM7Tp _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5M7Tp _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMM7Tp _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbkAwSC",
    subtleAppearance: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1UtDYzZpcK _32C2rk98eZ _0i9AWAYbGa _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMZpcK _3WzCGi98eZ _0NqVRt0Rl6 _3BKYwu6wH8 _0CMRbky7kJ",
    subtleAppearanceMotion: "_00uqCYjOvk _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzZpcK _32C2rkjOvk _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMZpcK _3WzCGi98eZ _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbky7kJ",
    inverseAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _1UtDYze5R3 _2nTuUYe5R3 _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5e5R3 _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0clgaMe5R3 _3WzCGi98eZ _0NqVRtYbGa _3BKYwu6wH8 _0CMRbke5R3",
    inverseAppearanceMotion: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYze5R3 _2nTuUYe5R3 _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5e5R3 _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMe5R3 _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbke5R3",
    iconWrapper: "_3iDTPbS8kF _1ANEUSLRg7 _1RrJLiQame _1mT5xdRAKS _2I62gzVQEB"
};
const $7e44050607850249$var$iconStyles = null;
const $7e44050607850249$var$LinkWithoutRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(21);
    let children;
    let htmlAttributes;
    let newWindowLabel;
    let t1;
    let target;
    let testId;
    if ($[0] !== t0) {
        const { children: t2, testId: t3, appearance: t4, newWindowLabel: t5, target: t6, className: _preventedClassName, style: _preventedStyle, ...t7 } = t0;
        children = t2;
        testId = t3;
        t1 = t4;
        newWindowLabel = t5;
        target = t6;
        htmlAttributes = t7;
        $[0] = t0;
        $[1] = children;
        $[2] = htmlAttributes;
        $[3] = newWindowLabel;
        $[4] = t1;
        $[5] = target;
        $[6] = testId;
    } else {
        children = $[1];
        htmlAttributes = $[2];
        newWindowLabel = $[3];
        t1 = $[4];
        target = $[5];
        testId = $[6];
    }
    const appearance = t1 === undefined ? "default" : t1;
    let t2;
    if ($[7] !== appearance) {
        t2 = (0, $w6R6I.cx)($7e44050607850249$var$styles.base, (0, $iDrrr.fg)("platform-dst-shape-theme-default") && $7e44050607850249$var$styles.baseT26Shape, appearance === "default" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.defaultAppearanceMotion : $7e44050607850249$var$styles.defaultAppearance), appearance === "subtle" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.subtleAppearanceMotion : $7e44050607850249$var$styles.subtleAppearance), appearance === "inverse" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.inverseAppearanceMotion : $7e44050607850249$var$styles.inverseAppearance), appearance !== "inverse" && $7e44050607850249$var$styles.visitedLink);
        $[7] = appearance;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== target || $[10] !== testId) {
        t3 = target === "_blank" && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $7e44050607850249$var$styles.iconWrapper,
            testId: testId && `${testId}__icon`
        }, "\uFEFF", /*#__PURE__*/ $cozmU.createElement("svg", {
            width: "12",
            height: "12",
            viewBox: "0 0 12 12",
            fill: "none",
            className: (0, $hekY6.default)([
                "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
            ])
        }, /*#__PURE__*/ $cozmU.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
            fill: "currentColor"
        })));
        $[9] = target;
        $[10] = testId;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== children || $[13] !== htmlAttributes || $[14] !== newWindowLabel || $[15] !== ref || $[16] !== t2 || $[17] !== t3 || $[18] !== target || $[19] !== testId) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor), {
            ...htmlAttributes,
            target: target,
            ref: ref,
            xcss: t2,
            testId: testId,
            componentName: "Link",
            newWindowLabel: newWindowLabel
        }, children, t3);
        $[12] = children;
        $[13] = htmlAttributes;
        $[14] = newWindowLabel;
        $[15] = ref;
        $[16] = t2;
        $[17] = t3;
        $[18] = target;
        $[19] = testId;
        $[20] = t4;
    } else t4 = $[20];
    return t4;
} : ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $w6R6I.cx)($7e44050607850249$var$styles.base, (0, $iDrrr.fg)('platform-dst-shape-theme-default') && $7e44050607850249$var$styles.baseT26Shape, appearance === 'default' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.defaultAppearanceMotion : $7e44050607850249$var$styles.defaultAppearance), appearance === 'subtle' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.subtleAppearanceMotion : $7e44050607850249$var$styles.subtleAppearance), appearance === 'inverse' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.inverseAppearanceMotion : $7e44050607850249$var$styles.inverseAppearance), // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $7e44050607850249$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }, children, target === '_blank' && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $7e44050607850249$var$styles.iconWrapper,
        testId: testId && `${testId}__icon`
    }, "\uFEFF", /*#__PURE__*/ $cozmU.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $hekY6.default)([
            "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    }))));
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $7e44050607850249$var$Link = /*#__PURE__*/ (0, $cozmU.forwardRef)($7e44050607850249$var$LinkWithoutRef);
var $7e44050607850249$export$2e2bcd8739ae039 = $7e44050607850249$var$Link;
module.exports["default"] = $7e44050607850249$export$2e2bcd8739ae039;

});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

const $abc73c6f5c74c436$export$6d558eab13290f59 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
module.exports["useRouterLink"] = $abc73c6f5c74c436$export$6d558eab13290f59;

});

parcelRegister("ac2J9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1
        }, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});

parcelRegister("jPzTX", function(module, exports) {

var $lyW2B = parcelRequire("lyW2B");


var $e7pPJ = parcelRequire("e7pPJ");


var $d246i = parcelRequire("d246i");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $e6fea10dbb684687$var$flatRest(func) {
    return $d246i($e7pPJ(func, undefined, $lyW2B), func + '');
}
module.exports = $e6fea10dbb684687$var$flatRest;

});

parcelRegister("lyW2B", function(module, exports) {

var $avFJ9 = parcelRequire("avFJ9");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $fb29cba7dcd09042$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $avFJ9(array, 1) : [];
}
module.exports = $fb29cba7dcd09042$var$flatten;

});

parcelRegister("avFJ9", function(module, exports) {

var $8kPaX = parcelRequire("8kPaX");


var $eED1E = parcelRequire("eED1E");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $7a6d2ac83094702e$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $eED1E);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $7a6d2ac83094702e$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $8kPaX(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $7a6d2ac83094702e$var$baseFlatten;

});

parcelRegister("eED1E", function(module, exports) {

var $2v1OR = parcelRequire("2v1OR");


var $bZ5J1 = parcelRequire("bZ5J1");


var $1ScXu = parcelRequire("1ScXu");

/** Built-in value references. */ var $aab312c604d1130a$var$spreadableSymbol = $2v1OR ? $2v1OR.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $aab312c604d1130a$var$isFlattenable(value) {
    return $1ScXu(value) || $bZ5J1(value) || !!($aab312c604d1130a$var$spreadableSymbol && value && value[$aab312c604d1130a$var$spreadableSymbol]);
}
module.exports = $aab312c604d1130a$var$isFlattenable;

});

parcelRegister("4ZxLt", function(module, exports) {
/**
 * @generated SignedSource<<76836bee9d3181bb32ece1357a68e03f>>
 * @relayHash 8503b5ca122c8b61cd10af1b1c2004c9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b
const $cc63beb8a5381fdf$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeSpaceTypeSettings"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "dataClassificationTags"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "condition": "includeSpaceTypeSettings",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "SpaceTypeSettings",
                            "kind": "LinkedField",
                            "name": "spaceTypeSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "EnabledContentTypes",
                                    "kind": "LinkedField",
                                    "name": "enabledContentTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isLivePagesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isWhiteboardsEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDatabasesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isSlidesEnabled"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "8503b5ca122c8b61cd10af1b1c2004c9",
            "id": "3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b",
            "metadata": {},
            "name": "useSpaceDetailQuery",
            "operationKind": "query",
            "text": "query useSpaceDetailQuery($spaceKey:String,$includeSpaceTypeSettings:Boolean!){space(key:$spaceKey){id,name,alias,key,type,dataClassificationTags,homepage{id,title,type},icon{path},spaceTypeSettings@include(if:$includeSpaceTypeSettings){enabledContentTypes{isLivePagesEnabled,isWhiteboardsEnabled,isDatabasesEnabled,isSlidesEnabled}}}}"
        }
    };
}();
$cc63beb8a5381fdf$var$node.hash = "591d4790bc30ed0352bb44ad552d45cb";
var $cc63beb8a5381fdf$export$2e2bcd8739ae039 = $cc63beb8a5381fdf$var$node;
module.exports["default"] = $cc63beb8a5381fdf$export$2e2bcd8739ae039;

});

parcelRegister("lC6Qd", function(module, exports) {
/**
 * @generated SignedSource<<809e2044c3792f08e4a1f1fd3c386e1c>>
 * @relayHash eca6e9d325c97f4fd5880178ecc63561
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2e9338430096a14321d43ffc4d7c87126164ce6f2d44ea4ede01d437b0ec12d
const $03de5ecc01e321ee$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "cover-picture-id-draft",
                                        "cover-picture-id-published"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "number"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CoverPictureQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CoverPictureQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "eca6e9d325c97f4fd5880178ecc63561",
            "id": "e2e9338430096a14321d43ffc4d7c87126164ce6f2d44ea4ede01d437b0ec12d",
            "metadata": {},
            "name": "CoverPictureQuery",
            "operationKind": "query",
            "text": "query CoverPictureQuery($contentId:ID,$status:[String],$draftShareId:String){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"]){nodes{id,key,value,version{number}}}}}}"
        }
    };
}();
$03de5ecc01e321ee$var$node.hash = "cbe85309884dfe8220661d705f977e0f";
var $03de5ecc01e321ee$export$2e2bcd8739ae039 = $03de5ecc01e321ee$var$node;
module.exports["default"] = $03de5ecc01e321ee$export$2e2bcd8739ae039;

});

parcelRegister("nIvaQ", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $fXb84 = parcelRequire("fXb84");


var $7ZQNA = parcelRequire("7ZQNA");

const $c4f625141049567c$export$1248f2ac56981fbd = ()=>(0, $6mKj3.expValEquals)('platform_editor_early_exit_return_draft', 'isEnabled', true) ? (0, $fXb84.CollabDraftWithRelevanceQuery) : (0, $7ZQNA.CollabDraftQuery);
module.exports["getCollabDraftQuery"] = $c4f625141049567c$export$1248f2ac56981fbd;

});

parcelRegister("fXb84", function(module, exports) {

var $kiLxw = parcelRequire("kiLxw");

const $abbff5e8c5475947$export$fb92c84fb9714700 = (0, $kiLxw.default);
module.exports["CollabDraftWithRelevanceQuery"] = $abbff5e8c5475947$export$fb92c84fb9714700;

});

parcelRegister("kiLxw", function(module, exports) {
/**
 * @generated SignedSource<<c2d68d945c3fe4452d03d6bdc8ddfd5c>>
 * @relayHash 5eb9ba691ed48d80122a8d87074eee9c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 19ff778aa0cc634375733dc31cf334d93ce6c8c4e3dd7bf786f4393165965ee1
const $ff1e82bf0b897703$var$node = function() {
    var v0 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hydrateAdf"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "hydrateAdf",
                    "variableName": "hydrateAdf"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "CollabDraft",
            "kind": "LinkedField",
            "name": "collabDraft",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "document"
                },
                {
                    "kind": "ScalarField",
                    "name": "version"
                },
                {
                    "concreteType": "CollabDraftMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "relevance"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CollabDraftWithRelevanceQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CollabDraftWithRelevanceQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "5eb9ba691ed48d80122a8d87074eee9c",
            "id": "19ff778aa0cc634375733dc31cf334d93ce6c8c4e3dd7bf786f4393165965ee1",
            "metadata": {},
            "name": "CollabDraftWithRelevanceQuery",
            "operationKind": "query",
            "text": "query CollabDraftWithRelevanceQuery($id:ID!,$draftShareId:String=\"\",$hydrateAdf:Boolean){collabDraft(id:$id,draftShareId:$draftShareId,hydrateAdf:$hydrateAdf){document,version,metadata{title,relevance}}}"
        }
    };
}();
$ff1e82bf0b897703$var$node.hash = "c0bfcca7b64103265224238d7c18d9b1";
var $ff1e82bf0b897703$export$2e2bcd8739ae039 = $ff1e82bf0b897703$var$node;
module.exports["default"] = $ff1e82bf0b897703$export$2e2bcd8739ae039;

});

parcelRegister("7ZQNA", function(module, exports) {

var $lU81J = parcelRequire("lU81J");

const $270318977b9095e1$export$89183b1b5e58f33c = (0, $lU81J.default);
module.exports["CollabDraftQuery"] = $270318977b9095e1$export$89183b1b5e58f33c;

});

parcelRegister("lU81J", function(module, exports) {
/**
 * @generated SignedSource<<81d932c04171cccd3ee1c517fa2180ce>>
 * @relayHash cd92794db2ea2a3b9bfa36b4fb9ae833
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44e85cfd7f416b92fd30c810982ddfc4aeaa8b9ab964fe47829b79185c29b63a
const $e1affc2f9f206abd$var$node = function() {
    var v0 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hydrateAdf"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "hydrateAdf",
                    "variableName": "hydrateAdf"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "CollabDraft",
            "kind": "LinkedField",
            "name": "collabDraft",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "document"
                },
                {
                    "kind": "ScalarField",
                    "name": "version"
                },
                {
                    "concreteType": "CollabDraftMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CollabDraftQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CollabDraftQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "cd92794db2ea2a3b9bfa36b4fb9ae833",
            "id": "44e85cfd7f416b92fd30c810982ddfc4aeaa8b9ab964fe47829b79185c29b63a",
            "metadata": {},
            "name": "CollabDraftQuery",
            "operationKind": "query",
            "text": "query CollabDraftQuery($id:ID!,$draftShareId:String=\"\",$hydrateAdf:Boolean){collabDraft(id:$id,draftShareId:$draftShareId,hydrateAdf:$hydrateAdf){document,version,metadata{title}}}"
        }
    };
}();
$e1affc2f9f206abd$var$node.hash = "3cf6959ca06a0e7e4a4e60e0c720b14e";
var $e1affc2f9f206abd$export$2e2bcd8739ae039 = $e1affc2f9f206abd$var$node;
module.exports["default"] = $e1affc2f9f206abd$export$2e2bcd8739ae039;

});

parcelRegister("di8q4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("2RKSB"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("crLHf", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $57p4j = parcelRequire("57p4j");

const $e2c8b616e1533245$var$skeletonWrapperStyles = null;
const $e2c8b616e1533245$var$emojiSkeletonStyles = null;
const $e2c8b616e1533245$export$9fc60f86d5a6479f = (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const PLACEHOLDER_SIZE = props.height || 26;
    let t0;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== props.loadingMargin) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $hekY6.default)([
                    "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _39Ohv4YbGa _1SdfoHYbGa"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: props.loadingMargin
                },
                className: (0, $hekY6.default)([
                    "_2uo31fGsB2 _0bjKvDzXzM _2XghbEPgdg _3iDTPbvbI6 _0Of8r2Pgdg"
                ])
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = props.loadingMargin;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
module.exports["EmojiPlaceholder"] = $e2c8b616e1533245$export$9fc60f86d5a6479f;

});

parcelRegister("2RKSB", function(module, exports) {

let $2164e552f765a2c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2164e552f765a2c9$var$load("90vep"),
    $2164e552f765a2c9$var$load("bwLq7"),
    $2164e552f765a2c9$var$load("fH3TJ"),
    $2164e552f765a2c9$var$load("ipLRb"),
    $2164e552f765a2c9$var$load("5RCVQ"),
    $2164e552f765a2c9$var$load("6wr18"),
    $2164e552f765a2c9$var$load("ffEVr"),
    $2164e552f765a2c9$var$load("4Ldt2"),
    $2164e552f765a2c9$var$load("4izLy"),
    $2164e552f765a2c9$var$load("89O2I"),
    $2164e552f765a2c9$var$load("d7ovg"),
    $2164e552f765a2c9$var$load("953Uz"),
    $2164e552f765a2c9$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("N1nBh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
   * This will perform the given action at a scheduled time after the
   * component has painted.
   *
   * This is the default behavior.
   */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
   * This will perform the given action at the next animation frame (after the
   * component has been painted).
   */ ActionTiming["PAINT"] = "PAINT";
    /**
   * This will perform the given action at the moment its render function
   * fires.
   *
   * NOTE: This is called _within_ the render body, making it unpure. The
   * component is memoized, so it will fire this only once for a given set
   * of props. Be careful when using this, since it is unsafe.
   */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $cozmU.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $cozmU.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};
module.exports["ActionTiming"] = $4fef2d066feab689$export$6a673e74e98cdf55;
module.exports["usePerformanceAction"] = $4fef2d066feab689$export$454639fd58f598bd;

});

parcelRegister("18R9N", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6b4f0c0629e8427f$export$fda153f959d0066f = /*#__PURE__*/ (0, $cozmU.createContext)(false);
const $6b4f0c0629e8427f$export$b6c7102a78eb7f7f = ()=>(0, $cozmU.useContext)($6b4f0c0629e8427f$export$fda153f959d0066f);
module.exports["EmbeddedConfluenceTrackingContext"] = $6b4f0c0629e8427f$export$fda153f959d0066f;
module.exports["useIsEmbeddedTracking"] = $6b4f0c0629e8427f$export$b6c7102a78eb7f7f;

});

parcelRegister("jX1qB", function(module, exports) {
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$f6bd20f4f796eb89 = 'folder-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$40d92ab0c1cc5298 = 'comments-panel-deleted-content-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';
const $fa0ea3428ec5aa62$export$b3aade49b91bdeba = 'comments-panel-mentions-me-view';
module.exports["APP_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$9e40500efe28ac9e;
module.exports["BLOG_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$38b273cdbbf56c26;
module.exports["BYLINE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1ac23cd5807df863;
module.exports["READ_TIME_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$5bbb36bee09a5671;
module.exports["CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$a79607497a4a710c;
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c56a99673f1bb7bb;
module.exports["CONTENT_RENDERER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$140a493a9e781fe2;
module.exports["CONTENT_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1285ccb0399c01;
module.exports["FAVOURITE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$eb5bb54418693284;
module.exports["FOCUSED_INLINE_COMMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3fde425dbc74423b;
module.exports["INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6a58cce6529da40e;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$8910bc840e3ee4ce;
module.exports["RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf572571ca036b67;
module.exports["EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$644778267d4a4a82;
module.exports["PAGE_COMMENTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e4ff10a0a39a7217;
module.exports["PAGE_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6648c9be174e6923;
module.exports["FEED_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d3d6144128aaee3;
module.exports["PAGE_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499;
module.exports["RESTRICTIONS_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d1dfca9e0eb45581;
module.exports["GLOBAL_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$312db7b759bad970;
module.exports["SPACE_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$cf2a6bf49e73b304;
module.exports["SPACE_APPS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$84f6b5717c3fb962;
module.exports["WATCH_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1a423f2548c46be3;
module.exports["HOME_OVERVIEW_RECENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6426c6941656619;
module.exports["HOME_OVERVIEW_FEED_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$14f30a91623dfcf3;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c6926beb57b60636;
module.exports["HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$687913e127f52cc3;
module.exports["HOME_RECENTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0;
module.exports["HOME_STARRED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$76243e8aa4afaa0b;
module.exports["HOME_DRAFTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1df6f3f29083f48;
module.exports["END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7b32848c9413526a;
module.exports["IN_EDITOR_TEMPLATES_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$58fbb0ba50341103;
module.exports["NCS_CONNECTED_FMP_KEY"] = $fa0ea3428ec5aa62$export$4f481f063369df3c;
module.exports["ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1b9793e009e605;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$90bda069d4bf981b;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f11e1d4269141c0e;
module.exports["DATABASE_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$f0298cbab4a44998;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$cf2f52fec740bdea;
module.exports["OBJECT_HEADER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$52050233077a1838;
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1ab333f0b70b317;
module.exports["WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4;
module.exports["DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b95bd4bfc46932fc;
module.exports["FOLDER_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f6bd20f4f796eb89;
module.exports["SHARE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf838b84ba2f7b95;
module.exports["VIEW_PAGE_LABELS_METRIC_KEY"] = $fa0ea3428ec5aa62$export$79910402df6be117;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d86af34f7dc194b4;
module.exports["CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb;
module.exports["SPACE_PERMISSIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1939caa7fae28ef5;
module.exports["VIEW_PAGE_CONTAINER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3f06ee123a5ad183;
module.exports["EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$37da6122cd60d332;
module.exports["EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3437c1f145cfce19;
module.exports["EDITOR_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7903037283afbce0;
module.exports["OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$31d10d7597db11d3;
module.exports["COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b64d520f9b37dcd7;
module.exports["COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$50553e47471a0f5e;
module.exports["COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$40d92ab0c1cc5298;
module.exports["COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f2a6407ac901fd8d;
module.exports["COMMENTS_PANEL_MENTIONS_ME_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b3aade49b91bdeba;

});

parcelRegister("cD1qu", function(module, exports) {
var $7825447594ee3eb0$export$6ea4b0c62affbe44 = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}({});
var $7825447594ee3eb0$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "current";
    ContentStatus["DRAFT"] = "draft";
    ContentStatus["ARCHIVED"] = "archived";
    return ContentStatus;
}({});
const $7825447594ee3eb0$export$5d7c5e13dde1e9b8 = [
    "draft"
];
const $7825447594ee3eb0$export$c75005e52070dee = [
    "current"
];
module.exports["PageMode"] = $7825447594ee3eb0$export$6ea4b0c62affbe44;
module.exports["ContentStatus"] = $7825447594ee3eb0$export$b2be22e9d5dd3927;
module.exports["DRAFT_STATUS"] = $7825447594ee3eb0$export$5d7c5e13dde1e9b8;
module.exports["CURRENT_STATUS"] = $7825447594ee3eb0$export$c75005e52070dee;

});

parcelRegister("1ggpj", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $lx6jn = parcelRequire("lx6jn");

var $2aa2bdb281c6889a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["PAGE"] = "page";
    ContentType["BLOGPOST"] = "blogpost";
    ContentType["DATABASE"] = "database";
    ContentType["SLIDE"] = "slide";
    ContentType["EMBED"] = "embed";
    ContentType["FOLDER"] = "folder";
    return ContentType;
}({});
const $2aa2bdb281c6889a$export$31930b8b7828306b = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$e8b4d9d0d681efa4 = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name,
    (0, $1NBp8.EDIT_PAGE).name,
    (0, $1NBp8.EDIT_PAGE_V2).name
];
const $2aa2bdb281c6889a$export$142530096b49b828 = [
    "whiteboard",
    "database",
    "slide",
    "embed",
    "page",
    "folder",
    "blogpost"
];
const $2aa2bdb281c6889a$export$de22146d402d9bdd = {
    ["whiteboard"]: (0, $lx6jn.FeedbackSource).WHITEBOARD,
    ["embed"]: (0, $lx6jn.FeedbackSource).EMBED,
    ["database"]: (0, $lx6jn.FeedbackSource).DATABASE,
    ["slide"]: (0, $lx6jn.FeedbackSource).SLIDE
};
const $2aa2bdb281c6889a$export$4aba9c2e2995f563 = [
    "whiteboard",
    "slide"
];
const $2aa2bdb281c6889a$export$ea7ca1acbbc07168 = (contentType)=>!!contentType && $2aa2bdb281c6889a$export$4aba9c2e2995f563.includes(contentType);
const $2aa2bdb281c6889a$export$10c6f1bef31d587c = [
    'database',
    'slide',
    'embed',
    'folder'
];
const $2aa2bdb281c6889a$export$544bad8872c0b7ed = 400;
module.exports["ContentType"] = $2aa2bdb281c6889a$export$e2e108cbe2e4f865;
module.exports["ARCHIVE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$31930b8b7828306b;
module.exports["DELETE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$e8b4d9d0d681efa4;
module.exports["VALID_OPERATION_TARGETS"] = $2aa2bdb281c6889a$export$142530096b49b828;
module.exports["CONTENT_TYPE_FEEDBACK_SOURCE"] = $2aa2bdb281c6889a$export$de22146d402d9bdd;
module.exports["isCanvasContentType"] = $2aa2bdb281c6889a$export$ea7ca1acbbc07168;
module.exports["TYPES_WITH_ACTIVATIONID"] = $2aa2bdb281c6889a$export$10c6f1bef31d587c;
module.exports["onChangeTitleDebounceTime"] = $2aa2bdb281c6889a$export$544bad8872c0b7ed;

});

parcelRegister("lx6jn", function(module, exports) {
var $4d57d476a3596595$export$1953473fc535c5c1 = /*#__PURE__*/ function(FeedbackSource) {
    FeedbackSource["EDITOR"] = "Editor";
    FeedbackSource["HELP_PANEL"] = "Help Panel";
    FeedbackSource["THEME_SELECTOR"] = "Theme Selector";
    FeedbackSource["WHITEBOARD"] = "Whiteboard";
    FeedbackSource["EMBED"] = "Embed";
    FeedbackSource["DATABASE"] = "Database";
    FeedbackSource["NAV_4"] = "Nav4";
    FeedbackSource["SHARE_DIALOG"] = "Share Dialog";
    FeedbackSource["CONTENT_WRAPPER"] = "Content Wrapper";
    FeedbackSource["LIVE_DOCS"] = "Live Docs";
    FeedbackSource["EDITOR_CONTROLS"] = "Editor Controls";
    FeedbackSource["NOTES"] = "Notes";
    FeedbackSource["CREATE_WITH_ROVO"] = "Create with Rovo";
    FeedbackSource["SLIDE"] = "Slide";
    return FeedbackSource;
}({});
module.exports["FeedbackSource"] = $4d57d476a3596595$export$1953473fc535c5c1;

});

parcelRegister("6B1vK", function(module, exports) {

var $jyUkr = parcelRequire("jyUkr");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/page/manifest.ts
var $4cd75eda3ba03299$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jyUkr.ConfluencePageAriResourceOwner),
    resourceType: (0, $jyUkr.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $4cd75eda3ba03299$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $4cd75eda3ba03299$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $4cd75eda3ba03299$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $4cd75eda3ba03299$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $4cd75eda3ba03299$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $4cd75eda3ba03299$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $4cd75eda3ba03299$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["ConfluencePageAri"] = $4cd75eda3ba03299$export$3f931dd15d96caff;

});

parcelRegister("jyUkr", function(module, exports) {
// src/confluence/page/types.ts
var $e3dce2fc5add42f7$export$da53e4f7db4c6a71 = "confluence", $e3dce2fc5add42f7$export$636fc622562a2c5b = "page";
module.exports["ConfluencePageAriResourceOwner"] = $e3dce2fc5add42f7$export$da53e4f7db4c6a71;
module.exports["ConfluencePageAriResourceType"] = $e3dce2fc5add42f7$export$636fc622562a2c5b;

});

parcelRegister("7tHGa", function(module, exports) {
var $c76572742e8d6c54$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "CURRENT";
    ContentStatus["DRAFT"] = "DRAFT";
    ContentStatus["ARCHIVED"] = "ARCHIVED";
    return ContentStatus;
}({});
module.exports["ContentStatus"] = $c76572742e8d6c54$export$b2be22e9d5dd3927;

});

parcelRegister("gSfo4", function(module, exports) {

var $7tHGa = parcelRequire("7tHGa");

const $d569ee9ba15fe187$var$classificationContentStatusEnumToSingleContentSearchArrayMap = {
    [(0, $7tHGa.ContentStatus).CURRENT]: 'current',
    [(0, $7tHGa.ContentStatus).DRAFT]: 'draft',
    [(0, $7tHGa.ContentStatus).ARCHIVED]: 'archived'
};
const $d569ee9ba15fe187$var$getSingleContentStatusStringFromClassificationStatus = (status)=>{
    return $d569ee9ba15fe187$var$classificationContentStatusEnumToSingleContentSearchArrayMap[status];
};
const $d569ee9ba15fe187$export$930e5fd4dd47a5f1 = (statuses)=>{
    return statuses.map((status)=>$d569ee9ba15fe187$var$getSingleContentStatusStringFromClassificationStatus(status)).filter(Boolean);
};
module.exports["getQuerySingleContentStatusArrayVariable"] = $d569ee9ba15fe187$export$930e5fd4dd47a5f1;

});

parcelRegister("79mss", function(module, exports) {
/**
 * @generated SignedSource<<217ed72306ad0003c83611da9b9dfec7>>
 * @relayHash 02343eb4ab11fc6471bc117cd9c349d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f9794fe079d8566f47a9f279f6b1eb86fd6f7441be80aea326be0f0bc4e003d
const $22165adc85ae14ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "lowerCaseContentStatusArray"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "lowerCaseContentStatusArray"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "ClassificationLevelDetails",
                    "kind": "LinkedField",
                    "name": "classificationLevelDetails",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentDataClassificationLevel",
                            "kind": "LinkedField",
                            "name": "classificationLevel",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "guideline"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "guidelineADF"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "color"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "featureEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "source"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReclassificationPermitted"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canManageSpaceSettings"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "classificationControlSetting"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "userOverrideSetting"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentClassificationContentDataClassificationQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentClassificationContentDataClassificationQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "02343eb4ab11fc6471bc117cd9c349d2",
            "id": "2f9794fe079d8566f47a9f279f6b1eb86fd6f7441be80aea326be0f0bc4e003d",
            "metadata": {},
            "name": "useContentClassificationContentDataClassificationQuery",
            "operationKind": "query",
            "text": "query useContentClassificationContentDataClassificationQuery($contentId:ID!,$lowerCaseContentStatusArray:[String]){singleContent(id:$contentId,status:$lowerCaseContentStatusArray){id,classificationLevelDetails{classificationLevel{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting}}}"
        }
    };
}();
$22165adc85ae14ea$var$node.hash = "e2a3c90b94181436fe0a32faafb92cf6";
var $22165adc85ae14ea$export$2e2bcd8739ae039 = $22165adc85ae14ea$var$node;
module.exports["default"] = $22165adc85ae14ea$export$2e2bcd8739ae039;

});

parcelRegister("6m3nS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $e71ebdc70c2ecd2e$var$initialActiveTriggerState = {
    activeTriggerState: {}
};
const $e71ebdc70c2ecd2e$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $e71ebdc70c2ecd2e$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($e71ebdc70c2ecd2e$var$initialActiveTriggerState);
const $e71ebdc70c2ecd2e$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($e71ebdc70c2ecd2e$var$initialTriggerDispatchState);
const $e71ebdc70c2ecd2e$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [recordState, setRecordState] = (0, $cozmU.useState)({});
    const setTriggerState = (0, $cozmU.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setRecordState((current)=>{
            if (!!current[triggerId] === isActive) return current;
            if (isActive) return {
                ...current,
                [triggerId]: true
            };
            const { [triggerId]: excludedTrigger, ...rest } = current;
            return rest;
        });
    }, []);
    const triggerContextValue = (0, $cozmU.useMemo)(()=>({
            activeTriggerState: recordState
        }), [
        recordState
    ]);
    const triggerContexDispatchValue = (0, $cozmU.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e71ebdc70c2ecd2e$var$TriggerContext.Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e71ebdc70c2ecd2e$var$TriggerDispatchContext.Provider, {
        value: triggerContexDispatchValue
    }, children));
};
const $e71ebdc70c2ecd2e$export$454c1d7c35958f5e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerContext);
} : ()=>(0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerContext);
const $e71ebdc70c2ecd2e$export$23cbf084e08bdb93 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerDispatchContext);
} : ()=>(0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerDispatchContext);
const $e71ebdc70c2ecd2e$export$3b196fe93a948c18 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (triggerId)=>{
    const $ = (0, $bDgLe.c)(3);
    const { activeTriggerState: activeTriggerState } = $e71ebdc70c2ecd2e$export$454c1d7c35958f5e();
    let t0;
    if ($[0] !== activeTriggerState || $[1] !== triggerId) {
        t0 = triggerId ? {
            isActive: !!activeTriggerState[triggerId]
        } : {
            isActive: undefined
        };
        $[0] = activeTriggerState;
        $[1] = triggerId;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $e71ebdc70c2ecd2e$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: !!activeTriggerState[triggerId]
    } : {
        isActive: undefined
    };
};
const $e71ebdc70c2ecd2e$export$83b33e5fe4cce64 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { triggerId: triggerId } = t0;
    const { setTriggerState: setContextTriggerState } = $e71ebdc70c2ecd2e$export$23cbf084e08bdb93();
    let t1;
    if ($[0] !== setContextTriggerState || $[1] !== triggerId) {
        t1 = (t2)=>{
            const { isActive: isActive } = t2;
            return setContextTriggerState({
                triggerId: triggerId,
                isActive: isActive
            });
        };
        $[0] = setContextTriggerState;
        $[1] = triggerId;
        $[2] = t1;
    } else t1 = $[2];
    const fireTrigger = t1;
    let t2;
    if ($[3] !== fireTrigger) {
        t2 = {
            fireTrigger: fireTrigger
        };
        $[3] = fireTrigger;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $e71ebdc70c2ecd2e$export$23cbf084e08bdb93();
    const fireTrigger = (0, $cozmU.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $e71ebdc70c2ecd2e$export$e45375ff75169f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (messageId)=>{
    const $ = (0, $bDgLe.c)(17);
    const { isActive: hasMessageStarted } = $e71ebdc70c2ecd2e$export$3b196fe93a948c18(`${messageId}-started`);
    const t0 = `${messageId}-start`;
    let t1;
    if ($[0] !== t0) {
        t1 = {
            triggerId: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { fireTrigger: requestMessageStartTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t1);
    const t2 = `${messageId}-dismiss`;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            triggerId: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const { fireTrigger: fireDismissClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t3);
    const t4 = `${messageId}-cta-click`;
    let t5;
    if ($[4] !== t4) {
        t5 = {
            triggerId: t4
        };
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    const { fireTrigger: fireCtaClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t5);
    let t6;
    if ($[6] !== requestMessageStartTrigger) {
        t6 = ()=>{
            requestMessageStartTrigger({
                isActive: true
            });
        };
        $[6] = requestMessageStartTrigger;
        $[7] = t6;
    } else t6 = $[7];
    const requestMessageStart = t6;
    let t7;
    if ($[8] !== fireDismissClickTrigger) {
        t7 = ()=>{
            fireDismissClickTrigger({
                isActive: true
            });
        };
        $[8] = fireDismissClickTrigger;
        $[9] = t7;
    } else t7 = $[9];
    const dismissMessage = t7;
    let t8;
    if ($[10] !== fireCtaClickTrigger) {
        t8 = ()=>{
            fireCtaClickTrigger({
                isActive: true
            });
        };
        $[10] = fireCtaClickTrigger;
        $[11] = t8;
    } else t8 = $[11];
    const handlePostOfficeClickTracking = t8;
    let t9;
    if ($[12] !== dismissMessage || $[13] !== handlePostOfficeClickTracking || $[14] !== hasMessageStarted || $[15] !== requestMessageStart) {
        t9 = {
            hasMessageStarted: hasMessageStarted,
            requestMessageStart: requestMessageStart,
            dismissMessage: dismissMessage,
            handlePostOfficeClickTracking: handlePostOfficeClickTracking
        };
        $[12] = dismissMessage;
        $[13] = handlePostOfficeClickTracking;
        $[14] = hasMessageStarted;
        $[15] = requestMessageStart;
        $[16] = t9;
    } else t9 = $[16];
    return t9;
} : (messageId)=>{
    // listeners
    const { isActive: hasMessageStarted } = $e71ebdc70c2ecd2e$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $cozmU.useCallback)(()=>{
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger
    ]);
    const dismissMessage = (0, $cozmU.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $cozmU.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};
module.exports["TriggerContextProvider"] = $e71ebdc70c2ecd2e$export$e80a5720bb4c8fe3;
module.exports["useTrigger"] = $e71ebdc70c2ecd2e$export$3b196fe93a948c18;
module.exports["useFirePostOfficeTrigger"] = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64;
module.exports["usePostOfficeExernalMessageProxy"] = $e71ebdc70c2ecd2e$export$e45375ff75169f;

});

parcelRegister("fmu9K", function(module, exports) {
$parcel$export(module.exports, "FabricChannel", () => (parcelRequire("iTJtk")).FabricChannel);

var $hpWmZ = parcelRequire("hpWmZ");


var $lMjmr = parcelRequire("lMjmr");


var $iTJtk = parcelRequire("iTJtk");


});

parcelRegister("gsyiL", function(module, exports) {

var $eQkRH = parcelRequire("eQkRH");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/blogpost/manifest.ts
var $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $eQkRH.ConfluenceBlogpostAriResourceOwner),
    resourceType: (0, $eQkRH.ConfluenceBlogpostAriResourceType),
    resourceIdSlug: "{blogpostId}",
    resourceIdSegmentFormats: {
        blogpostId: /[0-9]+/
    }
};
// src/confluence/blogpost/index.ts
var $bfb9de7804f5bb44$export$8602a2c2f6ac09bc = class _ConfluenceBlogpostAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get blogpostId() {
        return this._blogpostId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts.qualifier,
            platformQualifier: $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts.resourceOwner,
            resourceType: $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts.resourceType,
            resourceId: `${opts.blogpostId}`,
            resourceIdSegmentValues: {
                blogpostId: opts.blogpostId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            blogpostId: this.blogpostId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._blogpostId = opts.resourceIdSegmentValues.blogpostId;
    }
};
module.exports["ConfluenceBlogpostAri"] = $bfb9de7804f5bb44$export$8602a2c2f6ac09bc;

});

parcelRegister("eQkRH", function(module, exports) {
// src/confluence/blogpost/types.ts
var $ace61b64202bfb2d$export$9389f06bd1d0765c = "confluence", $ace61b64202bfb2d$export$fb777a2d645a4129 = "blogpost";
module.exports["ConfluenceBlogpostAriResourceOwner"] = $ace61b64202bfb2d$export$9389f06bd1d0765c;
module.exports["ConfluenceBlogpostAriResourceType"] = $ace61b64202bfb2d$export$fb777a2d645a4129;

});

parcelRegister("36Uax", function(module, exports) {

var $bVevd = parcelRequire("bVevd");


var $kTPbu = parcelRequire("kTPbu");

var $dcf2160d889b63fd$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $dcf2160d889b63fd$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share',
        'enable-redirection',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar',
        'loom-external-open'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        // @deprecated: use template-browser-panel instead.
        'template-browser',
        'template-browser-panel',
        'blank-page-quick-actions',
        'inline-comments',
        'disable-publish-close-buttons',
        'disable-close-button',
        'loom-external-open',
        'rovo',
        'enable-share'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $dcf2160d889b63fd$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $dcf2160d889b63fd$var$pageAllowedFeatures = {
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.edit,
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.view
};
const $dcf2160d889b63fd$var$blogPostAllowedFeatures = {
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.edit,
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.view
};
const $dcf2160d889b63fd$var$whiteboardAllowedFeatures = {
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.whiteboard
};
const $dcf2160d889b63fd$var$contentTypeAllowedFeatures = {
    [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $dcf2160d889b63fd$var$pageAllowedFeatures,
    [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $dcf2160d889b63fd$var$blogPostAllowedFeatures,
    [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $dcf2160d889b63fd$var$whiteboardAllowedFeatures
};
const $dcf2160d889b63fd$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$dcf2160d889b63fd$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];
module.exports["ALLOWED_FEATURES"] = $dcf2160d889b63fd$export$a3fda3dcee62e1cc;
module.exports["DEFAULT_ALLOWED_FEATURES"] = $dcf2160d889b63fd$export$a33327ada3a6ee4a;
module.exports["getAllowedFeatures"] = $dcf2160d889b63fd$export$3207c60940c4a9b0;

});

parcelRegister("bVevd", function(module, exports) {
var $3914485ee940289d$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
module.exports["EMBEDDED_CONFLUENCE_MODE"] = $3914485ee940289d$export$816ef638e478449a;

});

parcelRegister("kTPbu", function(module, exports) {
var $eaa06f5f4964dde1$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});
module.exports["EMBEDDED_CONFLUENCE_CONTENT_TYPE"] = $eaa06f5f4964dde1$export$942a5fac9b8c9dc2;

});

parcelRegister("boaiH", function(module, exports) {

var $2gr4B = parcelRequire("2gr4B");

class $ffade2ccf1ecf3ef$export$12b6b072930fd68f {
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $2gr4B.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    updateAttributes({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.updateAttributes(attributes);
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = void 0;
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
}
module.exports["ExperienceTracker"] = $ffade2ccf1ecf3ef$export$12b6b072930fd68f;

});

parcelRegister("2gr4B", function(module, exports) {

var $apqal = parcelRequire("apqal");

function $8617e1b2001e7e7c$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $8617e1b2001e7e7c$export$c90b54e658fc4d7c {
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $apqal.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    updateAttributes(attributes) {
        this.attributes = {
            ...this.attributes,
            ...attributes
        };
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this.name = void 0;
        this.id = void 0;
        this.timeout = void 0;
        this._hasStopped = false;
        this.startTime = void 0;
        this.attributes = void 0;
        this.onStop = void 0;
        this.onSuccess = void 0;
        this.onFailure = void 0;
        this.onAbort = void 0;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
}
module.exports["Experience"] = $8617e1b2001e7e7c$export$c90b54e658fc4d7c;

});

parcelRegister("apqal", function(module, exports) {
class $f9800b995ac71735$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}
module.exports["ExperienceTimeoutError"] = $f9800b995ac71735$export$d27a2b6293f7631c;

});

parcelRegister("nStJY", function(module, exports) {

var $gO7n9 = parcelRequire("gO7n9");


var $jPzTX = parcelRequire("jPzTX");

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $047c686ddfb588a6$var$pick = $jPzTX(function(object, paths) {
    return object == null ? {} : $gO7n9(object, paths);
});
module.exports = $047c686ddfb588a6$var$pick;

});

parcelRegister("gO7n9", function(module, exports) {

var $3Bix5 = parcelRequire("3Bix5");


var $h7loT = parcelRequire("h7loT");

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $c3c708e20cb40f59$var$basePick(object, paths) {
    return $3Bix5(object, paths, function(value, path) {
        return $h7loT(object, path);
    });
}
module.exports = $c3c708e20cb40f59$var$basePick;

});

parcelRegister("5vi32", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lTECB = parcelRequire("lTECB");


var $7zgzO = parcelRequire("7zgzO");

function $36802f16e927d19b$export$c850f609dc850980() {
    const { location: location } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    return (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)(location || window.location);
}
module.exports["useIsEmbeddedConfluence_DO_NOT_USE"] = $36802f16e927d19b$export$c850f609dc850980;

});

parcelRegister("dA1Sn", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");

const $18ccf8477934fc9e$export$2a8604960d7d23d9 = 30000;
const $18ccf8477934fc9e$var$useTwoStageHydration = (name, enabled)=>{
    const fullCycleOutput = window.__FULLCYCLE__?.[name];
    const isNoFullCycleOutput = (0, $6mKj3.expValEquals)('platform_editor_editor_ssr_streaming', 'isEnabled', true) ? fullCycleOutput === undefined : !fullCycleOutput;
    const isNoSSR = !window.__SSR_RENDERED__;
    // Rely on a normal hydration/rendering flow when it's a transition or there's no full cycle output
    // or when experience is not hydratable
    const [hydrated, setHydrated] = (0, $cozmU.useState)(isNoSSR || isNoFullCycleOutput || !window.__HYDRATABLE__ || !enabled);
    (0, $cozmU.useEffect)(()=>{
        setHydrated(true);
        const cleanup = ()=>{
            delete window.__FULLCYCLE__?.[name];
        };
        // Arbitrary 30s CLEANUP_TIMEOUT to allow for the element to be rendered before removal
        // to not force an unecessary re-render or flash of blank content, even in slowest cases
        setTimeout(cleanup, $18ccf8477934fc9e$export$2a8604960d7d23d9);
        return cleanup;
    }, [
        name
    ]);
    return {
        hydrated: hydrated,
        fullCycleOutput: fullCycleOutput
    };
};
const $18ccf8477934fc9e$export$ca5d80b93e3e21b2 = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals -- the saveFullCycleOutput() only runs in the browser
    const nodesForPartialHydration = document.querySelectorAll('[data-fullcycle-name]');
    if (nodesForPartialHydration.length > 0) window.__FULLCYCLE__ = Array.from(nodesForPartialHydration).reduce((acc, node)=>{
        acc[node.dataset.fullcycleName] = node.innerHTML;
        return acc;
    }, {});
};
const $18ccf8477934fc9e$export$137b13ff1789fa49 = (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { style: style, name: name, children: children, enabled: t1, ssrPlaceholder: t2 } = t0;
    const enabled = t1 === undefined ? false : t1;
    const ssrPlaceholder = t2 === undefined ? false : t2;
    const { hydrated: hydrated, fullCycleOutput: fullCycleOutput } = $18ccf8477934fc9e$var$useTwoStageHydration(name, enabled);
    if ((0, $6mKj3.expValEquals)("cc_fix_hydration_ttvc", "isEnabled", true)) {
        if (!enabled) return children;
        if (hydrated) {
            let t3;
            if ($[0] !== name || $[1] !== ssrPlaceholder) {
                t3 = ssrPlaceholder ? {
                    "data-ssr-placeholder": name,
                    "data-ssr-placeholder-replace": name
                } : {};
                $[0] = name;
                $[1] = ssrPlaceholder;
                $[2] = t3;
            } else t3 = $[2];
            let t4;
            if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
                t4 = {
                    position: "relative",
                    height: "100%",
                    width: "100%"
                };
                $[3] = t4;
            } else t4 = $[3];
            let t5;
            if ($[4] !== children || $[5] !== name || $[6] !== t3) {
                t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    "data-testid": "two-stage-hydration",
                    "data-fullcycle-name": name,
                    ...t3,
                    style: t4
                }, children);
                $[4] = children;
                $[5] = name;
                $[6] = t3;
                $[7] = t5;
            } else t5 = $[7];
            return t5;
        }
        const innerHTML = fullCycleOutput;
        let t3;
        if ($[8] !== name || $[9] !== ssrPlaceholder) {
            t3 = ssrPlaceholder ? {
                "data-ssr-placeholder": name,
                "data-ssr-placeholder-replace": name
            } : {};
            $[8] = name;
            $[9] = ssrPlaceholder;
            $[10] = t3;
        } else t3 = $[10];
        let t4;
        if ($[11] !== innerHTML) {
            t4 = {
                __html: innerHTML
            };
            $[11] = innerHTML;
            $[12] = t4;
        } else t4 = $[12];
        let t5;
        if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = {
                position: "relative",
                height: "100%",
                width: "100%"
            };
            $[13] = t5;
        } else t5 = $[13];
        let t6;
        if ($[14] !== name || $[15] !== t3 || $[16] !== t4) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "data-testid": "two-stage-hydration",
                "data-fullcycle-name": name,
                ...t3,
                dangerouslySetInnerHTML: t4,
                style: t5
            });
            $[14] = name;
            $[15] = t3;
            $[16] = t4;
            $[17] = t6;
        } else t6 = $[17];
        return t6;
    }
    if (!enabled || hydrated) return children;
    const innerHTML_0 = fullCycleOutput;
    let t3;
    if ($[22] !== innerHTML_0) {
        t3 = {
            __html: innerHTML_0
        };
        $[22] = innerHTML_0;
        $[23] = t3;
    } else t3 = $[23];
    let t4;
    if ($[24] !== name || $[25] !== style || $[26] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: style,
            "data-testid": "two-stage-hydration",
            "data-fullcycle-name": name,
            dangerouslySetInnerHTML: t3
        });
        $[24] = name;
        $[25] = style;
        $[26] = t3;
        $[27] = t4;
    } else t4 = $[27];
    return t4;
};
const $18ccf8477934fc9e$export$b6db8e1e111c3550 = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { name: name, style: style, children: children, enabled: t1, ssrPlaceholder: t2 } = t0;
    const enabled = t1 === undefined ? true : t1;
    const ssrPlaceholder = t2 === undefined ? false : t2;
    let t3;
    if ($[0] !== children || $[1] !== enabled || $[2] !== name || $[3] !== ssrPlaceholder || $[4] !== style) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($18ccf8477934fc9e$export$137b13ff1789fa49, {
            name: name,
            style: style,
            enabled: enabled,
            ssrPlaceholder: ssrPlaceholder
        }, children);
        $[0] = children;
        $[1] = enabled;
        $[2] = name;
        $[3] = ssrPlaceholder;
        $[4] = style;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
};
module.exports["saveFullCycleOutput"] = $18ccf8477934fc9e$export$ca5d80b93e3e21b2;
module.exports["TwoStageHydration"] = $18ccf8477934fc9e$export$b6db8e1e111c3550;

});

parcelRegister("7aRa9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $cozmU.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("bJX6u", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");

const $258e0d668fcd3778$export$7e292eecf5a8f340 = {
    contentState: null,
    contentStateLastUpdated: null,
    shouldRunContentStateEffect: true,
    defaultStatesArray: [],
    customStatesArray: [],
    isContentStateEnabled: true,
    isSuggestedEnabled: true,
    isCustomEnabled: true,
    isUpdating: false,
    lastFetchedIsDraft: null,
    lastFetchedContentId: null
};
class $258e0d668fcd3778$export$ade89fbf99f42685 extends (0, $kNIYN.Container) {
    populateState(ssrContentStateData) {
        const newContentStateValues = Object.assign({}, $258e0d668fcd3778$export$7e292eecf5a8f340);
        newContentStateValues.shouldRunContentStateEffect = false;
        newContentStateValues.contentState = ssrContentStateData?.singleContent?.contentState || null;
        newContentStateValues.contentStateLastUpdated = ssrContentStateData?.singleContent?.contentStateLastUpdated?.value || null;
        newContentStateValues.defaultStatesArray = ssrContentStateData?.availableContentStates?.spaceContentStates?.filter((i)=>!!i) || [];
        newContentStateValues.customStatesArray = ssrContentStateData?.availableContentStates?.customContentStates?.filter((i)=>!!i) || [];
        // If an admin has turned off a toggle, BE returns us the value as null
        // If an empty array is returned [], means the feature is still enabled - there's just no values in there.
        // if both return as null it means the admin disabled content states
        const isSuggestedContentStatesDisabled = !ssrContentStateData?.availableContentStates?.spaceContentStates;
        const isCustomContentStatesDisabled = !ssrContentStateData?.availableContentStates?.customContentStates;
        const isContentStatesDisabled = isSuggestedContentStatesDisabled && isCustomContentStatesDisabled;
        if (isContentStatesDisabled) newContentStateValues.isContentStateEnabled = false;
        else if (isSuggestedContentStatesDisabled) // if spaceContentStates is null, admin disabled suggested
        newContentStateValues.isSuggestedEnabled = false;
        else if (isCustomContentStatesDisabled) // if customContentStates is null, admin disabled custom
        newContentStateValues.isCustomEnabled = false;
        this.state = newContentStateValues;
    }
    constructor(ssrContentStateData){
        super();
        this.state = {
            ...$258e0d668fcd3778$export$7e292eecf5a8f340
        };
        // Guards optimistic, mutation-owned fields (applied status + option list) from being
        // clobbered by stale refetches while an operation is pending. Kept off `state` so it
        // survives the refetch-driven `setInitialValues` calls.
        this.isOptimisticOperationPending = false;
        this.setIsOptimisticOperationPending = (isOptimisticOperationPending)=>{
            this.isOptimisticOperationPending = isOptimisticOperationPending;
        };
        // The contentId for which the empty add-status trigger should be kept visible after a
        // view-mode delete. Stored as an id (not a boolean) so render can scope it to the current page
        // without a navigation listener — it's only honored while this matches the active contentId,
        // so it naturally clears on navigation. Kept off `state` so a fresh container (refresh) resets it.
        this.keepEmptyTriggerForContentId = null;
        this.setKeepEmptyTriggerForContentId = (contentId)=>{
            this.keepEmptyTriggerForContentId = contentId;
        };
        this.setContentState = (contentState)=>this.setState({
                contentState: contentState
            });
        this.setShouldRunContentStateEffect = (shouldRunContentStateEffect)=>this.setState({
                shouldRunContentStateEffect: shouldRunContentStateEffect
            });
        this.setDefaultStatesArray = (defaultStatesArray)=>this.setState({
                defaultStatesArray: defaultStatesArray
            });
        this.setCustomStatesArray = (customStatesArray)=>this.setState({
                customStatesArray: customStatesArray
            });
        this.setIsContentStateEnabled = (isContentStateEnabled)=>this.setState({
                isContentStateEnabled: isContentStateEnabled
            });
        this.setIsSuggestedEnabled = (isSuggestedEnabled)=>this.setState({
                isSuggestedEnabled: isSuggestedEnabled
            });
        this.setIsCustomEnabled = (isCustomEnabled)=>this.setState({
                isCustomEnabled: isCustomEnabled
            });
        this.setIsUpdating = (isUpdating)=>this.setState({
                isUpdating: isUpdating
            });
        this.setLastFetchedIsDraft = (lastFetchedIsDraft)=>this.setState({
                lastFetchedIsDraft: lastFetchedIsDraft
            });
        this.setLastFetchedContentId = (lastFetchedContentId)=>this.setState({
                lastFetchedContentId: lastFetchedContentId
            });
        this.setInitialValues = (contentStateState)=>this.setState(contentStateState);
        this.resetToDefaults = ()=>this.setState({
                ...$258e0d668fcd3778$export$7e292eecf5a8f340
            });
        if (ssrContentStateData) this.populateState(ssrContentStateData);
    }
}
module.exports["defaultValues"] = $258e0d668fcd3778$export$7e292eecf5a8f340;
module.exports["ContentStateStateContainer"] = $258e0d668fcd3778$export$ade89fbf99f42685;

});

parcelRegister("4GGNn", function(module, exports) {

var $jhbO3 = parcelRequire("jhbO3");


var $GLgaM = parcelRequire("GLgaM");


var $bjeS8 = parcelRequire("bjeS8");

async function $aeaa62655b9da260$export$4199ef03ec2aea3f({ url: url, method: method, headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError }) {
    const fetchData = async ()=>{
        const json = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, variables);
        return await parseResult(json, variables);
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $jhbO3.apolloCompatibleMutation)({
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalMutate"] = $aeaa62655b9da260$export$4199ef03ec2aea3f;

});

parcelRegister("de2j9", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name || routeName === (0, $1NBp8.SPACE_SETTINGS_AGENT_CONTEXT).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
};
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("hYoU4", function(module, exports) {

var $nStJY = parcelRequire("nStJY");


var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");

const $cf3a2c4e252823d7$export$79b973328ab6a08a = {
    collabEditProvider: null,
    collabEditInitialized: false,
    hasInitialDraft: false,
    isDraftSyncPending: false,
    collabEditConnected: false
};
const $cf3a2c4e252823d7$export$e324594224ef24da = {
    setCollabEditProvider: (collabEditProvider)=>({ setState: setState })=>{
            setState({
                collabEditProvider: collabEditProvider
            });
        },
    setCollabEditInitialized: (collabEditInitialized)=>({ setState: setState })=>{
            setState({
                collabEditInitialized: collabEditInitialized
            });
        },
    setHasInitialDraft: (hasInitialDraft)=>({ setState: setState })=>{
            setState({
                hasInitialDraft: hasInitialDraft
            });
        },
    setIsDraftSyncPending: // PGXT-3849 Remove this if we update lodash to 5.0+ and use debounce.pending() instead
    (isDraftSyncPending)=>({ setState: setState })=>{
            setState({
                isDraftSyncPending: isDraftSyncPending
            });
        },
    setCollabEditConnected: (collabEditConnected)=>({ setState: setState })=>{
            setState({
                collabEditConnected: collabEditConnected
            });
        },
    resetNativeCollabState: ()=>({ setState: setState })=>{
            setState({
                collabEditProvider: null,
                collabEditInitialized: false,
                hasInitialDraft: false,
                isDraftSyncPending: false,
                collabEditConnected: false
            });
        }
};
const $cf3a2c4e252823d7$export$a3d4598f4626641c = (0, $8s9DV.createStore)({
    initialState: {
        ...$cf3a2c4e252823d7$export$79b973328ab6a08a
    },
    actions: $cf3a2c4e252823d7$export$e324594224ef24da,
    name: 'nativeCollabState'
});
const $cf3a2c4e252823d7$export$8af37259b4604092 = (0, $j8on0.createContainer)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    onInit: ()=>async ({ dispatch: dispatch }, { initialCollabState: initialCollabState })=>{
            initialCollabState?.collabEditProvider && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditProvider(initialCollabState?.collabEditProvider));
            initialCollabState?.collabEditInitialized && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditInitialized(initialCollabState?.collabEditInitialized));
            initialCollabState?.hasInitialDraft && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setHasInitialDraft(initialCollabState?.hasInitialDraft));
            initialCollabState?.isDraftSyncPending && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setIsDraftSyncPending(initialCollabState?.isDraftSyncPending));
            initialCollabState?.collabEditConnected && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditConnected(initialCollabState?.collabEditConnected));
        }
});
const $cf3a2c4e252823d7$export$b01c6ac62a4aed2c = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'collabEditProvider', 'collabEditInitialized', 'hasInitialDraft')
});
const $cf3a2c4e252823d7$export$3f0287ea828df991 = (0, $kBr4q.createActionsHook)($cf3a2c4e252823d7$export$a3d4598f4626641c);
const $cf3a2c4e252823d7$export$31e00ebc52451b8e = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'isDraftSyncPending')
});
const $cf3a2c4e252823d7$export$4bfbf4dd405bc207 = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'collabEditConnected')
});
module.exports["useNativeCollabState"] = $cf3a2c4e252823d7$export$b01c6ac62a4aed2c;
module.exports["useNativeCollabActions"] = $cf3a2c4e252823d7$export$3f0287ea828df991;
module.exports["useNativeCollabDraftSync"] = $cf3a2c4e252823d7$export$31e00ebc52451b8e;
module.exports["useNativeCollabConnected"] = $cf3a2c4e252823d7$export$4bfbf4dd405bc207;

});

parcelRegister("4PNpW", function(module, exports) {

var $36Uax = parcelRequire("36Uax");

const $ff056bb0ad02bd7c$export$1acbaeb6a9a6bc40 = (0, $36Uax.ALLOWED_FEATURES).view;
const $ff056bb0ad02bd7c$export$2c7469b01e61fde2 = (0, $36Uax.ALLOWED_FEATURES).edit;
const $ff056bb0ad02bd7c$export$72afc086e90eb0bf = (0, $36Uax.ALLOWED_FEATURES).whiteboard;
module.exports["VIEW_PAGE_FEATURES"] = $ff056bb0ad02bd7c$export$1acbaeb6a9a6bc40;
module.exports["EDIT_PAGE_FEATURES"] = $ff056bb0ad02bd7c$export$2c7469b01e61fde2;
module.exports["WHITEBOARD_FEATURES"] = $ff056bb0ad02bd7c$export$72afc086e90eb0bf;

});

parcelRegister("gyiJY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1eD4P = parcelRequire("1eD4P");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");

const $b2e9e223d7519ab7$var$QUERY_NAME = 'initialAllowedFeatures';
var $b2e9e223d7519ab7$export$2ba0e67b02c658ce = /*#__PURE__*/ function(FeatureMode) {
    FeatureMode["VIEW"] = "view";
    FeatureMode["EDIT"] = "edit";
    FeatureMode["WHITEBOARD"] = "whiteboard";
    return FeatureMode;
}({});
function $b2e9e223d7519ab7$export$745a9b66a8f1814a() {
    const { allowedFeatures: allowedFeatures } = (0, $1eD4P.useReactProps_DO_NOT_USE)() || {};
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    /**
	 * When allowedFeatures passthrough props not available but query param `initialAllowedFeatures` available, we resolve allowedFeatures from this query param
	 * After allowedFeatures passthrough props become available again at SPA, the allowedFeatures should be resolved by passthrough props
	 * This is needed for rendering consistent features between SSR and SPA phases, as SSR phase cannot resolve passthrough props through `window.postMessage`
	 *
	 * E.g.
	 * - `?embedded=true&initialAllowedFeatures=edit,delete` should only enable Edit and Delete features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=all` should enable all features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=` should enable no features in SSR phase
	 */ const queriedAllowedFeatures = (0, $cozmU.useMemo)(()=>(0, $c3Qwv.getSingleParam)(getQueryParams(), $b2e9e223d7519ab7$var$QUERY_NAME), [
        getQueryParams
    ]);
    const initialAllowedFeatures = (0, $cozmU.useMemo)(()=>{
        let features;
        if (queriedAllowedFeatures === '') features = [];
        else if (queriedAllowedFeatures === 'all') features = 'all';
        else // There is a bug to be fixed where comma "," in query param will break view page SSR https://product-fabric.atlassian.net/browse/SCALE-5274
        // Workaround is to allow "." as query param separator instead of comma ",". Use regex here to support both characters.
        features = queriedAllowedFeatures?.split(/[\s,.]+/).map((feature)=>{
            try {
                return JSON.parse(feature);
            } catch (error) {
                return feature;
            }
        }) ?? undefined;
        return features;
    }, [
        queriedAllowedFeatures
    ]);
    // Ensure the return type matches UseAllowedFeaturesType<T>
    if (!allowedFeatures && initialAllowedFeatures !== undefined) return initialAllowedFeatures;
    return allowedFeatures;
}
module.exports["useAllowedFeatures"] = $b2e9e223d7519ab7$export$745a9b66a8f1814a;

});

parcelRegister("cxu5H", function(module, exports) {

var $36Uax = parcelRequire("36Uax");

var $4PNpW = parcelRequire("4PNpW");


var $gyiJY = parcelRequire("gyiJY");

const { view: $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $36Uax.DEFAULT_ALLOWED_FEATURES);
const $9b72a1c744147957$export$f9f73b7eca94463f = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)();
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-share" out of allowedViewPageFeatures,
	 * so that the Share button won't be disable when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-share',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar'
    ];
    const allowedViewPageFeatures = allowedFeatures === 'all' ? (0, $4PNpW.VIEW_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const showShare = !(allowedViewPageFeatures?.includes('disable-share') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-share'));
    return {
        showShare: showShare,
        hasByLineContributors: allowedViewPageFeatures?.includes('byline-contributors') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('byline-contributors'),
        hasByLineExtensions: allowedViewPageFeatures?.includes('byline-extensions') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('byline-extensions'),
        hasPageReactions: allowedViewPageFeatures?.includes('page-reactions') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('page-reactions'),
        hasStickyHeader: allowedViewPageFeatures?.includes('sticky-header') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('sticky-header'),
        showEdit: allowedViewPageFeatures?.includes('edit') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('edit'),
        showDelete: allowedViewPageFeatures?.includes('delete') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('delete'),
        hasComments: allowedViewPageFeatures?.includes('page-comments') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('page-comments'),
        hasInlineCommentsAndHighlightActions: allowedViewPageFeatures?.includes('inline-comments') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('inline-comments'),
        includeNonLicensedUsersToShare: showShare && (allowedViewPageFeatures?.includes('non-licensed-share') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('non-licensed-share')),
        hasModernHeader: allowedViewPageFeatures?.includes('modern-header') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('modern-header'),
        hideHelpButton: allowedViewPageFeatures?.includes('disable-help-button') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-help-button'),
        hideTitleToolbar: allowedViewPageFeatures?.includes('disable-title-toolbar') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-title-toolbar'),
        loomExternalOpenRoute: allowedViewPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route
    };
};
module.exports["useEmbeddedViewPageFeatures"] = $9b72a1c744147957$export$f9f73b7eca94463f;

});

parcelRegister("aSsfA", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $cD1qu = parcelRequire("cD1qu");

const $1874c19402f3b5d2$export$da5a0d0942eec3a4 = ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
};
module.exports["useGetPageMode"] = $1874c19402f3b5d2$export$da5a0d0942eec3a4;

});

parcelRegister("i7cz5", function(module, exports) {
const $1b581ea1c80d4d76$var$ROVO_RECEIVER_ID_DATA_ATTR = 'data-rovo-receiver-id';
const $1b581ea1c80d4d76$var$ROVO_CHILD_ID_QUERY_PARAM_KEY = 'nativeEmbedChildId';
const $1b581ea1c80d4d76$var$ROVO_PARENT_ID_QUERY_PARAM_KEY = 'nativeEmbedParentId';
function $1b581ea1c80d4d76$export$d5ca420e0d8fc785(bridgeParams) {
    const { embedClientId: embedClientId, hostClientId: hostClientId } = bridgeParams;
    return {
        clientId: embedClientId,
        getQueryParams: ()=>({
                [$1b581ea1c80d4d76$var$ROVO_CHILD_ID_QUERY_PARAM_KEY]: embedClientId,
                [$1b581ea1c80d4d76$var$ROVO_PARENT_ID_QUERY_PARAM_KEY]: hostClientId
            }),
        getIframeDataAttributes: ()=>({
                [$1b581ea1c80d4d76$var$ROVO_RECEIVER_ID_DATA_ATTR]: embedClientId
            })
    };
}
function $1b581ea1c80d4d76$export$a5e60906cc8da6df(params) {
    const id = params.get($1b581ea1c80d4d76$var$ROVO_CHILD_ID_QUERY_PARAM_KEY);
    const parentId = params.get($1b581ea1c80d4d76$var$ROVO_PARENT_ID_QUERY_PARAM_KEY);
    if (!id || id.length === 0 || !parentId || parentId.length === 0) return undefined;
    return {
        childClientId: id,
        parentClientId: parentId
    };
}
module.exports["createNativeEmbedClientIframeIntegrator"] = $1b581ea1c80d4d76$export$d5ca420e0d8fc785;
module.exports["maybeParseNativeEmbedParams"] = $1b581ea1c80d4d76$export$a5e60906cc8da6df;

});

parcelRegister("7mpOv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");

const $7ae32555811cd45f$export$cc5edac91cdebf9b = (_props = {})=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    return {
        isAIEnabledForContent: isAdminHubAIEnabled,
        isRovoEnabledForContent: isRovoLLMEnabled
    };
};
function $7ae32555811cd45f$export$fb975e2d7306f54a(WrappedComponent) {
    return function EnhancedComponent(props) {
        const [contentId] = (0, $ep3mz.usePageContentId)();
        const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = $7ae32555811cd45f$export$cc5edac91cdebf9b({
            contentId: contentId ?? ''
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
            ...props,
            isAIEnabledForContent: isAIEnabledForContent,
            isRovoEnabledForContent: isRovoEnabledForContent
        });
    };
}
module.exports["useIsAIEnabledForContent"] = $7ae32555811cd45f$export$cc5edac91cdebf9b;
module.exports["withIsAIEnabledForContent"] = $7ae32555811cd45f$export$fb975e2d7306f54a;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $bDgLe.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("6AroL", function(module, exports) {
function $4cbb5ba451601f11$var$e(e) {
    this.message = e;
}
$4cbb5ba451601f11$var$e.prototype = new Error, $4cbb5ba451601f11$var$e.prototype.name = "InvalidCharacterError";
var $4cbb5ba451601f11$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $4cbb5ba451601f11$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $4cbb5ba451601f11$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($4cbb5ba451601f11$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $4cbb5ba451601f11$var$r(t);
    }
}
function $4cbb5ba451601f11$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $4cbb5ba451601f11$var$o(e, r) {
    if ("string" != typeof e) throw new $4cbb5ba451601f11$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($4cbb5ba451601f11$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $4cbb5ba451601f11$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$4cbb5ba451601f11$export$b9721ef022f71a68.prototype = new Error, $4cbb5ba451601f11$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $4cbb5ba451601f11$export$2e2bcd8739ae039 = $4cbb5ba451601f11$var$o;
 //# sourceMappingURL=jwt-decode.esm.js.map
module.exports["default"] = $4cbb5ba451601f11$export$2e2bcd8739ae039;

});

parcelRegister("4fqm1", function(module, exports) {
const $317d0183692131b1$var$peq = new Uint32Array(0x10000);
const $317d0183692131b1$var$myers_32 = (a, b)=>{
    const n = a.length;
    const m = b.length;
    const lst = 1 << n - 1;
    let pv = -1;
    let mv = 0;
    let sc = n;
    let i = n;
    while(i--)$317d0183692131b1$var$peq[a.charCodeAt(i)] |= 1 << i;
    for(i = 0; i < m; i++){
        let eq = $317d0183692131b1$var$peq[b.charCodeAt(i)];
        const xv = eq | mv;
        eq |= (eq & pv) + pv ^ pv;
        mv |= ~(eq | pv);
        pv &= eq;
        if (mv & lst) sc++;
        if (pv & lst) sc--;
        mv = mv << 1 | 1;
        pv = pv << 1 | ~(xv | mv);
        mv &= xv;
    }
    i = n;
    while(i--)$317d0183692131b1$var$peq[a.charCodeAt(i)] = 0;
    return sc;
};
const $317d0183692131b1$var$myers_x = (b, a)=>{
    const n = a.length;
    const m = b.length;
    const mhc = [];
    const phc = [];
    const hsize = Math.ceil(n / 32);
    const vsize = Math.ceil(m / 32);
    for(let i = 0; i < hsize; i++){
        phc[i] = -1;
        mhc[i] = 0;
    }
    let j = 0;
    for(; j < vsize - 1; j++){
        let mv = 0;
        let pv = -1;
        const start = j * 32;
        const vlen = Math.min(32, m) + start;
        for(let k = start; k < vlen; k++)$317d0183692131b1$var$peq[b.charCodeAt(k)] |= 1 << k;
        for(let i = 0; i < n; i++){
            const eq = $317d0183692131b1$var$peq[a.charCodeAt(i)];
            const pb = phc[i / 32 | 0] >>> i & 1;
            const mb = mhc[i / 32 | 0] >>> i & 1;
            const xv = eq | mv;
            const xh = ((eq | mb) & pv) + pv ^ pv | eq | mb;
            let ph = mv | ~(xh | pv);
            let mh = pv & xh;
            if (ph >>> 31 ^ pb) phc[i / 32 | 0] ^= 1 << i;
            if (mh >>> 31 ^ mb) mhc[i / 32 | 0] ^= 1 << i;
            ph = ph << 1 | pb;
            mh = mh << 1 | mb;
            pv = mh | ~(xv | ph);
            mv = ph & xv;
        }
        for(let k = start; k < vlen; k++)$317d0183692131b1$var$peq[b.charCodeAt(k)] = 0;
    }
    let mv = 0;
    let pv = -1;
    const start = j * 32;
    const vlen = Math.min(32, m - start) + start;
    for(let k = start; k < vlen; k++)$317d0183692131b1$var$peq[b.charCodeAt(k)] |= 1 << k;
    let score = m;
    for(let i = 0; i < n; i++){
        const eq = $317d0183692131b1$var$peq[a.charCodeAt(i)];
        const pb = phc[i / 32 | 0] >>> i & 1;
        const mb = mhc[i / 32 | 0] >>> i & 1;
        const xv = eq | mv;
        const xh = ((eq | mb) & pv) + pv ^ pv | eq | mb;
        let ph = mv | ~(xh | pv);
        let mh = pv & xh;
        score += ph >>> m - 1 & 1;
        score -= mh >>> m - 1 & 1;
        if (ph >>> 31 ^ pb) phc[i / 32 | 0] ^= 1 << i;
        if (mh >>> 31 ^ mb) mhc[i / 32 | 0] ^= 1 << i;
        ph = ph << 1 | pb;
        mh = mh << 1 | mb;
        pv = mh | ~(xv | ph);
        mv = ph & xv;
    }
    for(let k = start; k < vlen; k++)$317d0183692131b1$var$peq[b.charCodeAt(k)] = 0;
    return score;
};
const $317d0183692131b1$export$9f17032d917177de = (a, b)=>{
    if (a.length < b.length) {
        const tmp = b;
        b = a;
        a = tmp;
    }
    if (b.length === 0) return a.length;
    if (a.length <= 32) return $317d0183692131b1$var$myers_32(a, b);
    return $317d0183692131b1$var$myers_x(a, b);
};
const $317d0183692131b1$export$ff7f7c97cdce86e = (str, arr)=>{
    let min_distance = Infinity;
    let min_index = 0;
    for(let i = 0; i < arr.length; i++){
        const dist = $317d0183692131b1$export$9f17032d917177de(str, arr[i]);
        if (dist < min_distance) {
            min_distance = dist;
            min_index = i;
        }
    }
    return arr[min_index];
};
module.exports["distance"] = $317d0183692131b1$export$9f17032d917177de;
module.exports["closest"] = $317d0183692131b1$export$ff7f7c97cdce86e;

});

parcelRegister("jln20", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lRhY3 = parcelRequire("lRhY3");


var $87whh = parcelRequire("87whh");


var $aWwYt = parcelRequire("aWwYt");

function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = ()=>{
    return (0, $cozmU.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
};
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [sidebars, setSidebars] = (0, $cozmU.useState)(t1);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $cozmU.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $lRhY3.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $87whh.useIsPreviewPanelOpen)();
    let t2;
    if ($[1] !== hideObjectSidebar || $[2] !== hidePreviewPanel || $[3] !== isPreviewPanelOpen || $[4] !== sidebars || $[5] !== triggerButtonRef) {
        t2 = $8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        });
        $[1] = hideObjectSidebar;
        $[2] = hidePreviewPanel;
        $[3] = isPreviewPanelOpen;
        $[4] = sidebars;
        $[5] = triggerButtonRef;
        $[6] = t2;
    } else t2 = $[6];
    const contextValue = t2;
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const handleCloseGlobalSidebar = ()=>{
                setSidebars($8facebd0ecb5e0ee$var$_temp);
            };
            window.addEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            return ()=>{
                window.removeEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            };
        };
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[9] !== children || $[10] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
            value: contextValue
        }, children);
        $[9] = children;
        $[10] = contextValue;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
function $8facebd0ecb5e0ee$var$_temp(prev) {
    return prev.length === 0 ? prev : [];
}
module.exports["useRightSidebarContext"] = $8facebd0ecb5e0ee$export$8c38c254c6602904;
module.exports["RightSidebarContextProvider"] = $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f;

});

parcelRegister("87whh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $3Ap09 = parcelRequire("3Ap09");

const $5fad2268a70a3d3b$export$c68e55e6e77f3d5d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (panelId)=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
} : (panelId)=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
module.exports["useIsPreviewPanelOpen"] = $5fad2268a70a3d3b$export$c68e55e6e77f3d5d;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("9XB2W", function(module, exports) {
class $8fc43f5e489bb303$var$EventHub {
    /**
   * Subscribes to a specific Editor AI event, registering a callback function that will be invoked whenever the event is published.
   *
   * @param {object} params - The subscription parameters.
   * @param {T} params.event - The name of the event to subscribe to.
   * @param {(data: EventDataMap[T]) => void} params.callback - The callback function to invoke when the event is published.
   * It receives the event data as its parameter.
   * @returns {object} An object containing the `unsubscribe` method to remove the subscription when it's no longer needed.
   *
   * @example
   * // Subscribing to an event
   * const subscription = eventHub.subscribe({
   *   event: 'start prompt',
   *   callback: (data) => {
   *     console.log('Received start prompt event:', data);
   *   },
   * });
   *
   * // Later, to unsubscribe
   * subscription.unsubscribe();
   */ subscribe({ event: event, callback: callback }) {
        const callbacks = this.subscribers.get(event) || [];
        this.subscribers.set(event, [
            ...callbacks,
            callback
        ]);
        return {
            unsubscribe: ()=>{
                const callbacks = this.subscribers.get(event)?.filter((sub)=>sub !== callback) || [];
                if (callbacks.length > 0) this.subscribers.set(event, callbacks);
                else this.subscribers.delete(event);
            }
        };
    }
    /**
   * Publishes an Editor AI event to a target editor. (This will usually be an event like 'start prompt').
   *
   * @param {object} params - The event parameters.
   * @param {T} params.event - The name of the event to publish.
   * @param {ToEditorEventDataMap[T]} params.data - The data associated with the event, specific to the event type.
   * @returns {void}
   *
   * @example
   * // Publishing an event to the editor
   * eventHub.publishToEditor({
   *   event: 'start prompt',
   *   data: {
   *     prompt: 'issue reformatter',
   *     targetEditorId,
   *     analyticSourceId: 'jiraIssueReformatterExternalButton',
   *   },
   * });
   */ publishToEditor({ event: event, data: data }) {
        const callbacks = this.subscribers.get(event) || [];
        callbacks.forEach((callback)=>{
            callback(data);
        });
    }
    /**
   * Publishes an event originating from the editor, invoking all registered subscribers for that event.
   *
   * @param {object} params - The event parameters.
   * @param {T} params.event - The name of the event to publish.
   * @param {FromEditorEventDataMap[T]} params.data - The data associated with the event, specific to the event type.
   * @returns {void}
   *
   * @example
   * // Publishing an event from the editor
   * eventHub.publishFromEditor({
   *   event: 'replace title in confluence',
   *   data: {
   *     analyticSourceId: 'confluenceTitleToolbar',
   *     sourceEditorId,
   *     title: textContent,
   *   },
   * });
   */ publishFromEditor({ event: event, data: data }) {
        const callbacks = this.subscribers.get(event) || [];
        callbacks.forEach((callback)=>{
            callback(data);
        });
    }
    constructor(){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.subscribers = new Map();
        this.subscribers = new Map();
    }
}
const $8fc43f5e489bb303$export$e17a52e5da72c4cb = new $8fc43f5e489bb303$var$EventHub();
module.exports["eventHub"] = $8fc43f5e489bb303$export$e17a52e5da72c4cb;

});

parcelRegister("kqIWy", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $4ZxLt = parcelRequire("4ZxLt");


var $jtuBN = parcelRequire("jtuBN");

const $bbbfebced5e36727$export$7081570f83890156 = (spaceKey, t0)=>{
    const $ = (0, $bDgLe.c)(12);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { includeSpaceTypeSettings: t2 } = t1;
    const includeSpaceTypeSettings = t2 === undefined ? false : t2;
    let t3;
    if ($[2] !== includeSpaceTypeSettings || $[3] !== spaceKey) {
        t3 = {
            variables: {
                spaceKey: spaceKey,
                includeSpaceTypeSettings: includeSpaceTypeSettings
            }
        };
        $[2] = includeSpaceTypeSettings;
        $[3] = spaceKey;
        $[4] = t3;
    } else t3 = $[4];
    const options = t3;
    const { loading: loading, data: data, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $4ZxLt.default), {
        ...options,
        __callerPackage__: "space-utils"
    });
    let t4;
    if ($[5] !== data || $[6] !== includeSpaceTypeSettings) {
        t4 = data ? {
            spaceId: data.space?.id,
            type: data.space?.type,
            name: data.space?.name,
            dataClassificationTags: data.space?.dataClassificationTags,
            alias: data.space?.alias,
            homepage: data.space?.homepage,
            iconPath: data.space?.icon?.path,
            typeSettings: includeSpaceTypeSettings && data.space?.spaceTypeSettings ? {
                enabledContentTypes: {
                    ...data.space.spaceTypeSettings.enabledContentTypes
                }
            } : undefined
        } : undefined;
        $[5] = data;
        $[6] = includeSpaceTypeSettings;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== error || $[9] !== loading || $[10] !== t4) {
        t5 = {
            loading: loading,
            data: t4,
            error: error
        };
        $[8] = error;
        $[9] = loading;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
module.exports["useSpaceDetail"] = $bbbfebced5e36727$export$7081570f83890156;

});

parcelRegister("9ivsj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $dX6FL = parcelRequire("dX6FL");


var $jlWUB = parcelRequire("jlWUB");

const $68c74ae30c005fed$export$c537e63161742ce3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $cozmU.useState)((0, $jlWUB.isReducedMotion));
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            if (!(0, $dX6FL.isMatchMediaAvailable)()) return;
            const mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
            const onChange = (event)=>setPrefersReducedMotion(event.matches);
            return (0, $cbY7C.bind)(mediaQueryList, {
                type: "change",
                listener: onChange
            });
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return prefersReducedMotion;
} : ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $cozmU.useState)((0, $jlWUB.isReducedMotion));
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $dX6FL.isMatchMediaAvailable)()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, $cbY7C.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
module.exports["useIsReducedMotion"] = $68c74ae30c005fed$export$c537e63161742ce3;

});

parcelRegister("lpJCW", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $8jQuQ = parcelRequire("8jQuQ");

var $9ivsj = parcelRequire("9ivsj");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");

const $f5e4f95acdf8fc4d$var$GradientPropertyContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_39xV02N91d _1mT5xdRAKS _0NUa3rOLYo",
            __cmplp.className
        ])
    });
});
const $f5e4f95acdf8fc4d$var$outerContainerStyles = (0, $buxP3.xcss)({
    overflow: 'hidden',
    position: 'relative',
    background: `conic-gradient(
    from var(--gradient-angle, 45deg),
    #0065FF 10%,
    #0469FF 30%,
    #BF63F3 50%,
    #FFA900 70%,
    #0065FF 90%
  )`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ...(0, $8jQuQ.reduceMotionAsPerUserPreference),
    maxHeight: 'inherit'
});
const $f5e4f95acdf8fc4d$var$animationStyles = (0, $buxP3.xcss)({
    animation: 'rotationAnimation linear 2s infinite'
});
const $f5e4f95acdf8fc4d$var$baseGlowStyles = (0, $buxP3.xcss)({
    position: 'absolute',
    filter: 'blur(25px)',
    opacity: '0.5',
    height: '100%',
    width: '100%'
});
const $f5e4f95acdf8fc4d$var$defaultBorderRadiusStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.large'
});
const $f5e4f95acdf8fc4d$var$modalBorderRadiusStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.small'
});
const $f5e4f95acdf8fc4d$var$innerContainerStyles = (0, $buxP3.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    maxHeight: 'inherit',
    display: 'flex',
    flexDirection: 'column',
    backgroundClip: 'content-box'
});
const $f5e4f95acdf8fc4d$export$6ed1e39f4dbe0bbf = ({ loading: loading = false, children: children, useModalStyles: useModalStyles, hideGlow: hideGlow, customInnerContainerStyles: customInnerContainerStyles, customGlowStyles: customGlowStyles, ...props })=>{
    const isReducedMotion = (0, $9ivsj.useIsReducedMotion)();
    const shouldRotate = loading && !isReducedMotion;
    const containerStyles = shouldRotate ? [
        $f5e4f95acdf8fc4d$var$outerContainerStyles,
        $f5e4f95acdf8fc4d$var$animationStyles
    ] : [
        $f5e4f95acdf8fc4d$var$outerContainerStyles
    ];
    const glowStyles = customGlowStyles ? [
        $f5e4f95acdf8fc4d$var$baseGlowStyles,
        customGlowStyles
    ] : [
        $f5e4f95acdf8fc4d$var$baseGlowStyles
    ];
    const borderRadiusStyles = useModalStyles ? $f5e4f95acdf8fc4d$var$modalBorderRadiusStyles : $f5e4f95acdf8fc4d$var$defaultBorderRadiusStyles;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5e4f95acdf8fc4d$var$GradientPropertyContainer, {
        "data-testid": "ai-border-container",
        ...props
    }, shouldRotate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            ...containerStyles,
            borderRadiusStyles,
            ...hideGlow ? [] : glowStyles
        ],
        testId: "loading-glow"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            ...containerStyles,
            borderRadiusStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        padding: "space.025",
        xcss: [
            $f5e4f95acdf8fc4d$var$innerContainerStyles,
            borderRadiusStyles,
            customInnerContainerStyles
        ]
    }, children)));
};
module.exports["AIBorder"] = $f5e4f95acdf8fc4d$export$6ed1e39f4dbe0bbf;

});

parcelRegister("8jQuQ", function(module, exports) {
/**
 * Use for any CSS based motion (animation or transition).
 * Always put at the end of your declaration for correct use of the cascade.
 * Reduced motion preference is generally set through OS preferences/settings.
 *
 * @deprecated This is not fully compatible with Compiled CSS and will be removed in the future.
 * You should hardcode the `prefers-reduced-motion` media query in your file instead.
 */ const $cfd6e6a22c7a51c3$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
module.exports["reduceMotionAsPerUserPreference"] = $cfd6e6a22c7a51c3$export$f0f789643ba5a83c;

});

parcelRegister("bMPhU", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $7SV4J = parcelRequire("7SV4J");


var $ep3mz = parcelRequire("ep3mz");


var $jMyy4 = parcelRequire("jMyy4");

const $337a96ad81fe0f87$export$a1e0cd72fc64ef6 = (spaceKey)=>{
    const $ = (0, $bDgLe.c)(5);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    spaceKey = spaceKey ?? pageContextSpaceKey;
    let t0;
    if ($[0] !== spaceKey) {
        t0 = {
            spaceKey: spaceKey
        };
        $[0] = spaceKey;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = !spaceKey;
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
        t2 = {
            variables: t0,
            skip: t1
        };
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $7SV4J.default), {
        ...t2,
        __callerPackage__: "space-utils"
    });
    return data?.space?.homepage?.id || undefined;
};
module.exports["useSpaceHomepageId"] = $337a96ad81fe0f87$export$a1e0cd72fc64ef6;

});

parcelRegister("7SV4J", function(module, exports) {
/**
 * @generated SignedSource<<9c89aa0352f7d1dca5a5a1271100cc40>>
 * @relayHash be53943df43514309a4d7c908c1c0fa2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5
const $6972c51ac50ce9bf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                },
                v1 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "be53943df43514309a4d7c908c1c0fa2",
            "id": "7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5",
            "metadata": {},
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "operationKind": "query",
            "text": "query useSpaceHomepageIdSpaceHomepageIdQuery($spaceKey:String){space(key:$spaceKey){homepage{id},id}}"
        }
    };
}();
$6972c51ac50ce9bf$var$node.hash = "008609f21691e19f9c101d43e2e78e81";
var $6972c51ac50ce9bf$export$2e2bcd8739ae039 = $6972c51ac50ce9bf$var$node;
module.exports["default"] = $6972c51ac50ce9bf$export$2e2bcd8739ae039;

});

parcelRegister("jkVM2", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $5f9bfd31a6a2d08f$export$2791e79b1a186ba4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CFAQV",
    name: "EditorContentState",
    loader: async ()=>(await (parcelRequire("l1zOe"))).EditorContentState
});
module.exports["EditorContentState"] = $5f9bfd31a6a2d08f$export$2791e79b1a186ba4;

});

parcelRegister("l1zOe", function(module, exports) {

let $f4e577e83c6813d6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f4e577e83c6813d6$var$load("dgerE"),
    $f4e577e83c6813d6$var$load("7wlV6"),
    $f4e577e83c6813d6$var$load("el56J"),
    $f4e577e83c6813d6$var$load("hhss7"),
    $f4e577e83c6813d6$var$load("9cpj1"),
    $f4e577e83c6813d6$var$load("ljCe8")
]).then(()=>parcelRequire('iDxDj'));

});

parcelRegister("hycHC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4fqm1 = parcelRequire("4fqm1");


var $iDrrr = parcelRequire("iDrrr");


var $9XB2W = parcelRequire("9XB2W");

const $19f67db039a615a7$var$ACTIONED_EVENT_DELAY = 10000;
const $19f67db039a615a7$var$AI_GENERATED_TITLE_CHANGE_PERCENTAGE_THRESHOLD = 50;
const $19f67db039a615a7$export$ff041132f32feaf3 = ({ enabled: enabled, title: title, handleNewTitle: handleNewTitle, canFireUnifiedAIAnalyticsEvent: canFireUnifiedAIAnalyticsEvent })=>{
    const canFireActionedEvent = canFireUnifiedAIAnalyticsEvent && (0, $iDrrr.fg)('platform_editor_ai_suggest_title_actioned_event');
    const currentTitleRef = (0, $cozmU.useRef)(title);
    (0, $cozmU.useEffect)(()=>{
        currentTitleRef.current = title;
    }, [
        title
    ]);
    const currentAnalyticsEventDataRef = (0, $cozmU.useRef)(null);
    const fireAnalyticEvent = (0, $cozmU.useCallback)((currentTitle)=>{
        if (!canFireActionedEvent) return;
        if (currentAnalyticsEventDataRef.current && currentAnalyticsEventDataRef.current.isFinal) {
            const titleChangePercentage = $19f67db039a615a7$export$1c6b9baa0047190(currentAnalyticsEventDataRef.current.aiGeneratingTitle, currentTitle);
            if (titleChangePercentage < $19f67db039a615a7$var$AI_GENERATED_TITLE_CHANGE_PERCENTAGE_THRESHOLD) currentAnalyticsEventDataRef.current.fireUnifiedAnalyticsEvent('actioned');
            else currentAnalyticsEventDataRef.current.fireUnifiedAnalyticsEvent('discarded');
            // currentAnalyticsEventDataRef.current to null to avoid duplicate events.
            currentAnalyticsEventDataRef.current = null;
        }
    }, [
        canFireActionedEvent
    ]);
    const currentTimerIdRef = (0, $cozmU.useRef)(undefined);
    const createTimerToFireActionedEvent = (0, $cozmU.useCallback)(()=>{
        if (currentTimerIdRef.current) window.clearTimeout(currentTimerIdRef.current);
        currentTimerIdRef.current = window.setTimeout(()=>{
            fireAnalyticEvent(currentTitleRef.current);
        }, $19f67db039a615a7$var$ACTIONED_EVENT_DELAY);
    }, [
        fireAnalyticEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!enabled) return;
        const { unsubscribe: unsubscribe } = (0, $9XB2W.eventHub).subscribe({
            event: 'replace title in confluence',
            callback: (data)=>{
                const aiGeneratingTitle = data.title;
                if (canFireActionedEvent && data.isFinal !== undefined && data.fireUnifiedAnalyticsEvent) {
                    /**
           * This callback is called multiple times, for single replace title event
           * 	because of streaming api.
           *
           * So if only currentTimerIdRef.current is not undefined,
           * 	that means user has clicked on suggest title button again
           * 	within ACTIONED_EVENT_DELAY.
           *
           * That means user didn't like previously generated title,
           * 	so we will pass empty string, so that dismissed event is fired.
           */ if (currentTimerIdRef.current) {
                        fireAnalyticEvent('');
                        window.clearTimeout(currentTimerIdRef.current);
                        currentTimerIdRef.current = undefined;
                    }
                    currentAnalyticsEventDataRef.current = {
                        aiGeneratingTitle: aiGeneratingTitle,
                        isFinal: data.isFinal,
                        fireUnifiedAnalyticsEvent: data.fireUnifiedAnalyticsEvent
                    };
                    // When final stream arrives, we will set timer to fire actioned/dismissed event.
                    if (data.isFinal) createTimerToFireActionedEvent();
                }
                handleNewTitle(aiGeneratingTitle);
            }
        });
        return ()=>{
            unsubscribe();
            window.clearTimeout(currentTimerIdRef.current);
        };
    }, [
        createTimerToFireActionedEvent,
        enabled,
        fireAnalyticEvent,
        handleNewTitle,
        canFireActionedEvent
    ]);
};
const $19f67db039a615a7$export$1c6b9baa0047190 = (aiGeneratedTitle, currentTitle)=>{
    if (aiGeneratedTitle.length === 0) return 0;
    const distance = (0, $4fqm1.distance)(aiGeneratedTitle, currentTitle);
    return distance / aiGeneratedTitle.length * 100;
};
module.exports["useEditorAIReplacingTitle"] = $19f67db039a615a7$export$ff041132f32feaf3;

});

parcelRegister("2HGN8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $9wGTI = parcelRequire("9wGTI");


var $hYoU4 = parcelRequire("hYoU4");


var $8VcPj = parcelRequire("8VcPj");


var $1d2ww = parcelRequire("1d2ww");

const $652df36b21c46ede$var$ContentAppearanceContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    contentAppearance: {
        appearance: (0, $1d2ww.ContentAppearanceType).DEFAULT,
        version: 0
    },
    setContentAppearance: ()=>{},
    contentAppearanceLoading: false
});
const $652df36b21c46ede$export$53c04435be7a0acf = ({ contentId: contentId, children: children })=>{
    const [contentAppearanceOverride, setContentAppearanceOverride] = (0, $cozmU.useState)();
    // Clear the override state when navigating to a different page
    (0, $cozmU.useEffect)(()=>{
        if ((0, $9wGTI.fg)('platform_editor_appearance_override_reset')) setContentAppearanceOverride(undefined);
    }, [
        contentId
    ]);
    const [{ collabEditProvider: collabEditProvider }] = (0, $hYoU4.useNativeCollabState)();
    // Subscribe to metadata:changed events to update the content appearance for collaborators
    (0, $cozmU.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleMetadataChanged = (metadata)=>{
            const editorWidth = metadata?.editorWidth;
            const widthValue = editorWidth?.value;
            const version = editorWidth?.version;
            if (widthValue && version !== undefined) setContentAppearanceOverride((currentAppearance)=>{
                if (!currentAppearance || version > currentAppearance.version) return {
                    appearance: widthValue,
                    version: version
                };
                else return currentAppearance;
            });
        };
        collabEditProvider.on('metadata:changed', handleMetadataChanged);
        return ()=>{
            collabEditProvider.off('metadata:changed', handleMetadataChanged);
        };
    }, [
        collabEditProvider
    ]);
    /*
  	Previous check was:
  	const draftAppearanceQuery = getContentAppearanceQuery(ContentAppearancePropertyKey.DRAFT);
  	which always returns contentAppearanceQuery
  */ const { data: initialContentAppearanceData, loading: initialContentAppearanceLoading } = (0, $jMyy4.useQueryInterop)((0, $8VcPj.contentAppearanceQuery), {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ]
        },
        __callerPackage__: "content-appearance"
    });
    const context = (0, $cozmU.useMemo)(()=>{
        const initialContentAppearance = (0, $8VcPj.getContentAppearanceFromQueryData)(initialContentAppearanceData, (0, $1d2ww.ContentAppearancePropertyKey).DRAFT);
        // Under certain circumstances due to a previous bug with the content appearance during legacy editor autoconvert, an incorrect value may have been sent to collab service.
        // In this circumstance favour the initial content appearance value.
        const shouldUseInitial = contentAppearanceOverride && initialContentAppearance && contentAppearanceOverride.version === initialContentAppearance.version && contentAppearanceOverride.appearance !== initialContentAppearance.appearance;
        return {
            contentAppearance: shouldUseInitial ? initialContentAppearance : contentAppearanceOverride || initialContentAppearance,
            setContentAppearance: setContentAppearanceOverride,
            contentAppearanceLoading: initialContentAppearanceLoading
        };
    }, [
        initialContentAppearanceData,
        initialContentAppearanceLoading,
        contentAppearanceOverride
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($652df36b21c46ede$var$ContentAppearanceContext.Provider, {
        value: context
    }, children);
};
const $652df36b21c46ede$export$c3c73be39a08fc97 = ({ children: children })=>{
    const context = $652df36b21c46ede$export$4cedbdf2fdf3340d();
    return children(context);
};
const $652df36b21c46ede$export$4cedbdf2fdf3340d = ()=>{
    return (0, $cozmU.useContext)($652df36b21c46ede$var$ContentAppearanceContext);
};
module.exports["ContentAppearanceContextProvider"] = $652df36b21c46ede$export$53c04435be7a0acf;
module.exports["ContentAppearanceContextConsumer"] = $652df36b21c46ede$export$c3c73be39a08fc97;
module.exports["useContentAppearance"] = $652df36b21c46ede$export$4cedbdf2fdf3340d;

});

parcelRegister("38qvz", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $kqIWy = parcelRequire("kqIWy");

const $f0e4954369e4b2a4$export$6c92cd4e39d5997c = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { spaceKey: spaceKey } = t0;
    const { data: spaceData } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const t1 = spaceData?.type;
    const t2 = spaceData?.type === "knowledge_base";
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = {
            spaceType: t1,
            isKnowledgeBaseSpace: t2
        };
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    return t3;
} : ({ spaceKey: spaceKey })=>{
    const { data: spaceData } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    return {
        spaceType: spaceData?.type,
        isKnowledgeBaseSpace: spaceData?.type === 'knowledge_base'
    };
};
module.exports["useSpaceType"] = $f0e4954369e4b2a4$export$6c92cd4e39d5997c;

});

parcelRegister("bUiJC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $22ad974994dfbc0b$var$applyDefaultWidth = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const editorScrollParent = document.querySelector('.fabric-editor-popup-scroll-parent');
    if (editorScrollParent) return editorScrollParent.clientWidth || 0;
    return 0;
};
const $22ad974994dfbc0b$export$5308d1e625847f03 = ({ isFixedWidth: isFixedWidth = false })=>{
    const defaultWidth = $22ad974994dfbc0b$var$applyDefaultWidth();
    const [width, setWidth] = (0, $cozmU.useState)(defaultWidth);
    const observerRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        const editorScrollParent = document.querySelector('.fabric-editor-popup-scroll-parent');
        if (editorScrollParent && !isFixedWidth) {
            observerRef.current = new ResizeObserver((entries)=>{
                setWidth(Math.floor(entries[0]?.target.clientWidth));
            });
            observerRef.current.observe(editorScrollParent);
            return ()=>observerRef?.current?.disconnect();
        }
    }, [
        observerRef,
        isFixedWidth
    ]);
    return {
        width: width,
        observerRef: observerRef.current
    };
};
module.exports["useEditorWidthObserver"] = $22ad974994dfbc0b$export$5308d1e625847f03;

});

parcelRegister("5RPbY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $9ee3ba3f5fa2cebc$export$b00e22884b6dd9a = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1hM5R",
    name: "EditorAppearanceButtonNext",
    loader: async ()=>{
        const { EditorAppearanceButtonNext: EditorAppearanceButtonNext } = await (parcelRequire("fgMWo"));
        return EditorAppearanceButtonNext;
    }
});
module.exports["EditorAppearanceButtonNext"] = $9ee3ba3f5fa2cebc$export$b00e22884b6dd9a;

});

parcelRegister("fgMWo", function(module, exports) {

let $b1de50428cab9222$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b1de50428cab9222$var$load("6wr18"),
    $b1de50428cab9222$var$load("dlm6q"),
    $b1de50428cab9222$var$load("ffEVr"),
    $b1de50428cab9222$var$load("7EorR"),
    $b1de50428cab9222$var$load("ea3NB"),
    $b1de50428cab9222$var$load("7GtpA")
]).then(()=>parcelRequire('Vjn6T'));

});

parcelRegister("jPcvk", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $7e7400ce50234362$export$a8e3305d336ef5aa = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "K14-x",
    name: "EditorContentModeButton",
    loader: async ()=>{
        const { EditorContentModeButton: EditorContentModeButton } = await (parcelRequire("l0fWy"));
        return EditorContentModeButton;
    }
});
module.exports["EditorContentModeButton"] = $7e7400ce50234362$export$a8e3305d336ef5aa;

});

parcelRegister("l0fWy", function(module, exports) {

let $f4a5f718c8866794$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f4a5f718c8866794$var$load("953Uz"),
    $f4a5f718c8866794$var$load("cC68k")
]).then(()=>parcelRequire('iI06X'));

});

parcelRegister("5e34M", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0c67d43e155b2cd3$export$8ce5c583c1fa5a96 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rGXr0",
    name: "EmojiTitleButtonLoader",
    loader: async ()=>(await (parcelRequire("lN1mC"))).EmojiTitleButton
});
module.exports["EmojiTitleButtonLoader"] = $0c67d43e155b2cd3$export$8ce5c583c1fa5a96;

});

parcelRegister("lN1mC", function(module, exports) {

let $fdcf3b6c78e9b0af$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fdcf3b6c78e9b0af$var$load("6wr18"),
    $fdcf3b6c78e9b0af$var$load("dlm6q"),
    $fdcf3b6c78e9b0af$var$load("el56J"),
    $fdcf3b6c78e9b0af$var$load("ffEVr"),
    $fdcf3b6c78e9b0af$var$load("4izLy"),
    $fdcf3b6c78e9b0af$var$load("daX4F"),
    $fdcf3b6c78e9b0af$var$load("953Uz"),
    $fdcf3b6c78e9b0af$var$load("9Zd2C")
]).then(()=>parcelRequire('2FMo5'));

});

parcelRegister("jPACe", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4ff4f509ac781670$export$e8a47c72fec9e984 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "SUzCl",
    name: "EditorPageCoverPictureEntry",
    loader: async ()=>{
        const { EditorPageCoverPictureEntry: EditorPageCoverPictureEntry } = await (parcelRequire("9Cobe"));
        return EditorPageCoverPictureEntry;
    }
});
module.exports["EditorPageCoverPictureEntry"] = $4ff4f509ac781670$export$e8a47c72fec9e984;

});

parcelRegister("9Cobe", function(module, exports) {

let $700a6b52dceb90a7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $700a6b52dceb90a7$var$load("dPFEi"),
    $700a6b52dceb90a7$var$load("dVM1q")
]).then(()=>parcelRequire('5tKh7'));

});


//# sourceMappingURL=TitleAreaContentComponents.33019992.js.map
